var Jn=Object.defineProperty;var Zn=Object.prototype.hasOwnProperty;var co=Object.getOwnPropertySymbols,ei=Object.prototype.propertyIsEnumerable;var uo=(t,e,o)=>e in t?Jn(t,e,{enumerable:!0,configurable:!0,writable:!0,value:o}):t[e]=o,ue=(t,e)=>{for(var o in e||(e={}))Zn.call(e,o)&&uo(t,o,e[o]);if(co)for(var o of co(e))ei.call(e,o)&&uo(t,o,e[o]);return t};var ho=(t,e,o)=>new Promise((n,i)=>{var r=s=>{try{a(o.next(s))}catch(b){i(b)}},l=s=>{try{a(o.throw(s))}catch(b){i(b)}},a=s=>s.done?n(s.value):Promise.resolve(s.value).then(r,l);a((o=o.apply(t,e)).next())});document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
/* Number | Value
----------|------------
    800   | black @deprecated
    700   | bold
    600   | semi-bold @deprecated
    500   | medium @deprecated
    400   | normal
    300   | light
    200   | extra-light @deprecated
    100   | ultra-light @deprecated
*/
/*
    @deprecated - font-weight: 800;

    BEFORE:
    font-weight: 800;

    AFTER:
    font-weight: 700;
*/
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 800;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-black.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-black.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-black.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 700;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-bold.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-bold.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-bold.otf") format("opentype");
}
/*
    @deprecated - font-weight: 600;

    BEFORE:
    font-weight: 600;

    AFTER:
    font-weight: 700;
*/
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 600;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-semi-bold.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-semi-bold.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-semi-bold.otf") format("opentype");
}
/*
    @deprecated - font-weight: 500;

    BEFORE:
    font-weight: 500;

    AFTER:
    font-weight: 400;
*/
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 500;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-medium.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-medium.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-medium.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 400;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-regular.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-regular.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-regular.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 300;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-light.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-light.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-light.otf") format("opentype");
}
/*
    @deprecated - font-weight: 200;

    BEFORE:
    font-weight: 200;

    AFTER:
    font-weight: 300;
*/
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 200;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-extra-light.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-extra-light.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-extra-light.otf") format("opentype");
}
/*
    @deprecated - font-weight: 100;

    BEFORE:
    font-weight: 100;

    AFTER:
    font-weight: 300;
*/
@font-face {
  font-family: sofia-pro;
  font-style: normal;
  font-weight: 100;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-ultra-light.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-ultra-light.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-ultra-light.otf") format("opentype");
}
/*
    @deprecated - All @font-face declarations of sofia-pro-* (e.g. sofia-pro-medium and sofia-pro-regular)

    BEFORE:
    font-family: sofia-pro-bold, sans-serif;

    AFTER:
    font-family: sofia-pro, sans-serif;
    font-weight: 700;
*/
@font-face {
  font-family: sofia-pro-black;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-black.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-black.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-black.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-bold;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-bold.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-bold.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-bold.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-semi-bold;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-semi-bold.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-semi-bold.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-semi-bold.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-medium;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-medium.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-medium.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-medium.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-regular;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-regular.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-regular.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-regular.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-light;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-light.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-light.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-light.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-extra-light;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-extra-light.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-extra-light.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-extra-light.otf") format("opentype");
}
@font-face {
  font-family: sofia-pro-ultra-light;
  src: url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-ultra-light.woff2") format("woff2"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-ultra-light.woff") format("woff"), url("https://assets.pxlecdn.com/fonts/sofia-pro/sofia-pro-ultra-light.otf") format("opentype");
}
:root {
  --blox-red: #ff5300;
  --blox-yellow: #f9ac17;
  --blox-green: #2da95f;
  --blox-blue: #009ceb;
  --blox-purple: #8786f8;
  --blox-slate0a: #f8f9fd;
  --blox-slate1: #ebedf3;
  --blox-slate1a: #e0e7ef;
  --blox-slate1c: #d5dbe3;
  --blox-slate1b: #aeb1c0;
  --blox-slate2: #8b95a2;
  --blox-slate3: #667282;
  --blox-slate3a: #505a78;
  --blox-slate4: #4d5866;
  --blox-slate5: #323a45;
  --blox-slate7: #2b2f3e;
  --blox-slate6: #282d39;
  --blox-facebook: #3b5998;
  --blox-instagram: #000;
  --blox-instagram-alt: #c13584;
  --blox-pinterest: #cb2027;
  --blox-tiktok: #222;
  --blox-tumblr: #32506d;
  --blox-twitter: #00aced;
  --blox-youtube: #f00;
  --blox-orange: #ff6d26;
  --blox-lime: #b0cd1f;
  --blox-teal: #1fbba6;
  --blox-aqua: #58d3e5;
  --blox-pink: #f979a5;
  --blox-instagram-reels: #323a45;
  --blox-red--hover: #f04e00;
  --blox-red--active: #e04900;
  --blox-yellow--hover: #f9a607;
  --blox-yellow--active: #e99c06;
  --blox-green--hover: #2a9f59;
  --blox-green--active: #289554;
  --blox-blue--hover: #0093dd;
  --blox-blue--active: #0089cf;
  --blox-purple--hover: #7270f7;
  --blox-purple--active: #5c5bf5;
  --blox-slate0a--hover: #e1e5f6;
  --blox-slate0a--active: #c9d1f0;
  --blox-slate1--hover: #d9dde8;
  --blox-slate1--active: #c7cddd;
  --blox-slate1a--hover: #ced9e6;
  --blox-slate1a--active: #bbcbdc;
  --blox-slate1c--hover: #c5cdd8;
  --blox-slate1c--active: #b5c0ce;
  --blox-slate1b--hover: #a2a5b6;
  --blox-slate1b--active: #9599ad;
  --blox-slate2--hover: #818c9a;
  --blox-slate2--active: #778392;
  --blox-slate3--hover: #606b7a;
  --blox-slate3--active: #5a6472;
  --blox-slate3a--hover: #4b5571;
  --blox-slate3a--active: #464f6a;
  --blox-slate4--hover: #485360;
  --blox-slate4--active: #444d5a;
  --blox-slate5--hover: #2f3741;
  --blox-slate5--active: #2c333d;
  --blox-slate7--hover: #282c3a;
  --blox-slate7--active: #262937;
  --blox-slate6--hover: #262a36;
  --blox-slate6--active: #232832;
  --blox-facebook--hover: #37548f;
  --blox-facebook--active: #344e86;
  --blox-instagram--hover: black;
  --blox-instagram--active: black;
  --blox-instagram-alt--hover: #b5327c;
  --blox-instagram-alt--active: #aa2f74;
  --blox-pinterest--hover: #bf1e25;
  --blox-pinterest--active: #b31c22;
  --blox-tiktok--hover: #202020;
  --blox-tiktok--active: #1e1e1e;
  --blox-tumblr--hover: #2f4b66;
  --blox-tumblr--active: #2c4660;
  --blox-twitter--hover: #00a2df;
  --blox-twitter--active: #0097d1;
  --blox-youtube--hover: #f00000;
  --blox-youtube--active: #e00000;
  --blox-orange--hover: #ff6114;
  --blox-orange--active: #ff5503;
  --blox-lime--hover: #a5c11d;
  --blox-lime--active: #9bb41b;
  --blox-teal--hover: #1db09c;
  --blox-teal--active: #1ba592;
  --blox-aqua--hover: #48cfe2;
  --blox-aqua--active: #37cae0;
  --blox-pink--hover: #f86497;
  --blox-pink--active: #f74f88;
  --blox-instagram-reels--hover: #2f3741;
  --blox-instagram-reels--active: #2c333d;
  --blox-red--light: #fed4bf;
  --blox-yellow--light: #feeabf;
  --blox-green--light: #cae9d7;
  --blox-blue--light: #bfe6fa;
  --blox-purple--light: #e0e0fd;
  --blox-font-family: sofia-pro, sans-serif;
  --blox-font-size: 14px;
  --blox-font-size-sm: 12px;
  --blox-font-size-md: 14px;
  --blox-font-size-lg: 16px;
  --blox-font-size-xl: 24px;
  --blox-font-weight: 400;
  --blox-font-weight-300: 300;
  --blox-font-weight-400: 400;
  --blox-font-weight-700: 700;
  --blox-line-height: 140%;
  --blox-icon-height: 16px;
  --blox-background-input: white;
  --blox-background-input--hover: var(--blox-slate0a);
  --blox-background-input--disabled: var(--blox-slate1);
  --blox-border-input: 1px solid var(--blox-slate1c);
  --blox-border-input--hover: 1px solid var(--blox-slate2);
  --blox-border-input--active: 1px solid var(--blox-slate2--active);
  --blox-border-input--focus: 1px solid var(--blox-blue);
  --blox-border-input-invalid: 1px solid var(--blox-red);
  --blox-border-input-invalid--hover: 1px solid var(--blox-red--hover);
  --blox-border-input-invalid--focus: 1px solid var(--blox-red--active);
  --blox-border-radius: 3px;
  --blox-transition-duration: 0.25s;
  --blox-transition-timing-function: ease;
  --blox-transition-delay: 0s;
}

* {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.blox.font-sm-label,
.blox.font-sm-normal {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-sm);
  font-weight: var(--blox-font-weight-400);
}

.blox.font-sm-emphasized {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-sm);
  font-weight: var(--blox-font-weight-700);
}

.blox.font-sm-data-display {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-sm);
  font-weight: var(--blox-font-weight-300);
}

.blox.font-md-label,
.blox.font-md-normal {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
}

.blox.font-md-button,
.blox.font-md-emphasized,
.blox.font-md-heading,
.blox.font-md-table-header {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
}

.blox.font-md-data-display {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-300);
}

.blox.font-lg-heading {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-lg);
  font-weight: var(--blox-font-weight-400);
}

.blox.font-lg-emphasized {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-lg);
  font-weight: var(--blox-font-weight-700);
}

.blox.font-lg-data-display {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-lg);
  font-weight: var(--blox-font-weight-300);
}

.blox.font-xl-heading {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-xl);
  font-weight: var(--blox-font-weight-400);
}

.blox.font-xl-emphasized {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-xl);
  font-weight: var(--blox-font-weight-700);
}

.blox.font-xl-data-display {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-xl);
  font-weight: var(--blox-font-weight-300);
}

/*
    Used for the hidden form controls inserted in the regularDOM from certain
    'form control' BloxComponents (e.g. BloxSearch, BloxSelect, and BloxSwitch)
*/
.blox.hidden-form-control {
  display: none;
}`));document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
a.blox {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-blue);
  --font-size: 14px;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  text-decoration: none;
}
a.blox:hover:not([role=button]):not(.disabled) {
  color: var(--blox-blue--hover);
  text-decoration: underline;
}
a.blox:active:not([role=button]):not(.disabled) {
  color: var(--blox-blue--active);
  text-decoration: underline;
}
a.blox:focus:not([role=button]):not(.disabled) {
  text-decoration: underline;
}
a.blox:focus {
  border-radius: var(--blox-border-radius);
  outline: 2px solid var(--blox-slate5);
  outline-offset: 0;
}
a.blox.grey {
  color: var(--blox-slate3);
}
a.blox.grey:hover:not([role=button]):not(.disabled) {
  color: var(--blox-slate3--hover);
  text-decoration: underline;
}
a.blox.grey:active:not([role=button]):not(.disabled) {
  color: var(--blox-slate3--active);
  text-decoration: underline;
}
a.blox.grey:focus:not([role=button]):not(.disabled) {
  text-decoration: underline;
}
a.blox.green {
  color: var(--blox-green);
}
a.blox.green:hover:not([role=button]):not(.disabled) {
  color: var(--blox-green--hover);
  text-decoration: underline;
}
a.blox.green:active:not([role=button]):not(.disabled) {
  color: var(--blox-green--active);
  text-decoration: underline;
}
a.blox.green:focus:not([role=button]):not(.disabled) {
  text-decoration: underline;
}
a.blox.red {
  color: var(--blox-red);
}
a.blox.red:hover:not([role=button]):not(.disabled) {
  color: var(--blox-red--hover);
  text-decoration: underline;
}
a.blox.red:active:not([role=button]):not(.disabled) {
  color: var(--blox-red--active);
  text-decoration: underline;
}
a.blox.red:focus:not([role=button]):not(.disabled) {
  text-decoration: underline;
}
a.blox.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
a[role=button].blox,
button.blox,
input[type=button].blox,
input[type=reset].blox,
input[type=submit].blox {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  background-color: var(--blox-blue);
  border: 2px solid var(--blox-blue);
  color: white;
  align-items: center;
  border-radius: var(--blox-border-radius);
  cursor: pointer;
  font-family: var(--blox-font-family);
  gap: 10px;
  height: auto;
  justify-content: center;
  padding: 12px 20px 14px;
  text-transform: none;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
  width: auto;
}
a[role=button].blox:hover:not(:disabled), a[role=button].blox:hover:not(.disabled),
button.blox:hover:not(:disabled),
button.blox:hover:not(.disabled),
input[type=button].blox:hover:not(:disabled),
input[type=button].blox:hover:not(.disabled),
input[type=reset].blox:hover:not(:disabled),
input[type=reset].blox:hover:not(.disabled),
input[type=submit].blox:hover:not(:disabled),
input[type=submit].blox:hover:not(.disabled) {
  background-color: var(--blox-blue--hover);
  border: 2px solid var(--blox-blue--hover);
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
}
a[role=button].blox:active:not(:disabled), a[role=button].blox:active:not(.disabled),
button.blox:active:not(:disabled),
button.blox:active:not(.disabled),
input[type=button].blox:active:not(:disabled),
input[type=button].blox:active:not(.disabled),
input[type=reset].blox:active:not(:disabled),
input[type=reset].blox:active:not(.disabled),
input[type=submit].blox:active:not(:disabled),
input[type=submit].blox:active:not(.disabled) {
  background-color: var(--blox-blue--active);
  border: 2px solid var(--blox-blue--active);
}
a[role=button].blox:disabled, a[role=button].blox:disabled:hover, a[role=button].blox.disabled, a[role=button].blox.disabled:hover,
button.blox:disabled,
button.blox:disabled:hover,
button.blox.disabled,
button.blox.disabled:hover,
input[type=button].blox:disabled,
input[type=button].blox:disabled:hover,
input[type=button].blox.disabled,
input[type=button].blox.disabled:hover,
input[type=reset].blox:disabled,
input[type=reset].blox:disabled:hover,
input[type=reset].blox.disabled,
input[type=reset].blox.disabled:hover,
input[type=submit].blox:disabled,
input[type=submit].blox:disabled:hover,
input[type=submit].blox.disabled,
input[type=submit].blox.disabled:hover {
  background-color: var(--blox-blue);
  border: 2px solid var(--blox-blue);
  color: white;
}
a[role=button].blox:not([hidden]),
button.blox:not([hidden]),
input[type=button].blox:not([hidden]),
input[type=reset].blox:not([hidden]),
input[type=submit].blox:not([hidden]) {
  display: inline-flex;
}
a[role=button].blox:focus:not(:disabled), a[role=button].blox:focus:not(.disabled),
button.blox:focus:not(:disabled),
button.blox:focus:not(.disabled),
input[type=button].blox:focus:not(:disabled),
input[type=button].blox:focus:not(.disabled),
input[type=reset].blox:focus:not(:disabled),
input[type=reset].blox:focus:not(.disabled),
input[type=submit].blox:focus:not(:disabled),
input[type=submit].blox:focus:not(.disabled) {
  outline: 2px solid var(--blox-slate5);
}
a[role=button].blox:disabled, a[role=button].blox.disabled,
button.blox:disabled,
button.blox.disabled,
input[type=button].blox:disabled,
input[type=button].blox.disabled,
input[type=reset].blox:disabled,
input[type=reset].blox.disabled,
input[type=submit].blox:disabled,
input[type=submit].blox.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
a[role=button].blox:disabled:focus, a[role=button].blox.disabled:focus,
button.blox:disabled:focus,
button.blox.disabled:focus,
input[type=button].blox:disabled:focus,
input[type=button].blox.disabled:focus,
input[type=reset].blox:disabled:focus,
input[type=reset].blox.disabled:focus,
input[type=submit].blox:disabled:focus,
input[type=submit].blox.disabled:focus {
  outline: none;
}
a[role=button].blox.grey,
button.blox.grey,
input[type=button].blox.grey,
input[type=reset].blox.grey,
input[type=submit].blox.grey {
  background-color: var(--blox-slate3);
  border: 2px solid var(--blox-slate3);
  color: white;
}
a[role=button].blox.grey:hover:not(:disabled), a[role=button].blox.grey:hover:not(.disabled),
button.blox.grey:hover:not(:disabled),
button.blox.grey:hover:not(.disabled),
input[type=button].blox.grey:hover:not(:disabled),
input[type=button].blox.grey:hover:not(.disabled),
input[type=reset].blox.grey:hover:not(:disabled),
input[type=reset].blox.grey:hover:not(.disabled),
input[type=submit].blox.grey:hover:not(:disabled),
input[type=submit].blox.grey:hover:not(.disabled) {
  background-color: var(--blox-slate3--hover);
  border: 2px solid var(--blox-slate3--hover);
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
}
a[role=button].blox.grey:active:not(:disabled), a[role=button].blox.grey:active:not(.disabled),
button.blox.grey:active:not(:disabled),
button.blox.grey:active:not(.disabled),
input[type=button].blox.grey:active:not(:disabled),
input[type=button].blox.grey:active:not(.disabled),
input[type=reset].blox.grey:active:not(:disabled),
input[type=reset].blox.grey:active:not(.disabled),
input[type=submit].blox.grey:active:not(:disabled),
input[type=submit].blox.grey:active:not(.disabled) {
  background-color: var(--blox-slate3--active);
  border: 2px solid var(--blox-slate3--active);
}
a[role=button].blox.grey:disabled, a[role=button].blox.grey:disabled:hover, a[role=button].blox.grey.disabled, a[role=button].blox.grey.disabled:hover,
button.blox.grey:disabled,
button.blox.grey:disabled:hover,
button.blox.grey.disabled,
button.blox.grey.disabled:hover,
input[type=button].blox.grey:disabled,
input[type=button].blox.grey:disabled:hover,
input[type=button].blox.grey.disabled,
input[type=button].blox.grey.disabled:hover,
input[type=reset].blox.grey:disabled,
input[type=reset].blox.grey:disabled:hover,
input[type=reset].blox.grey.disabled,
input[type=reset].blox.grey.disabled:hover,
input[type=submit].blox.grey:disabled,
input[type=submit].blox.grey:disabled:hover,
input[type=submit].blox.grey.disabled,
input[type=submit].blox.grey.disabled:hover {
  background-color: var(--blox-slate3);
  border: 2px solid var(--blox-slate3);
  color: white;
}
a[role=button].blox.green,
button.blox.green,
input[type=button].blox.green,
input[type=reset].blox.green,
input[type=submit].blox.green {
  background-color: var(--blox-green);
  border: 2px solid var(--blox-green);
  color: white;
}
a[role=button].blox.green:hover:not(:disabled), a[role=button].blox.green:hover:not(.disabled),
button.blox.green:hover:not(:disabled),
button.blox.green:hover:not(.disabled),
input[type=button].blox.green:hover:not(:disabled),
input[type=button].blox.green:hover:not(.disabled),
input[type=reset].blox.green:hover:not(:disabled),
input[type=reset].blox.green:hover:not(.disabled),
input[type=submit].blox.green:hover:not(:disabled),
input[type=submit].blox.green:hover:not(.disabled) {
  background-color: var(--blox-green--hover);
  border: 2px solid var(--blox-green--hover);
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
}
a[role=button].blox.green:active:not(:disabled), a[role=button].blox.green:active:not(.disabled),
button.blox.green:active:not(:disabled),
button.blox.green:active:not(.disabled),
input[type=button].blox.green:active:not(:disabled),
input[type=button].blox.green:active:not(.disabled),
input[type=reset].blox.green:active:not(:disabled),
input[type=reset].blox.green:active:not(.disabled),
input[type=submit].blox.green:active:not(:disabled),
input[type=submit].blox.green:active:not(.disabled) {
  background-color: var(--blox-green--active);
  border: 2px solid var(--blox-green--active);
}
a[role=button].blox.green:disabled, a[role=button].blox.green:disabled:hover, a[role=button].blox.green.disabled, a[role=button].blox.green.disabled:hover,
button.blox.green:disabled,
button.blox.green:disabled:hover,
button.blox.green.disabled,
button.blox.green.disabled:hover,
input[type=button].blox.green:disabled,
input[type=button].blox.green:disabled:hover,
input[type=button].blox.green.disabled,
input[type=button].blox.green.disabled:hover,
input[type=reset].blox.green:disabled,
input[type=reset].blox.green:disabled:hover,
input[type=reset].blox.green.disabled,
input[type=reset].blox.green.disabled:hover,
input[type=submit].blox.green:disabled,
input[type=submit].blox.green:disabled:hover,
input[type=submit].blox.green.disabled,
input[type=submit].blox.green.disabled:hover {
  background-color: var(--blox-green);
  border: 2px solid var(--blox-green);
  color: white;
}
a[role=button].blox.red,
button.blox.red,
input[type=button].blox.red,
input[type=reset].blox.red,
input[type=submit].blox.red {
  background-color: var(--blox-red);
  border: 2px solid var(--blox-red);
  color: white;
}
a[role=button].blox.red:hover:not(:disabled), a[role=button].blox.red:hover:not(.disabled),
button.blox.red:hover:not(:disabled),
button.blox.red:hover:not(.disabled),
input[type=button].blox.red:hover:not(:disabled),
input[type=button].blox.red:hover:not(.disabled),
input[type=reset].blox.red:hover:not(:disabled),
input[type=reset].blox.red:hover:not(.disabled),
input[type=submit].blox.red:hover:not(:disabled),
input[type=submit].blox.red:hover:not(.disabled) {
  background-color: var(--blox-red--hover);
  border: 2px solid var(--blox-red--hover);
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
}
a[role=button].blox.red:active:not(:disabled), a[role=button].blox.red:active:not(.disabled),
button.blox.red:active:not(:disabled),
button.blox.red:active:not(.disabled),
input[type=button].blox.red:active:not(:disabled),
input[type=button].blox.red:active:not(.disabled),
input[type=reset].blox.red:active:not(:disabled),
input[type=reset].blox.red:active:not(.disabled),
input[type=submit].blox.red:active:not(:disabled),
input[type=submit].blox.red:active:not(.disabled) {
  background-color: var(--blox-red--active);
  border: 2px solid var(--blox-red--active);
}
a[role=button].blox.red:disabled, a[role=button].blox.red:disabled:hover, a[role=button].blox.red.disabled, a[role=button].blox.red.disabled:hover,
button.blox.red:disabled,
button.blox.red:disabled:hover,
button.blox.red.disabled,
button.blox.red.disabled:hover,
input[type=button].blox.red:disabled,
input[type=button].blox.red:disabled:hover,
input[type=button].blox.red.disabled,
input[type=button].blox.red.disabled:hover,
input[type=reset].blox.red:disabled,
input[type=reset].blox.red:disabled:hover,
input[type=reset].blox.red.disabled,
input[type=reset].blox.red.disabled:hover,
input[type=submit].blox.red:disabled,
input[type=submit].blox.red:disabled:hover,
input[type=submit].blox.red.disabled,
input[type=submit].blox.red.disabled:hover {
  background-color: var(--blox-red);
  border: 2px solid var(--blox-red);
  color: white;
}

a[role=button].blox.secondary,
button.blox.secondary,
input[type=button].blox.secondary,
input[type=reset].blox.secondary,
input[type=submit].blox.secondary {
  background-color: transparent;
  border: 2px solid var(--blox-blue);
  color: var(--blox-blue);
  background-color: transparent;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), color var(--blox-transition-duration) var(--blox-transition-timing-function);
}
a[role=button].blox.secondary:hover:not(:disabled), a[role=button].blox.secondary:hover:not(.disabled),
button.blox.secondary:hover:not(:disabled),
button.blox.secondary:hover:not(.disabled),
input[type=button].blox.secondary:hover:not(:disabled),
input[type=button].blox.secondary:hover:not(.disabled),
input[type=reset].blox.secondary:hover:not(:disabled),
input[type=reset].blox.secondary:hover:not(.disabled),
input[type=submit].blox.secondary:hover:not(:disabled),
input[type=submit].blox.secondary:hover:not(.disabled) {
  background-color: var(--blox-blue--hover);
  border: 2px solid var(--blox-blue--hover);
  color: white;
}
a[role=button].blox.secondary:active:not(:disabled), a[role=button].blox.secondary:active:not(.disabled),
button.blox.secondary:active:not(:disabled),
button.blox.secondary:active:not(.disabled),
input[type=button].blox.secondary:active:not(:disabled),
input[type=button].blox.secondary:active:not(.disabled),
input[type=reset].blox.secondary:active:not(:disabled),
input[type=reset].blox.secondary:active:not(.disabled),
input[type=submit].blox.secondary:active:not(:disabled),
input[type=submit].blox.secondary:active:not(.disabled) {
  background-color: var(--blox-blue--active);
  border: 2px solid var(--blox-blue--active);
  color: white;
}
a[role=button].blox.secondary:disabled, a[role=button].blox.secondary:disabled:hover, a[role=button].blox.secondary.disabled, a[role=button].blox.secondary.disabled:hover,
button.blox.secondary:disabled,
button.blox.secondary:disabled:hover,
button.blox.secondary.disabled,
button.blox.secondary.disabled:hover,
input[type=button].blox.secondary:disabled,
input[type=button].blox.secondary:disabled:hover,
input[type=button].blox.secondary.disabled,
input[type=button].blox.secondary.disabled:hover,
input[type=reset].blox.secondary:disabled,
input[type=reset].blox.secondary:disabled:hover,
input[type=reset].blox.secondary.disabled,
input[type=reset].blox.secondary.disabled:hover,
input[type=submit].blox.secondary:disabled,
input[type=submit].blox.secondary:disabled:hover,
input[type=submit].blox.secondary.disabled,
input[type=submit].blox.secondary.disabled:hover {
  background-color: transparent;
  border: 2px solid var(--blox-blue);
  color: var(--blox-blue);
}
a[role=button].blox.secondary.grey,
button.blox.secondary.grey,
input[type=button].blox.secondary.grey,
input[type=reset].blox.secondary.grey,
input[type=submit].blox.secondary.grey {
  background-color: transparent;
  border: 2px solid var(--blox-slate3);
  color: var(--blox-slate3);
}
a[role=button].blox.secondary.grey:hover:not(:disabled), a[role=button].blox.secondary.grey:hover:not(.disabled),
button.blox.secondary.grey:hover:not(:disabled),
button.blox.secondary.grey:hover:not(.disabled),
input[type=button].blox.secondary.grey:hover:not(:disabled),
input[type=button].blox.secondary.grey:hover:not(.disabled),
input[type=reset].blox.secondary.grey:hover:not(:disabled),
input[type=reset].blox.secondary.grey:hover:not(.disabled),
input[type=submit].blox.secondary.grey:hover:not(:disabled),
input[type=submit].blox.secondary.grey:hover:not(.disabled) {
  background-color: var(--blox-slate3--hover);
  border: 2px solid var(--blox-slate3--hover);
  color: white;
}
a[role=button].blox.secondary.grey:active:not(:disabled), a[role=button].blox.secondary.grey:active:not(.disabled),
button.blox.secondary.grey:active:not(:disabled),
button.blox.secondary.grey:active:not(.disabled),
input[type=button].blox.secondary.grey:active:not(:disabled),
input[type=button].blox.secondary.grey:active:not(.disabled),
input[type=reset].blox.secondary.grey:active:not(:disabled),
input[type=reset].blox.secondary.grey:active:not(.disabled),
input[type=submit].blox.secondary.grey:active:not(:disabled),
input[type=submit].blox.secondary.grey:active:not(.disabled) {
  background-color: var(--blox-slate3--active);
  border: 2px solid var(--blox-slate3--active);
  color: white;
}
a[role=button].blox.secondary.grey:disabled, a[role=button].blox.secondary.grey:disabled:hover, a[role=button].blox.secondary.grey.disabled, a[role=button].blox.secondary.grey.disabled:hover,
button.blox.secondary.grey:disabled,
button.blox.secondary.grey:disabled:hover,
button.blox.secondary.grey.disabled,
button.blox.secondary.grey.disabled:hover,
input[type=button].blox.secondary.grey:disabled,
input[type=button].blox.secondary.grey:disabled:hover,
input[type=button].blox.secondary.grey.disabled,
input[type=button].blox.secondary.grey.disabled:hover,
input[type=reset].blox.secondary.grey:disabled,
input[type=reset].blox.secondary.grey:disabled:hover,
input[type=reset].blox.secondary.grey.disabled,
input[type=reset].blox.secondary.grey.disabled:hover,
input[type=submit].blox.secondary.grey:disabled,
input[type=submit].blox.secondary.grey:disabled:hover,
input[type=submit].blox.secondary.grey.disabled,
input[type=submit].blox.secondary.grey.disabled:hover {
  background-color: transparent;
  border: 2px solid var(--blox-slate3);
  color: var(--blox-slate3);
}
a[role=button].blox.secondary.green,
button.blox.secondary.green,
input[type=button].blox.secondary.green,
input[type=reset].blox.secondary.green,
input[type=submit].blox.secondary.green {
  background-color: transparent;
  border: 2px solid var(--blox-green);
  color: var(--blox-green);
}
a[role=button].blox.secondary.green:hover:not(:disabled), a[role=button].blox.secondary.green:hover:not(.disabled),
button.blox.secondary.green:hover:not(:disabled),
button.blox.secondary.green:hover:not(.disabled),
input[type=button].blox.secondary.green:hover:not(:disabled),
input[type=button].blox.secondary.green:hover:not(.disabled),
input[type=reset].blox.secondary.green:hover:not(:disabled),
input[type=reset].blox.secondary.green:hover:not(.disabled),
input[type=submit].blox.secondary.green:hover:not(:disabled),
input[type=submit].blox.secondary.green:hover:not(.disabled) {
  background-color: var(--blox-green--hover);
  border: 2px solid var(--blox-green--hover);
  color: white;
}
a[role=button].blox.secondary.green:active:not(:disabled), a[role=button].blox.secondary.green:active:not(.disabled),
button.blox.secondary.green:active:not(:disabled),
button.blox.secondary.green:active:not(.disabled),
input[type=button].blox.secondary.green:active:not(:disabled),
input[type=button].blox.secondary.green:active:not(.disabled),
input[type=reset].blox.secondary.green:active:not(:disabled),
input[type=reset].blox.secondary.green:active:not(.disabled),
input[type=submit].blox.secondary.green:active:not(:disabled),
input[type=submit].blox.secondary.green:active:not(.disabled) {
  background-color: var(--blox-green--active);
  border: 2px solid var(--blox-green--active);
  color: white;
}
a[role=button].blox.secondary.green:disabled, a[role=button].blox.secondary.green:disabled:hover, a[role=button].blox.secondary.green.disabled, a[role=button].blox.secondary.green.disabled:hover,
button.blox.secondary.green:disabled,
button.blox.secondary.green:disabled:hover,
button.blox.secondary.green.disabled,
button.blox.secondary.green.disabled:hover,
input[type=button].blox.secondary.green:disabled,
input[type=button].blox.secondary.green:disabled:hover,
input[type=button].blox.secondary.green.disabled,
input[type=button].blox.secondary.green.disabled:hover,
input[type=reset].blox.secondary.green:disabled,
input[type=reset].blox.secondary.green:disabled:hover,
input[type=reset].blox.secondary.green.disabled,
input[type=reset].blox.secondary.green.disabled:hover,
input[type=submit].blox.secondary.green:disabled,
input[type=submit].blox.secondary.green:disabled:hover,
input[type=submit].blox.secondary.green.disabled,
input[type=submit].blox.secondary.green.disabled:hover {
  background-color: transparent;
  border: 2px solid var(--blox-green);
  color: var(--blox-green);
}
a[role=button].blox.secondary.red,
button.blox.secondary.red,
input[type=button].blox.secondary.red,
input[type=reset].blox.secondary.red,
input[type=submit].blox.secondary.red {
  background-color: transparent;
  border: 2px solid var(--blox-red);
  color: var(--blox-red);
}
a[role=button].blox.secondary.red:hover:not(:disabled), a[role=button].blox.secondary.red:hover:not(.disabled),
button.blox.secondary.red:hover:not(:disabled),
button.blox.secondary.red:hover:not(.disabled),
input[type=button].blox.secondary.red:hover:not(:disabled),
input[type=button].blox.secondary.red:hover:not(.disabled),
input[type=reset].blox.secondary.red:hover:not(:disabled),
input[type=reset].blox.secondary.red:hover:not(.disabled),
input[type=submit].blox.secondary.red:hover:not(:disabled),
input[type=submit].blox.secondary.red:hover:not(.disabled) {
  background-color: var(--blox-red--hover);
  border: 2px solid var(--blox-red--hover);
  color: white;
}
a[role=button].blox.secondary.red:active:not(:disabled), a[role=button].blox.secondary.red:active:not(.disabled),
button.blox.secondary.red:active:not(:disabled),
button.blox.secondary.red:active:not(.disabled),
input[type=button].blox.secondary.red:active:not(:disabled),
input[type=button].blox.secondary.red:active:not(.disabled),
input[type=reset].blox.secondary.red:active:not(:disabled),
input[type=reset].blox.secondary.red:active:not(.disabled),
input[type=submit].blox.secondary.red:active:not(:disabled),
input[type=submit].blox.secondary.red:active:not(.disabled) {
  background-color: var(--blox-red--active);
  border: 2px solid var(--blox-red--active);
  color: white;
}
a[role=button].blox.secondary.red:disabled, a[role=button].blox.secondary.red:disabled:hover, a[role=button].blox.secondary.red.disabled, a[role=button].blox.secondary.red.disabled:hover,
button.blox.secondary.red:disabled,
button.blox.secondary.red:disabled:hover,
button.blox.secondary.red.disabled,
button.blox.secondary.red.disabled:hover,
input[type=button].blox.secondary.red:disabled,
input[type=button].blox.secondary.red:disabled:hover,
input[type=button].blox.secondary.red.disabled,
input[type=button].blox.secondary.red.disabled:hover,
input[type=reset].blox.secondary.red:disabled,
input[type=reset].blox.secondary.red:disabled:hover,
input[type=reset].blox.secondary.red.disabled,
input[type=reset].blox.secondary.red.disabled:hover,
input[type=submit].blox.secondary.red:disabled,
input[type=submit].blox.secondary.red:disabled:hover,
input[type=submit].blox.secondary.red.disabled,
input[type=submit].blox.secondary.red.disabled:hover {
  background-color: transparent;
  border: 2px solid var(--blox-red);
  color: var(--blox-red);
}

a[role=button].blox.text,
button.blox.text,
input[type=button].blox.text,
input[type=reset].blox.text,
input[type=submit].blox.text {
  background-color: transparent;
  color: var(--blox-blue);
  border: none;
  padding: 0;
}
a[role=button].blox.text:hover:not(:disabled), a[role=button].blox.text:hover:not(.disabled),
button.blox.text:hover:not(:disabled),
button.blox.text:hover:not(.disabled),
input[type=button].blox.text:hover:not(:disabled),
input[type=button].blox.text:hover:not(.disabled),
input[type=reset].blox.text:hover:not(:disabled),
input[type=reset].blox.text:hover:not(.disabled),
input[type=submit].blox.text:hover:not(:disabled),
input[type=submit].blox.text:hover:not(.disabled) {
  background-color: transparent;
  color: var(--blox-blue--hover);
}
a[role=button].blox.text:active:not(:disabled), a[role=button].blox.text:active:not(.disabled),
button.blox.text:active:not(:disabled),
button.blox.text:active:not(.disabled),
input[type=button].blox.text:active:not(:disabled),
input[type=button].blox.text:active:not(.disabled),
input[type=reset].blox.text:active:not(:disabled),
input[type=reset].blox.text:active:not(.disabled),
input[type=submit].blox.text:active:not(:disabled),
input[type=submit].blox.text:active:not(.disabled) {
  background-color: transparent;
  color: var(--blox-blue--active);
}
a[role=button].blox.text:disabled, a[role=button].blox.text.disabled,
button.blox.text:disabled,
button.blox.text.disabled,
input[type=button].blox.text:disabled,
input[type=button].blox.text.disabled,
input[type=reset].blox.text:disabled,
input[type=reset].blox.text.disabled,
input[type=submit].blox.text:disabled,
input[type=submit].blox.text.disabled {
  background-color: transparent;
  color: var(--blox-blue);
}
a[role=button].blox.text:disabled, a[role=button].blox.text:hover:not(:disabled), a[role=button].blox.text:active:not(:disabled), a[role=button].blox.text.disabled, a[role=button].blox.text:hover:not(.disabled), a[role=button].blox.text:active:not(.disabled),
button.blox.text:disabled,
button.blox.text:hover:not(:disabled),
button.blox.text:active:not(:disabled),
button.blox.text.disabled,
button.blox.text:hover:not(.disabled),
button.blox.text:active:not(.disabled),
input[type=button].blox.text:disabled,
input[type=button].blox.text:hover:not(:disabled),
input[type=button].blox.text:active:not(:disabled),
input[type=button].blox.text.disabled,
input[type=button].blox.text:hover:not(.disabled),
input[type=button].blox.text:active:not(.disabled),
input[type=reset].blox.text:disabled,
input[type=reset].blox.text:hover:not(:disabled),
input[type=reset].blox.text:active:not(:disabled),
input[type=reset].blox.text.disabled,
input[type=reset].blox.text:hover:not(.disabled),
input[type=reset].blox.text:active:not(.disabled),
input[type=submit].blox.text:disabled,
input[type=submit].blox.text:hover:not(:disabled),
input[type=submit].blox.text:active:not(:disabled),
input[type=submit].blox.text.disabled,
input[type=submit].blox.text:hover:not(.disabled),
input[type=submit].blox.text:active:not(.disabled) {
  border: none;
}
a[role=button].blox.text.grey,
button.blox.text.grey,
input[type=button].blox.text.grey,
input[type=reset].blox.text.grey,
input[type=submit].blox.text.grey {
  background-color: transparent;
  color: var(--blox-slate3);
}
a[role=button].blox.text.grey:hover:not(:disabled), a[role=button].blox.text.grey:hover:not(.disabled),
button.blox.text.grey:hover:not(:disabled),
button.blox.text.grey:hover:not(.disabled),
input[type=button].blox.text.grey:hover:not(:disabled),
input[type=button].blox.text.grey:hover:not(.disabled),
input[type=reset].blox.text.grey:hover:not(:disabled),
input[type=reset].blox.text.grey:hover:not(.disabled),
input[type=submit].blox.text.grey:hover:not(:disabled),
input[type=submit].blox.text.grey:hover:not(.disabled) {
  background-color: transparent;
  color: var(--blox-slate3--hover);
}
a[role=button].blox.text.grey:active:not(:disabled), a[role=button].blox.text.grey:active:not(.disabled),
button.blox.text.grey:active:not(:disabled),
button.blox.text.grey:active:not(.disabled),
input[type=button].blox.text.grey:active:not(:disabled),
input[type=button].blox.text.grey:active:not(.disabled),
input[type=reset].blox.text.grey:active:not(:disabled),
input[type=reset].blox.text.grey:active:not(.disabled),
input[type=submit].blox.text.grey:active:not(:disabled),
input[type=submit].blox.text.grey:active:not(.disabled) {
  background-color: transparent;
  color: var(--blox-slate3--active);
}
a[role=button].blox.text.grey:disabled, a[role=button].blox.text.grey.disabled,
button.blox.text.grey:disabled,
button.blox.text.grey.disabled,
input[type=button].blox.text.grey:disabled,
input[type=button].blox.text.grey.disabled,
input[type=reset].blox.text.grey:disabled,
input[type=reset].blox.text.grey.disabled,
input[type=submit].blox.text.grey:disabled,
input[type=submit].blox.text.grey.disabled {
  background-color: transparent;
  color: var(--blox-slate3);
}
a[role=button].blox.text.green,
button.blox.text.green,
input[type=button].blox.text.green,
input[type=reset].blox.text.green,
input[type=submit].blox.text.green {
  background-color: transparent;
  color: var(--blox-green);
}
a[role=button].blox.text.green:hover:not(:disabled), a[role=button].blox.text.green:hover:not(.disabled),
button.blox.text.green:hover:not(:disabled),
button.blox.text.green:hover:not(.disabled),
input[type=button].blox.text.green:hover:not(:disabled),
input[type=button].blox.text.green:hover:not(.disabled),
input[type=reset].blox.text.green:hover:not(:disabled),
input[type=reset].blox.text.green:hover:not(.disabled),
input[type=submit].blox.text.green:hover:not(:disabled),
input[type=submit].blox.text.green:hover:not(.disabled) {
  background-color: transparent;
  color: var(--blox-green--hover);
}
a[role=button].blox.text.green:active:not(:disabled), a[role=button].blox.text.green:active:not(.disabled),
button.blox.text.green:active:not(:disabled),
button.blox.text.green:active:not(.disabled),
input[type=button].blox.text.green:active:not(:disabled),
input[type=button].blox.text.green:active:not(.disabled),
input[type=reset].blox.text.green:active:not(:disabled),
input[type=reset].blox.text.green:active:not(.disabled),
input[type=submit].blox.text.green:active:not(:disabled),
input[type=submit].blox.text.green:active:not(.disabled) {
  background-color: transparent;
  color: var(--blox-green--active);
}
a[role=button].blox.text.green:disabled, a[role=button].blox.text.green.disabled,
button.blox.text.green:disabled,
button.blox.text.green.disabled,
input[type=button].blox.text.green:disabled,
input[type=button].blox.text.green.disabled,
input[type=reset].blox.text.green:disabled,
input[type=reset].blox.text.green.disabled,
input[type=submit].blox.text.green:disabled,
input[type=submit].blox.text.green.disabled {
  background-color: transparent;
  color: var(--blox-green);
}
a[role=button].blox.text.red,
button.blox.text.red,
input[type=button].blox.text.red,
input[type=reset].blox.text.red,
input[type=submit].blox.text.red {
  background-color: transparent;
  color: var(--blox-red);
}
a[role=button].blox.text.red:hover:not(:disabled), a[role=button].blox.text.red:hover:not(.disabled),
button.blox.text.red:hover:not(:disabled),
button.blox.text.red:hover:not(.disabled),
input[type=button].blox.text.red:hover:not(:disabled),
input[type=button].blox.text.red:hover:not(.disabled),
input[type=reset].blox.text.red:hover:not(:disabled),
input[type=reset].blox.text.red:hover:not(.disabled),
input[type=submit].blox.text.red:hover:not(:disabled),
input[type=submit].blox.text.red:hover:not(.disabled) {
  background-color: transparent;
  color: var(--blox-red--hover);
}
a[role=button].blox.text.red:active:not(:disabled), a[role=button].blox.text.red:active:not(.disabled),
button.blox.text.red:active:not(:disabled),
button.blox.text.red:active:not(.disabled),
input[type=button].blox.text.red:active:not(:disabled),
input[type=button].blox.text.red:active:not(.disabled),
input[type=reset].blox.text.red:active:not(:disabled),
input[type=reset].blox.text.red:active:not(.disabled),
input[type=submit].blox.text.red:active:not(:disabled),
input[type=submit].blox.text.red:active:not(.disabled) {
  background-color: transparent;
  color: var(--blox-red--active);
}
a[role=button].blox.text.red:disabled, a[role=button].blox.text.red.disabled,
button.blox.text.red:disabled,
button.blox.text.red.disabled,
input[type=button].blox.text.red:disabled,
input[type=button].blox.text.red.disabled,
input[type=reset].blox.text.red:disabled,
input[type=reset].blox.text.red.disabled,
input[type=submit].blox.text.red:disabled,
input[type=submit].blox.text.red.disabled {
  background-color: transparent;
  color: var(--blox-red);
}
a[role=button].blox.text.grey, a[role=button].blox.text.green, a[role=button].blox.text.red,
button.blox.text.grey,
button.blox.text.green,
button.blox.text.red,
input[type=button].blox.text.grey,
input[type=button].blox.text.green,
input[type=button].blox.text.red,
input[type=reset].blox.text.grey,
input[type=reset].blox.text.green,
input[type=reset].blox.text.red,
input[type=submit].blox.text.grey,
input[type=submit].blox.text.green,
input[type=submit].blox.text.red {
  border: none;
  padding: 0;
}
a[role=button].blox.text.grey:disabled, a[role=button].blox.text.grey:hover:not(:disabled), a[role=button].blox.text.grey:active:not(:disabled), a[role=button].blox.text.grey.disabled, a[role=button].blox.text.grey:hover:not(.disabled), a[role=button].blox.text.grey:active:not(.disabled), a[role=button].blox.text.green:disabled, a[role=button].blox.text.green:hover:not(:disabled), a[role=button].blox.text.green:active:not(:disabled), a[role=button].blox.text.green.disabled, a[role=button].blox.text.green:hover:not(.disabled), a[role=button].blox.text.green:active:not(.disabled), a[role=button].blox.text.red:disabled, a[role=button].blox.text.red:hover:not(:disabled), a[role=button].blox.text.red:active:not(:disabled), a[role=button].blox.text.red.disabled, a[role=button].blox.text.red:hover:not(.disabled), a[role=button].blox.text.red:active:not(.disabled),
button.blox.text.grey:disabled,
button.blox.text.grey:hover:not(:disabled),
button.blox.text.grey:active:not(:disabled),
button.blox.text.grey.disabled,
button.blox.text.grey:hover:not(.disabled),
button.blox.text.grey:active:not(.disabled),
button.blox.text.green:disabled,
button.blox.text.green:hover:not(:disabled),
button.blox.text.green:active:not(:disabled),
button.blox.text.green.disabled,
button.blox.text.green:hover:not(.disabled),
button.blox.text.green:active:not(.disabled),
button.blox.text.red:disabled,
button.blox.text.red:hover:not(:disabled),
button.blox.text.red:active:not(:disabled),
button.blox.text.red.disabled,
button.blox.text.red:hover:not(.disabled),
button.blox.text.red:active:not(.disabled),
input[type=button].blox.text.grey:disabled,
input[type=button].blox.text.grey:hover:not(:disabled),
input[type=button].blox.text.grey:active:not(:disabled),
input[type=button].blox.text.grey.disabled,
input[type=button].blox.text.grey:hover:not(.disabled),
input[type=button].blox.text.grey:active:not(.disabled),
input[type=button].blox.text.green:disabled,
input[type=button].blox.text.green:hover:not(:disabled),
input[type=button].blox.text.green:active:not(:disabled),
input[type=button].blox.text.green.disabled,
input[type=button].blox.text.green:hover:not(.disabled),
input[type=button].blox.text.green:active:not(.disabled),
input[type=button].blox.text.red:disabled,
input[type=button].blox.text.red:hover:not(:disabled),
input[type=button].blox.text.red:active:not(:disabled),
input[type=button].blox.text.red.disabled,
input[type=button].blox.text.red:hover:not(.disabled),
input[type=button].blox.text.red:active:not(.disabled),
input[type=reset].blox.text.grey:disabled,
input[type=reset].blox.text.grey:hover:not(:disabled),
input[type=reset].blox.text.grey:active:not(:disabled),
input[type=reset].blox.text.grey.disabled,
input[type=reset].blox.text.grey:hover:not(.disabled),
input[type=reset].blox.text.grey:active:not(.disabled),
input[type=reset].blox.text.green:disabled,
input[type=reset].blox.text.green:hover:not(:disabled),
input[type=reset].blox.text.green:active:not(:disabled),
input[type=reset].blox.text.green.disabled,
input[type=reset].blox.text.green:hover:not(.disabled),
input[type=reset].blox.text.green:active:not(.disabled),
input[type=reset].blox.text.red:disabled,
input[type=reset].blox.text.red:hover:not(:disabled),
input[type=reset].blox.text.red:active:not(:disabled),
input[type=reset].blox.text.red.disabled,
input[type=reset].blox.text.red:hover:not(.disabled),
input[type=reset].blox.text.red:active:not(.disabled),
input[type=submit].blox.text.grey:disabled,
input[type=submit].blox.text.grey:hover:not(:disabled),
input[type=submit].blox.text.grey:active:not(:disabled),
input[type=submit].blox.text.grey.disabled,
input[type=submit].blox.text.grey:hover:not(.disabled),
input[type=submit].blox.text.grey:active:not(.disabled),
input[type=submit].blox.text.green:disabled,
input[type=submit].blox.text.green:hover:not(:disabled),
input[type=submit].blox.text.green:active:not(:disabled),
input[type=submit].blox.text.green.disabled,
input[type=submit].blox.text.green:hover:not(.disabled),
input[type=submit].blox.text.green:active:not(.disabled),
input[type=submit].blox.text.red:disabled,
input[type=submit].blox.text.red:hover:not(:disabled),
input[type=submit].blox.text.red:active:not(:disabled),
input[type=submit].blox.text.red.disabled,
input[type=submit].blox.text.red:hover:not(.disabled),
input[type=submit].blox.text.red:active:not(.disabled) {
  border: none;
}
a[role=button].blox.text i,
button.blox.text i,
input[type=button].blox.text i,
input[type=reset].blox.text i,
input[type=submit].blox.text i {
  font-size: 20px;
}
a[role=button].blox.text svg,
button.blox.text svg,
input[type=button].blox.text svg,
input[type=reset].blox.text svg,
input[type=submit].blox.text svg {
  font-size: 20px;
}

button.blox.icon {
  background-color: white;
  border: none;
  color: var(--blox-slate2);
  font-size: 16px;
  padding: 10px;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), color var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
}
button.blox.icon:hover:not(:disabled) {
  background-color: var(--blox-slate1);
  border: none;
  color: var(--blox-slate3);
}
button.blox.icon:focus:not(:disabled), button.blox.icon:focus-visible:not(:disabled) {
  outline: 2px solid var(--blox-blue);
}
button.blox.icon:disabled {
  background-color: white;
  border: none;
  color: var(--blox-slate2);
  cursor: not-allowed;
  opacity: 0.5;
}
button.blox.icon:active:not(:disabled), button.blox.icon[aria-expanded=true], button.blox.icon[aria-pressed=true] {
  background-color: var(--blox-slate1--hover);
  border: none;
  color: var(--blox-slate3);
}
button.blox.icon.no-bg {
  background-color: transparent;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function);
}

/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
input.blox:not(.hidden-form-control):not([type]):disabled, input.blox:not(.hidden-form-control)[type=checkbox]:disabled, input.blox:not(.hidden-form-control)[type=color]:disabled, input.blox:not(.hidden-form-control)[type=date]:disabled, input.blox:not(.hidden-form-control)[type=datetime-local]:disabled, input.blox:not(.hidden-form-control)[type=email]:disabled, input.blox:not(.hidden-form-control)[type=file]:disabled, input.blox:not(.hidden-form-control)[type=image]:disabled, input.blox:not(.hidden-form-control)[type=month]:disabled, input.blox:not(.hidden-form-control)[type=number]:disabled, input.blox:not(.hidden-form-control)[type=password]:disabled, input.blox:not(.hidden-form-control)[type=radio]:disabled, input.blox:not(.hidden-form-control)[type=range]:disabled, input.blox:not(.hidden-form-control)[type=search]:disabled, input.blox:not(.hidden-form-control)[type=tel]:disabled, input.blox:not(.hidden-form-control)[type=text]:disabled, input.blox:not(.hidden-form-control)[type=time]:disabled, input.blox:not(.hidden-form-control)[type=url]:disabled, input.blox:not(.hidden-form-control)[type=week]:disabled {
  background-color: var(--blox-background-input--disabled);
  cursor: not-allowed;
  opacity: 0.5;
  outline: none;
}
input.blox:not(.hidden-form-control):not([type]), input.blox:not(.hidden-form-control)[type=date], input.blox:not(.hidden-form-control)[type=datetime-local], input.blox:not(.hidden-form-control)[type=email], input.blox:not(.hidden-form-control)[type=month], input.blox:not(.hidden-form-control)[type=number], input.blox:not(.hidden-form-control)[type=password], input.blox:not(.hidden-form-control)[type=search], input.blox:not(.hidden-form-control)[type=tel], input.blox:not(.hidden-form-control)[type=text], input.blox:not(.hidden-form-control)[type=time], input.blox:not(.hidden-form-control)[type=url], input.blox:not(.hidden-form-control)[type=week] {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  --font-size: 14px;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  color: var(--blox-slate5);
  cursor: text;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  outline: revert;
  padding: 10px 20px;
  -webkit-text-decoration: revert;
          text-decoration: revert;
  vertical-align: revert;
}
input.blox:not(.hidden-form-control):not([type]):hover:enabled, input.blox:not(.hidden-form-control)[type=date]:hover:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:hover:enabled, input.blox:not(.hidden-form-control)[type=email]:hover:enabled, input.blox:not(.hidden-form-control)[type=month]:hover:enabled, input.blox:not(.hidden-form-control)[type=number]:hover:enabled, input.blox:not(.hidden-form-control)[type=password]:hover:enabled, input.blox:not(.hidden-form-control)[type=search]:hover:enabled, input.blox:not(.hidden-form-control)[type=tel]:hover:enabled, input.blox:not(.hidden-form-control)[type=text]:hover:enabled, input.blox:not(.hidden-form-control)[type=time]:hover:enabled, input.blox:not(.hidden-form-control)[type=url]:hover:enabled, input.blox:not(.hidden-form-control)[type=week]:hover:enabled {
  border: var(--blox-border-input--hover);
}
input.blox:not(.hidden-form-control):not([type]):focus:enabled, input.blox:not(.hidden-form-control)[type=date]:focus:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:focus:enabled, input.blox:not(.hidden-form-control)[type=email]:focus:enabled, input.blox:not(.hidden-form-control)[type=month]:focus:enabled, input.blox:not(.hidden-form-control)[type=number]:focus:enabled, input.blox:not(.hidden-form-control)[type=password]:focus:enabled, input.blox:not(.hidden-form-control)[type=search]:focus:enabled, input.blox:not(.hidden-form-control)[type=tel]:focus:enabled, input.blox:not(.hidden-form-control)[type=text]:focus:enabled, input.blox:not(.hidden-form-control)[type=time]:focus:enabled, input.blox:not(.hidden-form-control)[type=url]:focus:enabled, input.blox:not(.hidden-form-control)[type=week]:focus:enabled {
  border: var(--blox-border-input--focus);
  outline: none;
}
input.blox:not(.hidden-form-control):not([type]):invalid:not(.hide-invalid), input.blox:not(.hidden-form-control):not([type])[aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=date]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=date][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=datetime-local]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=datetime-local][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=email]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=email][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=month]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=month][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=number]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=number][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=password]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=password][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=search]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=search][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=tel]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=tel][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=text]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=text][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=time]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=time][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=url]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=url][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=week]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=week][aria-invalid=true]:not(.hide-invalid) {
  border: var(--blox-border-input-invalid);
}
input.blox:not(.hidden-form-control):not([type]):invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control):not([type])[aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=date]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=date][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=datetime-local][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=email]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=email][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=month]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=month][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=number]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=number][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=password]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=password][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=search]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=search][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=tel]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=tel][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=text]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=text][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=time]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=time][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=url]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=url][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=week]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=week][aria-invalid=true]:not(.hide-invalid):hover:enabled {
  border: var(--blox-border-input-invalid--hover);
}
input.blox:not(.hidden-form-control):not([type]):invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control):not([type])[aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=date]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=date][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=datetime-local][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=email]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=email][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=month]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=month][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=number]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=number][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=password]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=password][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=search]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=search][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=tel]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=tel][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=text]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=text][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=time]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=time][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=url]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=url][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=week]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=week][aria-invalid=true]:not(.hide-invalid):focus:enabled {
  border: var(--blox-border-input-invalid--focus);
}
input.blox:not(.hidden-form-control):not([type])::-moz-placeholder, input.blox:not(.hidden-form-control)[type=date]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=datetime-local]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=email]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=month]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=number]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=password]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=search]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=tel]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=text]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=time]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=url]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=week]::-moz-placeholder {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}
input.blox:not(.hidden-form-control):not([type]):-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=date]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=datetime-local]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=email]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=month]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=number]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=password]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=search]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=tel]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=text]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=time]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=url]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=week]:-ms-input-placeholder {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}
input.blox:not(.hidden-form-control):not([type])::placeholder, input.blox:not(.hidden-form-control)[type=date]::placeholder, input.blox:not(.hidden-form-control)[type=datetime-local]::placeholder, input.blox:not(.hidden-form-control)[type=email]::placeholder, input.blox:not(.hidden-form-control)[type=month]::placeholder, input.blox:not(.hidden-form-control)[type=number]::placeholder, input.blox:not(.hidden-form-control)[type=password]::placeholder, input.blox:not(.hidden-form-control)[type=search]::placeholder, input.blox:not(.hidden-form-control)[type=tel]::placeholder, input.blox:not(.hidden-form-control)[type=text]::placeholder, input.blox:not(.hidden-form-control)[type=time]::placeholder, input.blox:not(.hidden-form-control)[type=url]::placeholder, input.blox:not(.hidden-form-control)[type=week]::placeholder {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}
input.blox:not(.hidden-form-control):not([type])::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=date]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=datetime-local]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=email]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=month]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=number]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=password]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=search]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=tel]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=text]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=time]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=url]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=week]::-webkit-search-cancel-button {
  display: none;
}
input.blox:not(.hidden-form-control):not([type]).pill, input.blox:not(.hidden-form-control)[type=date].pill, input.blox:not(.hidden-form-control)[type=datetime-local].pill, input.blox:not(.hidden-form-control)[type=email].pill, input.blox:not(.hidden-form-control)[type=month].pill, input.blox:not(.hidden-form-control)[type=number].pill, input.blox:not(.hidden-form-control)[type=password].pill, input.blox:not(.hidden-form-control)[type=search].pill, input.blox:not(.hidden-form-control)[type=tel].pill, input.blox:not(.hidden-form-control)[type=text].pill, input.blox:not(.hidden-form-control)[type=time].pill, input.blox:not(.hidden-form-control)[type=url].pill, input.blox:not(.hidden-form-control)[type=week].pill {
  border-radius: 2em;
}
input.blox:not(.hidden-form-control)[type=checkbox], input.blox:not(.hidden-form-control)[type=radio] {
  --internal-size: var(--size, 16px);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  display: inline-grid;
  font: inherit;
  height: var(--internal-size);
  place-content: center;
  transition: background-color 0.1s var(--blox-transition-timing-function), border 0.1s var(--blox-transition-timing-function);
  width: var(--internal-size);
}
input.blox:not(.hidden-form-control)[type=checkbox]::before, input.blox:not(.hidden-form-control)[type=radio]::before {
  background-color: white;
  content: "";
  transform: scale(0);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked, input.blox:not(.hidden-form-control)[type=radio]:checked {
  background-color: var(--blox-blue);
  border: 1px solid var(--blox-blue);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked::before, input.blox:not(.hidden-form-control)[type=radio]:checked::before {
  transform: scale(1);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked:hover:enabled, input.blox:not(.hidden-form-control)[type=radio]:checked:hover:enabled {
  background-color: var(--blox-blue--hover);
  border: 1px solid var(--blox-blue--hover);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked:active:enabled, input.blox:not(.hidden-form-control)[type=radio]:checked:active:enabled {
  background-color: var(--blox-blue--active);
  border: 1px solid var(--blox-blue--active);
}
input.blox:not(.hidden-form-control)[type=checkbox]:hover:enabled:not(:checked), input.blox:not(.hidden-form-control)[type=radio]:hover:enabled:not(:checked) {
  border: var(--blox-border-input--hover);
}
input.blox:not(.hidden-form-control)[type=checkbox]:active:enabled:not(:checked), input.blox:not(.hidden-form-control)[type=radio]:active:enabled:not(:checked) {
  border: var(--blox-border-input--active);
}
input.blox:not(.hidden-form-control)[type=checkbox]:focus-visible, input.blox:not(.hidden-form-control)[type=radio]:focus-visible {
  outline: 2px solid var(--blox-blue);
  outline-offset: 2px;
}
input.blox:not(.hidden-form-control)[type=checkbox] {
  border-radius: var(--blox-border-radius);
  transform: translateY(1px);
}
input.blox:not(.hidden-form-control)[type=checkbox]::before {
  background-color: transparent;
  background-image: url("http://assets.pxlecdn.com/blox/checkmark-checked.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  height: calc(var(--internal-size) - 2px);
  width: calc(var(--internal-size) - 2px);
}
input.blox:not(.hidden-form-control)[type=checkbox].table {
  --internal-size: var(--size, 45px);
  border: 0;
  border-radius: unset;
  height: 100%;
  transform: none;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=checkbox].table::before {
  box-shadow: none;
  transform: none;
}
input.blox:not(.hidden-form-control)[type=checkbox].table:not(:checked) {
  background-color: var(--background-color, transparent);
}
input.blox:not(.hidden-form-control)[type=checkbox].table:not(:checked)::before {
  background-image: url("http://assets.pxlecdn.com/blox/checkmark-unchecked.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50%;
}
input.blox:not(.hidden-form-control)[type=checkbox].table:not(:checked):hover, input.blox:not(.hidden-form-control)[type=checkbox].table:checked:hover, input.blox:not(.hidden-form-control)[type=checkbox].table:active:enabled:not(:checked) {
  border: none;
}
input.blox:not(.hidden-form-control)[type=checkbox].table:checked::before {
  background-color: transparent;
  background-image: url("http://assets.pxlecdn.com/blox/checkmark-checked.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50%;
}
input.blox:not(.hidden-form-control)[type=checkbox].switch {
  --internal-size: var(--size, 36px);
  --switch-off-background-color: var(--blox-slate1c);
  --switch-on-background-color: var(--blox-green);
  --dot-size: 20px;
  --dot-padding: 4px;
  transition: --switch-off-background-color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--switch-off-background-color);
  border: 0;
  border-radius: 22px;
  color: transparent;
  font-size: 0;
  height: calc(var(--dot-size) + var(--dot-padding));
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  width: var(--internal-size);
}
input.blox:not(.hidden-form-control)[type=checkbox].switch::before {
  content: unset;
}
input.blox:not(.hidden-form-control)[type=checkbox].switch::after {
  background-color: white;
  border-radius: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15), 0 4px 4px rgba(0, 0, 0, 0.1);
  content: " ";
  height: var(--dot-size);
  left: calc(var(--dot-padding) / 2);
  position: absolute;
  right: auto;
  top: calc(var(--dot-padding) / 2);
  transition: all 0.1s ease-out 0s;
  width: var(--dot-size);
}
input.blox:not(.hidden-form-control)[type=checkbox].switch:checked, input.blox:not(.hidden-form-control)[type=checkbox].switch:checked:hover, input.blox:not(.hidden-form-control)[type=checkbox].switch:checked:focus, input.blox:not(.hidden-form-control)[type=checkbox].switch:checked:active {
  background-color: var(--switch-on-background-color);
}
input.blox:not(.hidden-form-control)[type=checkbox].switch:checked::after {
  transform: translateX(calc(var(--internal-size) - var(--dot-size) - var(--dot-padding)));
}
input.blox:not(.hidden-form-control)[type=checkbox].switch:hover:enabled:checked, input.blox:not(.hidden-form-control)[type=checkbox].switch:hover:enabled:not(:checked), input.blox:not(.hidden-form-control)[type=checkbox].switch:active:enabled:checked, input.blox:not(.hidden-form-control)[type=checkbox].switch:active:enabled:not(:checked) {
  border: 0;
}
input.blox:not(.hidden-form-control)[type=radio] {
  border-radius: 50%;
  transform: translateY(-3px);
}
input.blox:not(.hidden-form-control)[type=radio]::before {
  border-radius: 50%;
  box-shadow: inset 1em 1em var(--form-control-color);
  height: calc(var(--internal-size) * 0.4);
  width: calc(var(--internal-size) * 0.4);
}
input.blox:not(.hidden-form-control)[type=color] {
  --width: 50px;
  background-color: var(--blox-slate0a);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  height: calc(var(--width) / 2);
  min-height: 20px;
  min-width: 20px;
  padding: 0;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function);
  width: var(--width);
}
input.blox:not(.hidden-form-control)[type=color]:hover:enabled {
  background-color: var(--blox-slate1);
  border: var(--blox-border-input--hover);
}
input.blox:not(.hidden-form-control)[type=color]:active:enabled {
  border: var(--blox-border-input--active);
}
input.blox:not(.hidden-form-control)[type=color]:focus:enabled {
  border: var(--blox-border-input--focus);
  outline: none;
}
input.blox:not(.hidden-form-control)[type=color]::-webkit-color-swatch-wrapper {
  border: none;
  border-radius: var(--blox-border-radius);
  margin: 0;
  padding: 5px;
}
input.blox:not(.hidden-form-control)[type=color]::-webkit-color-swatch {
  border: none;
  border-radius: 2px;
  margin: 0;
  padding: 0;
}
input.blox:not(.hidden-form-control)[type=color].pill {
  border-radius: 2em;
}
input.blox:not(.hidden-form-control)[type=color].pill::-webkit-color-swatch-wrapper, input.blox:not(.hidden-form-control)[type=color].pill::-webkit-color-swatch {
  border-radius: 2em;
}
input.blox:not(.hidden-form-control)[type=file] {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  --font-size: 14px;
  border: 1px solid transparent;
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  color: var(--blox-slate3);
  cursor: pointer;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  padding: 0;
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function), color var(--blox-transition-duration) var(--blox-transition-timing-function);
}
input.blox:not(.hidden-form-control)[type=file]:hover:enabled {
  color: var(--blox-slate3--hover);
}
input.blox:not(.hidden-form-control)[type=file]:active:enabled {
  color: var(--blox-slate3--active);
}
input.blox:not(.hidden-form-control)[type=file]:focus-visible:enabled {
  outline: 2px solid var(--blox-blue);
}
input.blox:not(.hidden-form-control)[type=file]:disabled {
  background-color: transparent;
}
input.blox:not(.hidden-form-control)[type=file]:disabled::-webkit-file-upload-button {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=file]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=file][aria-invalid=true]:not(.hide-invalid) {
  border: var(--blox-border-input-invalid);
}
input.blox:not(.hidden-form-control)[type=file]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=file][aria-invalid=true]:not(.hide-invalid):hover:enabled {
  border: var(--blox-border-input-invalid--hover);
}
input.blox:not(.hidden-form-control)[type=file]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=file][aria-invalid=true]:not(.hide-invalid):focus:enabled {
  border: var(--blox-border-input-invalid--focus);
}
input.blox:not(.hidden-form-control)[type=file]::-webkit-file-upload-button {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  -webkit-transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  background-color: transparent;
  border: none;
  color: var(--blox-slate3);
  cursor: pointer;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  margin: 0 5px 0 0;
  padding: 0;
}
input.blox:not(.hidden-form-control)[type=file]::-webkit-file-upload-button:hover {
  color: var(--blox-slate3--hover);
}
input.blox:not(.hidden-form-control)[type=file]::-webkit-file-upload-button:active {
  color: var(--blox-slate3--active);
}
input.blox:not(.hidden-form-control)[type=image] {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  --font-size: 14px;
  box-sizing: border-box;
  color: var(--blox-slate3);
  cursor: pointer;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  outline: revert;
  padding: 0;
  -webkit-text-decoration: revert;
          text-decoration: revert;
  vertical-align: revert;
}
input.blox:not(.hidden-form-control)[type=image]:hover:enabled {
  color: var(--blox-slate3--hover);
}
input.blox:not(.hidden-form-control)[type=image]:active:enabled {
  color: var(--blox-slate3--active);
}
input.blox:not(.hidden-form-control)[type=image]:focus-visible:enabled {
  outline: 2px solid var(--blox-blue);
  outline-offset: 2px;
}
input.blox:not(.hidden-form-control)[type=image]:disabled {
  background-color: transparent;
}
input.blox:not(.hidden-form-control)[type=range] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  padding: 5px 10px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]:focus-visible {
  outline: 2px solid var(--blox-blue);
  outline-offset: 4px;
}
input.blox:not(.hidden-form-control)[type=range]:disabled {
  background-color: transparent;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-moz-range-track, input.blox:not(.hidden-form-control)[type=range]:disabled::-moz-range-thumb {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-moz-range-thumb {
  background-color: var(--blox-background-input--disabled);
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-ms-track, input.blox:not(.hidden-form-control)[type=range]:disabled::-ms-thumb {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-ms-thumb {
  background-color: var(--blox-background-input--disabled);
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-webkit-slider-runnable-track, input.blox:not(.hidden-form-control)[type=range]:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-webkit-slider-thumb {
  background-color: var(--blox-background-input--disabled);
}
input.blox:not(.hidden-form-control)[type=range]::-moz-range-track {
  background: var(--blox-blue);
  border-radius: 8.4px;
  cursor: pointer;
  height: 8.4px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]::-ms-track {
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
  cursor: pointer;
  height: 8.4px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]::-ms-fill-lower, input.blox:not(.hidden-form-control)[type=range]::-ms-fill-upper {
  background: var(--blox-blue);
  border-radius: var(--blox-border-radius);
}
input.blox:not(.hidden-form-control)[type=range]::-webkit-slider-runnable-track {
  background: var(--blox-blue);
  border-radius: 8.4px;
  cursor: pointer;
  height: 8.4px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]::-moz-range-thumb {
  background: white;
  border-radius: var(--blox-border-radius);
  cursor: pointer;
  height: 24px;
  width: 15px;
}
input.blox:not(.hidden-form-control)[type=range]::-ms-thumb {
  background: white;
  cursor: pointer;
  height: 24px;
  width: 15px;
}
input.blox:not(.hidden-form-control)[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
  background: white;
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  cursor: pointer;
  height: 24px;
  margin-top: -8px;
  width: 15px;
}

/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
label.blox {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  --font-size: var(--blox-font-size-md);
  border: revert;
  color: var(--blox-slate5);
  cursor: default;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  font-weight: var(--blox-font-weight-400);
  line-height: var(--blox-line-height);
  outline: revert;
  padding: revert;
  -webkit-text-decoration: revert;
          text-decoration: revert;
  vertical-align: revert;
}

/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
textarea.blox {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  cursor: text;
  outline: revert;
  padding: 10px 20px;
}
textarea.blox:hover:enabled {
  border: var(--blox-border-input--hover);
}
textarea.blox:focus:enabled {
  border: var(--blox-border-input--focus);
  outline: none;
}
textarea.blox:invalid:not(.hide-invalid), textarea.blox[aria-invalid=true]:not(.hide-invalid) {
  border: var(--blox-border-input-invalid);
}
textarea.blox:invalid:not(.hide-invalid):hover:enabled, textarea.blox[aria-invalid=true]:not(.hide-invalid):hover:enabled {
  border: var(--blox-border-input-invalid--hover);
}
textarea.blox:invalid:not(.hide-invalid):focus:enabled, textarea.blox[aria-invalid=true]:not(.hide-invalid):focus:enabled {
  border: var(--blox-border-input-invalid--focus);
}
textarea.blox:disabled {
  background-color: var(--blox-background-input--disabled);
  cursor: not-allowed;
  opacity: 0.5;
  outline: none;
}`));var fo,Lt,Rt,xo,xt=globalThis.trustedTypes,vo=xt?xt.createPolicy("lit-html",{createHTML:t=>t}):void 0,he=`lit$${(Math.random()+"").slice(9)}$`,mo="?"+he,ti=`<${mo}>`,Ae=document,Xe=(t="")=>Ae.createComment(t),vt=t=>t===null||typeof t!="object"&&typeof t!="function",yo=Array.isArray,oi=t=>{var e;return yo(t)||typeof((e=t)===null||e===void 0?void 0:e[Symbol.iterator])=="function"},Ye=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,go=/-->/g,wo=/>/g,ke=/>|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,ko=/'/g,So=/"/g,zo=/^(?:script|style|textarea)$/i,ni=t=>(e,...o)=>({_$litType$:t,strings:e,values:o}),c=ni(1),B=Symbol.for("lit-noChange"),j=Symbol.for("lit-nothing"),Eo=new WeakMap,Ge=(t,e,o)=>{var n,i;let r=(n=o==null?void 0:o.renderBefore)!==null&&n!==void 0?n:e,l=r._$litPart$;if(l===void 0){let a=(i=o==null?void 0:o.renderBefore)!==null&&i!==void 0?i:null;r._$litPart$=l=new Pe(e.insertBefore(Xe(),a),a,void 0,o)}return l.I(t),l},Le=Ae.createTreeWalker(Ae,129,null,!1),ii=(t,e)=>{let o=t.length-1,n=[],i,r=e===2?"<svg>":"",l=Ye;for(let s=0;s<o;s++){let b=t[s],p,u,h=-1,f=0;for(;f<b.length&&(l.lastIndex=f,u=l.exec(b),u!==null);)f=l.lastIndex,l===Ye?u[1]==="!--"?l=go:u[1]!==void 0?l=wo:u[2]!==void 0?(zo.test(u[2])&&(i=RegExp("</"+u[2],"g")),l=ke):u[3]!==void 0&&(l=ke):l===ke?u[0]===">"?(l=i!=null?i:Ye,h=-1):u[1]===void 0?h=-2:(h=l.lastIndex-u[2].length,p=u[1],l=u[3]===void 0?ke:u[3]==='"'?So:ko):l===So||l===ko?l=ke:l===go||l===wo?l=Ye:(l=ke,i=void 0);let y=l===ke&&t[s+1].startsWith("/>")?" ":"";r+=l===Ye?b+ti:h>=0?(n.push(p),b.slice(0,h)+"$lit$"+b.slice(h)+he+y):b+he+(h===-2?(n.push(void 0),s):y)}let a=r+(t[o]||"<?>")+(e===2?"</svg>":"");return[vo!==void 0?vo.createHTML(a):a,n]},Re=class{constructor({strings:e,_$litType$:o},n){let i;this.parts=[];let r=0,l=0,a=e.length-1,s=this.parts,[b,p]=ii(e,o);if(this.el=Re.createElement(b,n),Le.currentNode=this.el.content,o===2){let u=this.el.content,h=u.firstChild;h.remove(),u.append(...h.childNodes)}for(;(i=Le.nextNode())!==null&&s.length<a;){if(i.nodeType===1){if(i.hasAttributes()){let u=[];for(let h of i.getAttributeNames())if(h.endsWith("$lit$")||h.startsWith(he)){let f=p[l++];if(u.push(h),f!==void 0){let y=i.getAttribute(f.toLowerCase()+"$lit$").split(he),z=/([.?@])?(.*)/.exec(f);s.push({type:1,index:r,name:z[2],strings:y,ctor:z[1]==="."?Co:z[1]==="?"?Oo:z[1]==="@"?$o:Je})}else s.push({type:6,index:r})}for(let h of u)i.removeAttribute(h)}if(zo.test(i.tagName)){let u=i.textContent.split(he),h=u.length-1;if(h>0){i.textContent=xt?xt.emptyScript:"";for(let f=0;f<h;f++)i.append(u[f],Xe()),Le.nextNode(),s.push({type:2,index:++r});i.append(u[h],Xe())}}}else if(i.nodeType===8)if(i.data===mo)s.push({type:2,index:r});else{let u=-1;for(;(u=i.data.indexOf(he,u+1))!==-1;)s.push({type:7,index:r}),u+=he.length-1}r++}}static createElement(e,o){let n=Ae.createElement("template");return n.innerHTML=e,n}};function De(t,e,o=t,n){var i,r,l,a;if(e===B)return e;let s=n!==void 0?(i=o.Σi)===null||i===void 0?void 0:i[n]:o.Σo,b=vt(e)?void 0:e._$litDirective$;return(s==null?void 0:s.constructor)!==b&&((r=s==null?void 0:s.O)===null||r===void 0||r.call(s,!1),b===void 0?s=void 0:(s=new b(t),s.T(t,o,n)),n!==void 0?((l=(a=o).Σi)!==null&&l!==void 0?l:a.Σi=[])[n]=s:o.Σo=s),s!==void 0&&(e=De(t,s.S(t,e.values),s,n)),e}var jo=class{constructor(e,o){this.l=[],this.N=void 0,this.D=e,this.M=o}u(e){var o;let{el:{content:n},parts:i}=this.D,r=((o=e==null?void 0:e.creationScope)!==null&&o!==void 0?o:Ae).importNode(n,!0);Le.currentNode=r;let l=Le.nextNode(),a=0,s=0,b=i[0];for(;b!==void 0;){if(a===b.index){let p;b.type===2?p=new Pe(l,l.nextSibling,this,e):b.type===1?p=new b.ctor(l,b.name,b.strings,this,e):b.type===6&&(p=new To(l,this,e)),this.l.push(p),b=i[++s]}a!==(b==null?void 0:b.index)&&(l=Le.nextNode(),a++)}return r}v(e){let o=0;for(let n of this.l)n!==void 0&&(n.strings!==void 0?(n.I(e,n,o),o+=n.strings.length-2):n.I(e[o])),o++}},Pe=class{constructor(e,o,n,i){this.type=2,this.N=void 0,this.A=e,this.B=o,this.M=n,this.options=i}setConnected(e){var o;(o=this.P)===null||o===void 0||o.call(this,e)}get parentNode(){return this.A.parentNode}get startNode(){return this.A}get endNode(){return this.B}I(e,o=this){e=De(this,e,o),vt(e)?e===j||e==null||e===""?(this.H!==j&&this.R(),this.H=j):e!==this.H&&e!==B&&this.m(e):e._$litType$!==void 0?this._(e):e.nodeType!==void 0?this.$(e):oi(e)?this.g(e):this.m(e)}k(e,o=this.B){return this.A.parentNode.insertBefore(e,o)}$(e){this.H!==e&&(this.R(),this.H=this.k(e))}m(e){let o=this.A.nextSibling;o!==null&&o.nodeType===3&&(this.B===null?o.nextSibling===null:o===this.B.previousSibling)?o.data=e:this.$(Ae.createTextNode(e)),this.H=e}_(e){var o;let{values:n,_$litType$:i}=e,r=typeof i=="number"?this.C(e):(i.el===void 0&&(i.el=Re.createElement(i.h,this.options)),i);if(((o=this.H)===null||o===void 0?void 0:o.D)===r)this.H.v(n);else{let l=new jo(r,this),a=l.u(this.options);l.v(n),this.$(a),this.H=l}}C(e){let o=Eo.get(e.strings);return o===void 0&&Eo.set(e.strings,o=new Re(e)),o}g(e){yo(this.H)||(this.H=[],this.R());let o=this.H,n,i=0;for(let r of e)i===o.length?o.push(n=new Pe(this.k(Xe()),this.k(Xe()),this,this.options)):n=o[i],n.I(r),i++;i<o.length&&(this.R(n&&n.B.nextSibling,i),o.length=i)}R(e=this.A.nextSibling,o){var n;for((n=this.P)===null||n===void 0||n.call(this,!1,!0,o);e&&e!==this.B;){let i=e.nextSibling;e.remove(),e=i}}},Je=class{constructor(e,o,n,i,r){this.type=1,this.H=j,this.N=void 0,this.V=void 0,this.element=e,this.name=o,this.M=i,this.options=r,n.length>2||n[0]!==""||n[1]!==""?(this.H=Array(n.length-1).fill(j),this.strings=n):this.H=j}get tagName(){return this.element.tagName}I(e,o=this,n,i){let r=this.strings,l=!1;if(r===void 0)e=De(this,e,o,0),l=!vt(e)||e!==this.H&&e!==B,l&&(this.H=e);else{let a=e,s,b;for(e=r[0],s=0;s<r.length-1;s++)b=De(this,a[n+s],o,s),b===B&&(b=this.H[s]),l||(l=!vt(b)||b!==this.H[s]),b===j?e=j:e!==j&&(e+=(b!=null?b:"")+r[s+1]),this.H[s]=b}l&&!i&&this.W(e)}W(e){e===j?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,e!=null?e:"")}},Co=class extends Je{constructor(){super(...arguments),this.type=3}W(e){this.element[this.name]=e===j?void 0:e}},Oo=class extends Je{constructor(){super(...arguments),this.type=4}W(e){e&&e!==j?this.element.setAttribute(this.name,""):this.element.removeAttribute(this.name)}},$o=class extends Je{constructor(){super(...arguments),this.type=5}I(e,o=this){var n;if((e=(n=De(this,e,o,0))!==null&&n!==void 0?n:j)===B)return;let i=this.H,r=e===j&&i!==j||e.capture!==i.capture||e.once!==i.once||e.passive!==i.passive,l=e!==j&&(i===j||r);r&&this.element.removeEventListener(this.name,this,i),l&&this.element.addEventListener(this.name,this,e),this.H=e}handleEvent(e){var o,n;typeof this.H=="function"?this.H.call((n=(o=this.options)===null||o===void 0?void 0:o.host)!==null&&n!==void 0?n:this.element,e):this.H.handleEvent(e)}},To=class{constructor(e,o,n){this.element=e,this.type=6,this.N=void 0,this.V=void 0,this.M=o,this.options=n}I(e){De(this,e)}};(Lt=(fo=globalThis).litHtmlPlatformSupport)===null||Lt===void 0||Lt.call(fo,Re,Pe),((Rt=(xo=globalThis).litHtmlVersions)!==null&&Rt!==void 0?Rt:xo.litHtmlVersions=[]).push("2.0.0-rc.3");var Dt=window.ShadowRoot&&(window.ShadyCSS===void 0||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,_o=Symbol(),Ao=class{constructor(e,o){if(o!==_o)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=e}get styleSheet(){return Dt&&this.t===void 0&&(this.t=new CSSStyleSheet,this.t.replaceSync(this.cssText)),this.t}toString(){return this.cssText}},Po=new Map,ri=t=>{let e=Po.get(t);return e===void 0&&Po.set(t,e=new Ao(t,_o)),e},li=t=>ri(typeof t=="string"?t:t+""),ai=(t,e)=>{Dt?t.adoptedStyleSheets=e.map(o=>o instanceof CSSStyleSheet?o:o.styleSheet):e.forEach(o=>{let n=document.createElement("style");n.textContent=o.cssText,t.appendChild(n)})},Lo=Dt?t=>t:t=>t instanceof CSSStyleSheet?(e=>{let o="";for(let n of e.cssRules)o+=n.cssText;return li(o)})(t):t;var Ro,Mt,Bt,Do,Ht={toAttribute(t,e){switch(e){case Boolean:t=t?"":null;break;case Object:case Array:t=t==null?t:JSON.stringify(t)}return t},fromAttribute(t,e){let o=t;switch(e){case Boolean:o=t!==null;break;case Number:o=t===null?null:Number(t);break;case Object:case Array:try{o=JSON.parse(t)}catch(n){o=null}}return o}},Mo=(t,e)=>e!==t&&(e==e||t==t),Vt={attribute:!0,type:String,converter:Ht,reflect:!1,hasChanged:Mo},Se=class extends HTMLElement{constructor(){super(),this.Πi=new Map,this.Πo=void 0,this.Πl=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this.Πh=null,this.u()}static addInitializer(e){var o;(o=this.v)!==null&&o!==void 0||(this.v=[]),this.v.push(e)}static get observedAttributes(){this.finalize();let e=[];return this.elementProperties.forEach((o,n)=>{let i=this.Πp(n,o);i!==void 0&&(this.Πm.set(i,n),e.push(i))}),e}static createProperty(e,o=Vt){if(o.state&&(o.attribute=!1),this.finalize(),this.elementProperties.set(e,o),!o.noAccessor&&!this.prototype.hasOwnProperty(e)){let n=typeof e=="symbol"?Symbol():"__"+e,i=this.getPropertyDescriptor(e,n,o);i!==void 0&&Object.defineProperty(this.prototype,e,i)}}static getPropertyDescriptor(e,o,n){return{get(){return this[o]},set(i){let r=this[e];this[o]=i,this.requestUpdate(e,r,n)},configurable:!0,enumerable:!0}}static getPropertyOptions(e){return this.elementProperties.get(e)||Vt}static finalize(){if(this.hasOwnProperty("finalized"))return!1;this.finalized=!0;let e=Object.getPrototypeOf(this);if(e.finalize(),this.elementProperties=new Map(e.elementProperties),this.Πm=new Map,this.hasOwnProperty("properties")){let o=this.properties,n=[...Object.getOwnPropertyNames(o),...Object.getOwnPropertySymbols(o)];for(let i of n)this.createProperty(i,o[i])}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(e){let o=[];if(Array.isArray(e)){let n=new Set(e.flat(1/0).reverse());for(let i of n)o.unshift(Lo(i))}else e!==void 0&&o.push(Lo(e));return o}static Πp(e,o){let n=o.attribute;return n===!1?void 0:typeof n=="string"?n:typeof e=="string"?e.toLowerCase():void 0}u(){var e;this.Πg=new Promise(o=>this.enableUpdating=o),this.L=new Map,this.Π_(),this.requestUpdate(),(e=this.constructor.v)===null||e===void 0||e.forEach(o=>o(this))}addController(e){var o,n;((o=this.ΠU)!==null&&o!==void 0?o:this.ΠU=[]).push(e),this.renderRoot!==void 0&&this.isConnected&&((n=e.hostConnected)===null||n===void 0||n.call(e))}removeController(e){var o;(o=this.ΠU)===null||o===void 0||o.splice(this.ΠU.indexOf(e)>>>0,1)}Π_(){this.constructor.elementProperties.forEach((e,o)=>{this.hasOwnProperty(o)&&(this.Πi.set(o,this[o]),delete this[o])})}createRenderRoot(){var e;let o=(e=this.shadowRoot)!==null&&e!==void 0?e:this.attachShadow(this.constructor.shadowRootOptions);return ai(o,this.constructor.elementStyles),o}connectedCallback(){var e;this.renderRoot===void 0&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),(e=this.ΠU)===null||e===void 0||e.forEach(o=>{var n;return(n=o.hostConnected)===null||n===void 0?void 0:n.call(o)}),this.Πl&&(this.Πl(),this.Πo=this.Πl=void 0)}enableUpdating(e){}disconnectedCallback(){var e;(e=this.ΠU)===null||e===void 0||e.forEach(o=>{var n;return(n=o.hostDisconnected)===null||n===void 0?void 0:n.call(o)}),this.Πo=new Promise(o=>this.Πl=o)}attributeChangedCallback(e,o,n){this.K(e,n)}Πj(e,o,n=Vt){var i,r;let l=this.constructor.Πp(e,n);if(l!==void 0&&n.reflect===!0){let a=((r=(i=n.converter)===null||i===void 0?void 0:i.toAttribute)!==null&&r!==void 0?r:Ht.toAttribute)(o,n.type);this.Πh=e,a==null?this.removeAttribute(l):this.setAttribute(l,a),this.Πh=null}}K(e,o){var n,i,r;let l=this.constructor,a=l.Πm.get(e);if(a!==void 0&&this.Πh!==a){let s=l.getPropertyOptions(a),b=s.converter,p=(r=(i=(n=b)===null||n===void 0?void 0:n.fromAttribute)!==null&&i!==void 0?i:typeof b=="function"?b:null)!==null&&r!==void 0?r:Ht.fromAttribute;this.Πh=a,this[a]=p(o,s.type),this.Πh=null}}requestUpdate(e,o,n){let i=!0;e!==void 0&&(((n=n||this.constructor.getPropertyOptions(e)).hasChanged||Mo)(this[e],o)?(this.L.has(e)||this.L.set(e,o),n.reflect===!0&&this.Πh!==e&&(this.Πk===void 0&&(this.Πk=new Map),this.Πk.set(e,n))):i=!1),!this.isUpdatePending&&i&&(this.Πg=this.Πq())}Πq(){return ho(this,null,function*(){this.isUpdatePending=!0;try{for(yield this.Πg;this.Πo;)yield this.Πo}catch(o){Promise.reject(o)}let e=this.performUpdate();return e!=null&&(yield e),!this.isUpdatePending})}performUpdate(){var e;if(!this.isUpdatePending)return;this.hasUpdated,this.Πi&&(this.Πi.forEach((i,r)=>this[r]=i),this.Πi=void 0);let o=!1,n=this.L;try{o=this.shouldUpdate(n),o?(this.willUpdate(n),(e=this.ΠU)===null||e===void 0||e.forEach(i=>{var r;return(r=i.hostUpdate)===null||r===void 0?void 0:r.call(i)}),this.update(n)):this.Π$()}catch(i){throw o=!1,this.Π$(),i}o&&this.E(n)}willUpdate(e){}E(e){var o;(o=this.ΠU)===null||o===void 0||o.forEach(n=>{var i;return(i=n.hostUpdated)===null||i===void 0?void 0:i.call(n)}),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(e)),this.updated(e)}Π$(){this.L=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this.Πg}shouldUpdate(e){return!0}update(e){this.Πk!==void 0&&(this.Πk.forEach((o,n)=>this.Πj(n,this[n],o)),this.Πk=void 0),this.Π$()}updated(e){}firstUpdated(e){}};Se.finalized=!0,Se.elementProperties=new Map,Se.elementStyles=[],Se.shadowRootOptions={mode:"open"},(Mt=(Ro=globalThis).reactiveElementPlatformSupport)===null||Mt===void 0||Mt.call(Ro,{ReactiveElement:Se}),((Bt=(Do=globalThis).reactiveElementVersions)!==null&&Bt!==void 0?Bt:Do.reactiveElementVersions=[]).push("1.0.0-rc.2");var Nt,Bo,It,Ho,Ft,Vo;((Nt=(Vo=globalThis).litElementVersions)!==null&&Nt!==void 0?Nt:Vo.litElementVersions=[]).push("3.0.0-rc.2");var m=class extends Se{constructor(){super(...arguments),this.renderOptions={host:this},this.Φt=void 0}createRenderRoot(){var e,o;let n=super.createRenderRoot();return(e=(o=this.renderOptions).renderBefore)!==null&&e!==void 0||(o.renderBefore=n.firstChild),n}update(e){let o=this.render();super.update(e),this.Φt=Ge(o,this.renderRoot,this.renderOptions)}connectedCallback(){var e;super.connectedCallback(),(e=this.Φt)===null||e===void 0||e.setConnected(!0)}disconnectedCallback(){var e;super.disconnectedCallback(),(e=this.Φt)===null||e===void 0||e.setConnected(!1)}render(){return B}};m.finalized=!0,m._$litElement$=!0,(It=(Bo=globalThis).litElementHydrateSupport)===null||It===void 0||It.call(Bo,{LitElement:m}),(Ft=(Ho=globalThis).litElementPlatformSupport)===null||Ft===void 0||Ft.call(Ho,{LitElement:m});var w=t=>e=>typeof e=="function"?((o,n)=>(window.customElements.define(o,n),n))(t,e):((o,n)=>{let{kind:i,elements:r}=n;return{kind:i,elements:r,finisher(l){window.customElements.define(o,l)}}})(t,e);var si=(t,e)=>e.kind==="method"&&e.descriptor&&!("value"in e.descriptor)?ue(ue({},e),{finisher(o){o.createProperty(e.key,t)}}):{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){typeof e.initializer=="function"&&(this[e.key]=e.initializer.call(this))},finisher(o){o.createProperty(e.key,t)}};function d(t){return(e,o)=>o!==void 0?((n,i,r)=>{i.constructor.createProperty(r,n)})(t,e,o):si(t,e)}function Me(t){return d(ue(ue({},t),{state:!0,attribute:!1}))}var Be={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},He=t=>(...e)=>({_$litDirective$:t,values:e}),ze=class{constructor(e){}T(e,o,n){this.Σdt=e,this.M=o,this.Σct=n}S(e,o){return this.update(e,o)}update(e,o){return this.render(...o)}};var S=He(class extends ze{constructor(t){var e;if(super(t),t.type!==Be.ATTRIBUTE||t.name!=="class"||((e=t.strings)===null||e===void 0?void 0:e.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return Object.keys(t).filter(e=>t[e]).join(" ")}update(t,[e]){if(this.bt===void 0){this.bt=new Set;for(let n in e)e[n]&&this.bt.add(n);return this.render(e)}let o=t.element.classList;this.bt.forEach(n=>{n in e||(o.remove(n),this.bt.delete(n))});for(let n in e){let i=!!e[n];i!==this.bt.has(n)&&(i?(o.add(n),this.bt.add(n)):(o.remove(n),this.bt.delete(n)))}return B}});var di=t=>t.strings===void 0;var Ze=(t,e)=>{var o,n;let i=t.N;if(i===void 0)return!1;for(let r of i)(n=(o=r).O)===null||n===void 0||n.call(o,e,!1),Ze(r,e);return!0},mt=t=>{let e,o;do{if((e=t.M)===void 0)break;o=e.N,o.delete(t),t=e}while((o==null?void 0:o.size)===0)},No=t=>{for(let e;e=t.M;t=e){let o=e.N;if(o===void 0)e.N=o=new Set;else if(o.has(t))break;o.add(t),bi(e)}};function pi(t){this.N!==void 0?(mt(this),this.M=t,No(this)):this.M=t}function ci(t,e=!1,o=0){let n=this.H,i=this.N;if(i!==void 0&&i.size!==0)if(e)if(Array.isArray(n))for(let r=o;r<n.length;r++)Ze(n[r],!1),mt(n[r]);else n!=null&&(Ze(n,!1),mt(n));else Ze(this,t)}var bi=t=>{var e,o,n,i;t.type==Be.CHILD&&((e=(n=t).P)!==null&&e!==void 0||(n.P=ci),(o=(i=t).Q)!==null&&o!==void 0||(i.Q=pi))},Io=class extends ze{constructor(){super(...arguments),this.isConnected=!0,this.ut=B,this.N=void 0}T(e,o,n){super.T(e,o,n),No(this)}O(e,o=!0){this.at(e),o&&(Ze(this,e),mt(this))}at(e){var o,n;e!==this.isConnected&&(e?(this.isConnected=!0,this.ut!==B&&(this.setValue(this.ut),this.ut=B),(o=this.reconnected)===null||o===void 0||o.call(this)):(this.isConnected=!1,(n=this.disconnected)===null||n===void 0||n.call(this)))}S(e,o){if(!this.isConnected)throw Error(`AsyncDirective ${this.constructor.name} was rendered while its tree was disconnected.`);return super.S(e,o)}setValue(e){if(this.isConnected)if(di(this.Σdt))this.Σdt.I(e,this);else{let o=[...this.Σdt.H];o[this.Σct]=e,this.Σdt.I(o,this,0)}else this.ut=e}disconnected(){}reconnected(){}};var A=()=>new Fo,Fo=class{},Ut=new WeakMap,P=He(class extends Io{render(t){return j}update(t,[e]){var o;let n=e!==this.gt;return n&&this.gt!==void 0&&this.xt(void 0),(n||this.Tt!==this.Et)&&(this.gt=e,this.At=(o=t.options)===null||o===void 0?void 0:o.host,this.xt(this.Et=t.element)),j}xt(t){typeof this.gt=="function"?(Ut.get(this.gt)!==void 0&&this.gt.call(this.At,void 0),Ut.set(this.gt,t),t!==void 0&&this.gt.call(this.At,t)):this.gt.value=t}get Tt(){var t;return typeof this.gt=="function"?Ut.get(this.gt):(t=this.gt)===null||t===void 0?void 0:t.value}disconnected(){this.Tt===this.Et&&this.xt(void 0)}reconnected(){this.xt(this.Et)}});var Ll=`{{lit-${String(Math.random()).slice(2)}}}`;var Rl=window.trustedTypes&&trustedTypes.createPolicy("lit-html",{createHTML:t=>t});var ui=!1;(()=>{try{let t={get capture(){return ui=!0,!1}};window.addEventListener("test",t,t),window.removeEventListener("test",t,t)}catch(t){}})();typeof window!="undefined"&&(window.litHtmlVersions||(window.litHtmlVersions=[])).push("1.4.1");typeof window.ShadyCSS=="undefined"||typeof window.ShadyCSS.prepareTemplateDom=="undefined"&&console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1.");window.JSCompiler_renameProperty=(t,e)=>t;var hi=window.ShadowRoot&&(window.ShadyCSS===void 0||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,Uo=Symbol(),qt=class{constructor(e,o){if(o!==Uo)throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=e}get styleSheet(){return this._styleSheet===void 0&&(hi?(this._styleSheet=new CSSStyleSheet,this._styleSheet.replaceSync(this.cssText)):this._styleSheet=null),this._styleSheet}toString(){return this.cssText}},fi=t=>{if(t instanceof qt)return t.cssText;if(typeof t=="number")return t;throw new Error(`Value passed to 'css' function must be a 'css' function result: ${t}. Use 'unsafeCSS' to pass non-literal values, but
            take care to ensure page security.`)},g=(t,...e)=>{let o=e.reduce((n,i,r)=>n+fi(i)+t[r+1],t[0]);return new qt(o,Uo)};(window.litElementVersions||(window.litElementVersions=[])).push("2.5.1");var qo=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --body-padding: 40px 60px;
  --border-radius: var(--blox-border-radius);
  --max-width: 500px;
  --z-index: 99;
  font-family: var(--blox-font-family);
}

.component-container {
  background-color: rgba(224, 228, 235, 0.7);
  box-sizing: border-box;
  height: 100%;
  left: 0;
  overflow-y: scroll;
  padding: 20px;
  position: fixed;
  top: 0;
  visibility: hidden;
  width: 100%;
  z-index: var(--z-index);
}

.show {
  visibility: visible;
}

.alert {
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.1);
  color: var(--blox-slate5);
  left: 50%;
  margin: 0 auto;
  max-width: var(--max-width);
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px);
}

.header {
  align-items: center;
  background-color: var(--blox-red);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  display: flex;
  justify-content: center;
  padding: 14px 15px 16px;
}
.header h2 {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-xl);
  font-weight: var(--blox-font-weight-400);
  box-sizing: border-box;
  color: white;
  margin: 0;
  padding: 0;
  text-align: center;
}

.body {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  box-sizing: border-box;
  margin: 0;
  padding: var(--body-padding);
  text-align: left;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-end;
  padding: 0 15px 15px;
}
.actions button {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  transition: "background-color" var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  background-color: var(--blox-red);
  border: none;
  border-radius: var(--blox-border-radius);
  color: white;
  cursor: pointer;
  letter-spacing: inherit;
  max-width: 150px;
  padding: 12px 20px 14px;
  width: 150px;
  word-spacing: inherit;
}
.actions button:hover:enabled {
  background-color: var(--blox-red--hover);
}
.actions button:active:enabled {
  background-color: var(--blox-red--active);
}
.actions button:focus {
  outline: 2px solid var(--blox-blue);
}
.actions button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.actions button#secondary {
  background-color: white;
  border: 2px solid var(--blox-slate3);
  box-sizing: border-box;
  color: var(--blox-slate3);
  padding: 12px 20px 14px;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function);
}
.actions button#secondary:hover:enabled {
  background-color: var(--blox-slate3--hover);
  border: 2px solid var(--blox-slate3--hover);
  color: white;
}
.actions button#secondary:active:enabled {
  background-color: var(--blox-slate3--active);
  border: 2px solid var(--blox-slate3--active);
  color: white;
}

@media (max-width: 384px) {
  .body {
    padding: 30px;
  }

  .actions {
    justify-content: center;
  }
}`;var xi=Object.defineProperty,vi=Object.getOwnPropertyDescriptor,te=(t,e,o,n)=>{for(var i=n>1?void 0:n?vi(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&xi(e,o,i),i},N=class extends m{constructor(){super(...arguments);this.actionPrimary="Yes",this.actionPrimaryDisabled=!1,this.actionSecondary="",this.actionSecondaryDisabled=!1,this.content="",this.focusOnCloseQuery="",this.focusOnOpenQuery="",this.header="Are you sure?",this.show=!1,this.actionPrimaryRef=A(),this.actionSecondaryRef=A()}firstUpdated(){if(this.show){let t=this.getFocusOnOpenElement();if(!t)return;t.focus()}}updated(t){var e;if(!this.content&&this.getSlottedElements().length===0&&console.error('A <blox-alert> has no body content! Fix: Either provide the content="string" attribute or a slotted element.'),t.has("show")){if(this.show){let o=this.getFocusOnOpenElement();if(!o)return;o.focus()}t.get("show")&&this.focusOnCloseQuery&&((e=document.querySelector(this.focusOnCloseQuery))==null||e.focus())}}emitActionEvent(t){let e=`action-${t}`,o=new CustomEvent(e,{bubbles:!0,detail:e});this.dispatchEvent(o)}handleActionClick(t){let e=t.target;this.emitActionEvent(e.id)}handleKeyDown(t){var o;let e=this.getFirstFocusableElement();!e||(t.target===e&&t.shiftKey&&t.key==="Tab"&&(t.preventDefault(),(o=this.actionPrimaryRef.value)==null||o.focus()),!t.shiftKey&&t.key==="Tab"&&t.target&&t.target.id==="primary"&&(t.preventDefault(),e.focus()))}handleKeyUp(t){t.key==="Escape"&&this.emitActionEvent("secondary")}handleSlotChange(){this.getSlottedElements().length===0&&!this.content&&console.error('A <blox-alert> has no body content! Fix: Either provide the content="string" attribute or a slotted element.')}getFirstFocusableElement(){let t=this.getSlottedElement('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');return t||(this.actionSecondary?this.actionSecondaryRef.value:this.actionPrimaryRef.value)}getFocusOnOpenElement(){if(this.focusOnOpenQuery){let t=this.getSlottedElement(this.focusOnOpenQuery);if(t)return t}else if(this.actionSecondary)return this.actionSecondaryRef.value;return this.actionPrimaryRef.value}getSlottedElement(t){for(let e of this.getSlottedElements()){if(e.matches(t))return e;let o=e.querySelector(t);if(o)return o}}getSlottedElements(){var e;let t=(e=this.shadowRoot)==null?void 0:e.querySelector("slot");return t?t.assignedElements({flatten:!0}):[]}render(){return c`
            <div
                class=${S({"component-container":!0,show:this.show})}
                @keyup=${this.handleKeyUp}
            >
                <div
                    aria-describedby='alert-body'
                    aria-labelledby='alert-header'
                    aria-modal='true'
                    class='alert'
                    role='alertdialog'
                >
                    <div class='header'>
                        <h2 id='alert-header'>${this.header}</h2>
                    </div>

                    <div class='body' id='alert-body'>
                        ${this.content?this.content:c`<slot @keydown=${this.handleKeyDown} @slotchange=${this.handleSlotChange}></slot>`}
                    </div>

                    <div class='actions' @keydown=${this.handleKeyDown}>
                        ${this.actionSecondary?c`
                            <button
                                ${P(this.actionSecondaryRef)}
                                @click=${this.handleActionClick}
                                ?disabled=${this.actionSecondaryDisabled}
                                id='secondary'
                            >${this.actionSecondary}</button>`:null}
                        <button
                            ${P(this.actionPrimaryRef)}
                            @click=${this.handleActionClick}
                            ?disabled=${this.actionPrimaryDisabled}
                            id='primary'
                        >${this.actionPrimary}</button>
                    </div>
                </div>
            </div>
        `}};N.styles=[qo];te([d({attribute:"action-primary",type:String})],N.prototype,"actionPrimary",2);te([d({attribute:"action-primary-disabled",type:Boolean})],N.prototype,"actionPrimaryDisabled",2);te([d({attribute:"action-secondary",type:String})],N.prototype,"actionSecondary",2);te([d({attribute:"action-secondary-disabled",type:Boolean})],N.prototype,"actionSecondaryDisabled",2);te([d({type:String})],N.prototype,"content",2);te([d({attribute:"focus-on-close",type:String})],N.prototype,"focusOnCloseQuery",2);te([d({attribute:"focus-on-open",type:String})],N.prototype,"focusOnOpenQuery",2);te([d({type:String})],N.prototype,"header",2);te([d({reflect:!0,type:Boolean})],N.prototype,"show",2);N=te([w("blox-alert")],N);var Wo=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --container-width: 100%;
  --text-max-width: 600px;
  --padding: 10px 20px;
  font-family: var(--blox-font-family);
  width: 100%;
}

.component-container {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  background-color: white;
  box-sizing: border-box;
  height: auto;
  padding: var(--padding);
  width: var(--container-width);
}

.scroll-x {
  overflow-x: auto;
}

ol {
  display: flex;
  flex-wrap: nowrap;
  list-style: none;
  margin: 0;
  padding: 0;
}
ol.wrap {
  flex-wrap: wrap;
}

::slotted(blox-breadcrumb-item:not(:last-child))::after,
li:not(:last-of-type)::after {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  content: "/";
  display: inline-block;
  margin: 0 10px;
}

.level-container {
  display: flex;
  max-width: var(--text-max-width);
  min-width: 6ch;
  overflow: hidden;
}
.level-container a {
  color: var(--blox-blue);
  text-decoration: none;
}
.level-container a:active {
  color: var(--blox-blue--active);
}
.level-container a:hover {
  color: var(--blox-blue--hover);
}
.level-container span {
  color: var(--blox-slate4);
}
.level-container a,
.level-container span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multiline {
  flex-wrap: wrap;
}

.separator {
  color: var(--blox-slate4);
  margin: 0 10px;
}`;var mi=Object.defineProperty,yi=Object.getOwnPropertyDescriptor,Ve=(t,e,o,n)=>{for(var i=n>1?void 0:n?yi(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&mi(e,o,i),i},ae=class extends m{constructor(){super(...arguments);this.truncateIndex=0,this.levels=[],this.multiline=!1,this.wrap=!1,this.scrollX=!1}updated(t){t.has("truncateIndex")&&this.truncateIndex>=this.levels.length&&console.warn("A <blox-breadcrumb> `truncate-index` level matches or exceeds the `levels` length value (and was reset to `0` as a result). Fix: The `truncate-index` value must be less than the `levels` length value.")}handleSlotChange(){Array.from(this.children).forEach(t=>{t.nodeName.toLowerCase()!=="blox-breadcrumb-item"&&console.warn("No <blox-breadcrumb-item> elements were found inside a <blox-breadcrumb>. Using the 'levels' attribute has been deprecated.")})}_showLevel(t,e,o){if(e<this.levels.length-1){let n=e<o?"...":t.name;return c`
                <li class='level-container'>
                    <a title=${t.name} href=${t.href}>${n}</a>
                </li>
            `}else return c`
                <li class='level-container'>
                    <span>${t.name}</span>
                </li>
            `}render(){let t=this.truncateIndex<this.levels.length?this.truncateIndex:0,e=c`<slot name="items" @slotchange=${this.handleSlotChange}></slot>`;return c`
            <nav class=${S({"component-container":!0,multiline:this.multiline,"scroll-x":this.scrollX})}>
                <ol class=${S({multiline:this.multiline,wrap:this.wrap})}>
                    ${this.levels.length?this.levels.map((o,n)=>this._showLevel(o,n,t)):e}
                </ol>
            </nav>
        `}};ae.styles=[Wo];Ve([d({type:Number,attribute:"truncate-index"})],ae.prototype,"truncateIndex",2);Ve([d({type:Array})],ae.prototype,"levels",2);Ve([d({type:Boolean})],ae.prototype,"multiline",2);Ve([d({type:Boolean})],ae.prototype,"wrap",2);Ve([d({type:Boolean,attribute:"scroll-x"})],ae.prototype,"scrollX",2);ae=Ve([w("blox-breadcrumb")],ae);var Ko=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --max-width: 600px;
  color: var(--blox-slate4);
  font-family: var(--blox-font-family);
}

li {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  display: inline;
  list-style: none;
  overflow: hidden;
}`;var gi=Object.defineProperty,wi=Object.getOwnPropertyDescriptor,Qo=(t,e,o,n)=>{for(var i=n>1?void 0:n?wi(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&gi(e,o,i),i},et=class extends m{constructor(){super(...arguments);this.slot="items"}render(){return c`
            <li>
                <slot></slot>
            </li>
        `}};et.styles=[Ko];Qo([d({reflect:!0,type:String})],et.prototype,"slot",2);et=Qo([w("blox-breadcrumb-item")],et);var Xo={prefix:"fab",iconName:"facebook-f",icon:[320,512,[],"f39e","M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"]},Yo={prefix:"fab",iconName:"tiktok",icon:[448,512,[],"e07b","M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"]},Go={prefix:"fab",iconName:"twitter",icon:[512,512,[],"f099","M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"]},Jo={prefix:"fab",iconName:"pinterest",icon:[496,512,[],"f0d2","M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"]};var K=t=>t!=null?t:j;var Zo=t=>{let e=t.querySelectorAll(`a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"]), blox-dialog-action, 
        blox-switch, blox-search, blox-select`);return Array.from(e).filter(o=>{let n=window.getComputedStyle(o);return!o.hasAttribute("disabled")&&!o.getAttribute("aria-hidden")&&n.display!=="none"&&n.visibility!=="hidden"})},en=t=>{var o;let e=(o=t.shadowRoot)==null?void 0:o.querySelector("slot");return e?e.assignedElements({flatten:!0}):[]},D=t=>{var e;return c`
    <div
        aria-hidden=${K(t.ariaHidden?t.ariaHidden:void 0)}
        aria-label=${K(t.ariaLabel?t.ariaLabel:void 0)}
        class=${S({"svg-container":!0,[(e=t.class)!=null?e:""]:!!t.class})}
        style=${`${t.color?`fill: ${t.color}; `:""}font-size: 0;`}
    >
        <svg
            style=${`height: ${t.height?t.height:"var(--blox-icon-height)"}`}
            viewBox=${`0 0 ${t.icon.icon[0]} ${t.icon.icon[1]}`}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d=${t.icon.icon[4]}
            />
        </svg>
    </div>
`};var tn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --border-radius: var(--blox-border-radius);
  font-family: var(--blox-font-family);
}

button {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  align-items: stretch;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  display: flex;
  height: auto;
  margin: 0;
  padding: 0;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function), outline 0s ease;
  width: auto;
}
button:focus:enabled {
  outline: 2px solid var(--blox-blue);
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
button span:first-of-type {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: var(--border-radius) 0 0 var(--border-radius);
  display: flex;
  font-size: 18px;
  justify-content: center;
  line-height: normal;
  padding: 14px 0;
  width: 44px;
}
button span:last-child {
  align-items: center;
  background-color: transparent;
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
  display: flex;
  padding: 0 12px 2px;
}
button.facebook {
  background-color: var(--blox-facebook);
  color: white;
}
button.facebook:hover:enabled {
  background-color: var(--blox-facebook--hover);
}
button.facebook:active:enabled {
  background-color: var(--blox-facebook--active);
}
button.facebook:disabled {
  background-color: var(--blox-facebook);
}
button.pinterest {
  background-color: var(--blox-pinterest);
  color: white;
}
button.pinterest:hover:enabled {
  background-color: var(--blox-pinterest--hover);
}
button.pinterest:active:enabled {
  background-color: var(--blox-pinterest--active);
}
button.pinterest:disabled {
  background-color: var(--blox-pinterest);
}
button.tiktok {
  background-color: var(--blox-tiktok);
  color: white;
}
button.tiktok:hover:enabled {
  background-color: var(--blox-tiktok--hover);
}
button.tiktok:active:enabled {
  background-color: var(--blox-tiktok--active);
}
button.tiktok:disabled {
  background-color: var(--blox-tiktok);
}
button.twitter {
  background-color: var(--blox-twitter);
  color: white;
}
button.twitter:hover:enabled {
  background-color: var(--blox-twitter--hover);
}
button.twitter:active:enabled {
  background-color: var(--blox-twitter--active);
}
button.twitter:disabled {
  background-color: var(--blox-twitter);
}`;var ki=Object.defineProperty,Si=Object.getOwnPropertyDescriptor,Wt=(t,e,o,n)=>{for(var i=n>1?void 0:n?Si(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&ki(e,o,i),i},Ne=class extends m{constructor(){super(...arguments);this.disabled=!1,this.platform="Facebook"}iconTemplate(){let t=Xo;return this.platform==="Pinterest"?t=Jo:this.platform==="Twitter"?t=Go:this.platform==="TikTok"&&(t=Yo),D({ariaHidden:!0,color:"white",icon:t})}render(){return c`
            <button ?disabled=${this.disabled} class="${this.platform.toLowerCase()}">
                <span>${this.iconTemplate()}</span>
                <span>Add ${this.platform} account</span>
            </button>
        `}};Ne.styles=[tn];Wt([d({type:Boolean})],Ne.prototype,"disabled",2);Wt([d({type:String})],Ne.prototype,"platform",2);Ne=Wt([w("blox-connect-social-button")],Ne);var on={prefix:"far",iconName:"circle-exclamation",icon:[512,512,["exclamation-circle"],"f06a","M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"]},nn={prefix:"far",iconName:"circle-info",icon:[512,512,["info-circle"],"f05a","M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z"]},rn={prefix:"far",iconName:"magnifying-glass",icon:[512,512,[128269,"search"],"f002","M504.1 471l-134-134C399.1 301.5 415.1 256.8 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c48.79 0 93.55-16.91 129-45.04l134 134C475.7 509.7 481.9 512 488 512s12.28-2.344 16.97-7.031C514.3 495.6 514.3 480.4 504.1 471zM48 208c0-88.22 71.78-160 160-160s160 71.78 160 160s-71.78 160-160 160S48 296.2 48 208z"]},yt={prefix:"far",iconName:"xmark",icon:[320,512,[128473,10005,10006,10060,215,"close","multiply","remove","times"],"f00d","M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"]},ln={prefix:"far",iconName:"triangle-exclamation",icon:[512,512,[9888,"exclamation-triangle","warning"],"f071","M506.3 417l-213.3-364C284.8 39 270.4 32 256 32C241.6 32 227.2 39 218.1 53l-213.2 364C-10.59 444.9 9.851 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM52.58 432L255.1 84.8L459.4 432H52.58zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44c0 17.36 14.11 31.44 31.48 31.44s31.4-14.08 31.4-31.44C287.4 351.2 273.4 337.1 256 337.1zM232 184v96C232 293.3 242.8 304 256 304s24-10.75 24-24v-96C280 170.8 269.3 160 256 160S232 170.8 232 184z"]},an={prefix:"far",iconName:"circle-xmark",icon:[512,512,[61532,"times-circle","xmark-circle"],"f057","M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"]};var Ie;(function(t){t.loading="http://assets.pxlecdn.com/blox/loader.gif",t.pixleeSpinningLoading="http://assets.pxlecdn.com/blox/loader_white.gif"})(Ie||(Ie={}));var sn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --background-blur: 20px;
  --dialog-body-padding: 30px;
  --dialog-border-radius: var(--blox-border-radius);
  --dialog-horizontal-margin: 20px;
  --dialog-vertical-margin: 50px;
  --max-width: 980px;
  --z-index: 99;
  font-family: var(--blox-font-family);
}

.component-container {
  -webkit-backdrop-filter: blur(var(--background-blur));
          backdrop-filter: blur(var(--background-blur));
  background-color: rgba(236, 236, 236, 0.75);
  display: none;
  height: 100%;
  left: 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: var(--z-index);
}
.component-container.show {
  display: block;
}

.dialog-background {
  box-sizing: border-box;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: calc(var(--z-index) + 1);
}

.dialog {
  background-color: white;
  border-radius: var(--dialog-border-radius);
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.1);
  color: var(--blox-slate5);
  display: flex;
  flex-direction: column;
  left: 50%;
  max-width: var(--max-width);
  position: absolute;
  top: var(--dialog-vertical-margin);
  transform: translateX(-50%);
  width: 100%;
  z-index: calc(var(--z-index) + 2);
}

.header {
  align-items: center;
  background-color: var(--blox-slate7);
  border-radius: var(--dialog-border-radius) var(--dialog-border-radius) 0 0;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 11px;
}
.header h2 {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-lg);
  font-weight: var(--blox-font-weight-700);
  color: white;
  margin: 0;
  padding: 0;
}
.header h2:focus {
  outline: 2px solid var(--blox-blue);
}
.header button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.body {
  box-sizing: border-box;
  flex: 1;
  margin: 0;
  padding: var(--dialog-body-padding);
  position: relative;
}
.body .loading-gif {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  cursor: wait;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: calc(var(--z-index) + 1);
}
.body .loading-gif img {
  height: 25px;
  width: 25px;
}

.actions {
  border-radius: 0 0 var(--dialog-border-radius) var(--dialog-border-radius);
  display: flex;
  width: 100%;
}`;var zi=Object.defineProperty,Ei=Object.getOwnPropertyDescriptor,fe=(t,e,o,n)=>{for(var i=n>1?void 0:n?Ei(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&zi(e,o,i),i},Q=class extends m{constructor(){super(...arguments);this.autoClose=!1,this.focusOnCloseQuery="",this.focusOnOpenQuery="",this.header="Dialog",this.loading=!1,this.role="dialog",this.show=!1,this.dialogContainerRef=A(),this.dialogHeaderRef=A(),this.dialogCloseRef=A()}open(){this.show=!0}close(){this.show=!1}firstUpdated(){var t;this.show&&(this.setBodyScrollable(!1),this.focusOnOpenQuery?this.focusSlotElement():(t=this.dialogHeaderRef.value)==null||t.focus())}updated(t){var e;t.has("show")&&(this.show&&(this.setBodyScrollable(!1),this.focusOnOpenQuery?this.focusSlotElement():(e=this.dialogHeaderRef.value)==null||e.focus()),t.get("show")&&(this.setBodyScrollable(!0),this.focusOnCloseQuery&&document.querySelector(this.focusOnCloseQuery).focus()))}disconnectedCallback(){super.disconnectedCallback(),this.setBodyScrollable(!0)}emitCustomEvent(t){let e=new CustomEvent("close",{bubbles:!0,detail:t});this.dispatchEvent(e)}handleCloseClick(){this.emitCustomEvent("close"),this.autoClose&&(this.show=!1)}handleKeyDown(t){var i,r;let e=t.target.id,o=t.key==="Tab"&&t.shiftKey&&e==="dialog-header",n=t.key==="Tab"&&!t.shiftKey;if(o||n){let l=Zo(this),a=l.length?l[l.length-1]:void 0;o?(t.preventDefault(),a?a.focus():(i=this.dialogCloseRef.value)==null||i.focus()):t.target===a&&(t.preventDefault(),(r=this.dialogHeaderRef.value)==null||r.focus())}}handleKeyUp(t){t.key==="Escape"&&this.handleCloseClick()}focusSlotElement(){var o;let t=(o=this.shadowRoot)==null?void 0:o.querySelector("slot"),e=t==null?void 0:t.assignedElements({flatten:!0});e==null||e.some(n=>{var l;let i=n,r=i.querySelector(this.focusOnOpenQuery);if(r)return r.focus(),!0;{let a=(l=i.parentElement)==null?void 0:l.querySelector(this.focusOnOpenQuery);if(a)return a.focus(),!0}})}setBodyScrollable(t){t?(this.previousOverflow?document.body.style.overflow=this.previousOverflow:document.body.style.removeProperty("overflow"),this.previousHeight?document.body.style.height=this.previousHeight:document.body.style.removeProperty("height")):(this.previousOverflow=document.body.style.overflow,this.previousHeight=document.body.style.height,document.body.style.overflow="hidden",document.body.style.height="100vh")}getLoadingContent(){return this.loading?c`
                <div class="loading-gif">
                    <img src=${Ie.pixleeSpinningLoading} alt='loading'>
                </div>
            `:null}render(){return c`
            <div
                class=${S({"component-container":!0,show:this.show})}
                aria-hidden=${!this.show}
                ${P(this.dialogContainerRef)}
            >
                <div
                    class='dialog-background'
                    @keyup=${this.handleKeyUp}
                    @click=${this.handleCloseClick}
                ></div>

                <div
                    class='dialog'
                    aria-labelledby='dialog-header'
                    aria-modal='true'
                    class='dialog'
                    @keyup=${this.handleKeyUp}
                    @keydown=${this.handleKeyDown}
                    role=${this.role}
                >
                    <div class='header'>
                        <h2
                            ${P(this.dialogHeaderRef)}
                            id='dialog-header'
                            tabindex='0'
                        >
                            ${this.header}
                        </h2>
                        <button
                            ${P(this.dialogCloseRef)}
                            aria-label='Close'
                            @click=${this.handleCloseClick}
                            id='dialog-close'
                        >
                            ${D({ariaHidden:!0,color:"white",height:"29px",icon:yt})}
                        </button>
                    </div>
                    <div class='body'>
                        ${this.getLoadingContent()}
                        <slot tabindex='${K(this.loading?"-1":void 0)}'></slot>
                    </div>
                    <div class='actions'>
                        <slot name='actions'></slot>
                    </div>
                </div>
            </div>
        `}};Q.styles=[sn];fe([d({attribute:"auto-close",type:Boolean})],Q.prototype,"autoClose",2);fe([d({attribute:"focus-on-close",type:String})],Q.prototype,"focusOnCloseQuery",2);fe([d({attribute:"focus-on-open",type:String})],Q.prototype,"focusOnOpenQuery",2);fe([d({type:String})],Q.prototype,"header",2);fe([d({attribute:"loading",type:Boolean})],Q.prototype,"loading",2);fe([d({type:String})],Q.prototype,"role",2);fe([d({reflect:!0,type:Boolean})],Q.prototype,"show",2);Q=fe([w("blox-dialog")],Q);var dn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --dialog-border-radius: var(--blox-border-radius);
  display: flex;
  font-family: var(--blox-font-family);
  width: 100%;
}

.component-container {
  display: flex;
  width: 100%;
}

button {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  transition: "background-color" var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  background-color: var(--blox-blue);
  border: none;
  box-sizing: border-box;
  color: white;
  cursor: pointer;
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0;
  padding: 20px 0;
  width: 100%;
  word-spacing: inherit;
}
button:enabled:hover {
  background-color: var(--blox-blue--hover);
}
button:enabled:active {
  background-color: var(--blox-blue--active);
}
button:enabled:focus {
  outline: 2px solid blue;
  outline-offset: -2px;
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
button.secondary {
  background-color: var(--blox-slate3);
}
button.secondary:enabled:hover {
  background-color: var(--blox-slate3--hover);
}
button.secondary:enabled:active {
  background-color: var(--blox-slate3--active);
}
button.secondary-light {
  background-color: var(--blox-slate2);
}
button.secondary-light:enabled:hover {
  background-color: var(--blox-slate2--hover);
}
button.secondary-light:enabled:active {
  background-color: var(--blox-slate2--active);
}

::slotted(*) {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  box-sizing: border-box;
  color: white;
  margin: 0;
  padding: 0;
}`;var Ci=Object.defineProperty,Oi=Object.getOwnPropertyDescriptor,Fe=(t,e,o,n)=>{for(var i=n>1?void 0:n?Oi(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&Ci(e,o,i),i},se=class extends m{constructor(){super(...arguments);this.disabled=!1,this.form="",this.type="submit",this.slot="actions",this.variant="primary",this.buttonRef=A()}handleClick(){var t,e;if(this.type==="submit"&&!this.disabled){let o=document.createElement("input");o.classList.add("blox","hidden-form-control"),o.setAttribute("form",this.form),o.hidden=!0,o.type="submit",(t=this.parentElement)==null||t.appendChild(o),o.click(),(e=this.parentElement)==null||e.removeChild(o)}}focus(){this.buttonRef.value.focus()}render(){return c`
            <div class='component-container'>
                <button
                    ${P(this.buttonRef)}
                    class=${this.variant}
                    @click=${this.handleClick}
                    ?disabled=${this.disabled}
                    form=${K(this.form?this.form:void 0)}
                    type=${this.type}
                >
                    <slot></slot>
                </button>
            </div>
        `}};se.styles=[dn];Fe([d({type:Boolean})],se.prototype,"disabled",2);Fe([d({type:String})],se.prototype,"form",2);Fe([d({type:String})],se.prototype,"type",2);Fe([d({reflect:!0,type:String})],se.prototype,"slot",2);Fe([d({type:String})],se.prototype,"variant",2);se=Fe([w("blox-dialog-action")],se);var bn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --gap: 5px;
  font-family: var(--blox-font-family);
}

.component-container {
  align-items: flex-start;
  display: inline-flex;
  flex-flow: column wrap;
  gap: var(--gap);
  width: 100%;
}
.component-container .helper-text {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  margin: 0;
  padding: 0;
  width: 100%;
}
.component-container .helper-text.invalid {
  color: var(--blox-red);
  visibility: hidden;
}
.component-container .helper-text.invalid.show {
  visibility: visible;
}`;var $i=Object.defineProperty,ji=Object.getOwnPropertyDescriptor,gt=(t,e,o,n)=>{for(var i=n>1?void 0:n?ji(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&$i(e,o,i),i},Ee=class extends m{constructor(){super(...arguments);this.helperText="",this.helperTextInvalid="",this.invalid=!1}updated(){let e=en(this).find(o=>o.nodeName.toLowerCase()==="input"||o.nodeName.toLowerCase()==="textarea");!e||e.setAttribute("aria-invalid",this.invalid.toString())}renderHelperText(){if(this.helperText.length>0&&!this.invalid)return c`
                <p class='helper-text'>
                    ${this.helperText}
                </p>
            `;if(this.helperTextInvalid.length>0)return c`
                <p class=${S({"helper-text invalid":!0,show:this.invalid})}>
                    ${this.helperTextInvalid}
                </p>
            `}render(){return c`
            <div class='component-container'>
                <slot></slot>
                ${this.renderHelperText()}
            </div>
        `}};Ee.styles=[bn];gt([d({attribute:"helper-text",type:String})],Ee.prototype,"helperText",2);gt([d({attribute:"helper-text-invalid",type:String})],Ee.prototype,"helperTextInvalid",2);gt([d({type:Boolean})],Ee.prototype,"invalid",2);Ee=gt([w("blox-input-group")],Ee);var pn={prefix:"fas",iconName:"angle-down",icon:[448,512,[8964],"f107","M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]},cn={prefix:"fas",iconName:"circle-plus",icon:[512,512,["plus-circle"],"f055","M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]},Kt={prefix:"fas",iconName:"check",icon:[512,512,[10003,10004],"f00c","M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]};var un=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  display: inline-block;
  font-family: var(--blox-font-family);
}

#wrapper {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  background: var(--blox-blue);
  border: 1px solid gray;
  border-radius: var(--border-radius, var(--blox-border-radius));
  color: var(--blox-sample-text-color, #000);
  padding: var(--padding, 30px);
}

button {
  align-items: center;
  display: flex;
  font-family: inherit;
  padding: 5px 10px;
}
button .svg-container {
  fill: var(--blox-sample-text-color, #000);
  margin-right: 5px;
}

#variant {
  margin-top: 1rem;
}`;var Ti=Object.defineProperty,_i=Object.getOwnPropertyDescriptor,tt=(t,e,o,n)=>{for(var i=n>1?void 0:n?_i(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&Ti(e,o,i),i},hn=["primary","secondary"],xe=class extends m{constructor(){super(...arguments);this.title="Hey there",this.maxValue=10,this.value=5,this.variant="primary"}willUpdate(){hn.includes(this.variant)||console.error(`variant='${this.variant}' is unsupported. Supported values are: ${hn.join(", ")}`)}increment(){this.value<this.maxValue&&(this.value+=1);let t=new CustomEvent("sample-incremented",{detail:this.value});this.dispatchEvent(t)}render(){let t=this.maxValue-this.value<3;return c`
            <div id='wrapper'>
                <h2>${this.title} #${this.value}</h2>
                <button @click=${this.increment}>
                    ${D({ariaHidden:!0,icon:cn})}
                    <span>increment</span>
                </button>
                <div id='variant'> Variant: ${this.variant}</div>
                <div>v1.0.6</div>
                <!-- Conditional rendering. 'html' needs to be used for the inner blocks -->
                ${t?c`
                    <p> You are close to the max!</p>
                `:null}
            </div>
        `}};xe.styles=[un];tt([d({type:String})],xe.prototype,"title",2);tt([d({type:Number,attribute:"max-value"})],xe.prototype,"maxValue",2);tt([d({type:Number,reflect:!0})],xe.prototype,"value",2);tt([d({type:String})],xe.prototype,"variant",2);xe=tt([w("blox-sample")],xe);var wt=typeof globalThis!="undefined"?globalThis:typeof window!="undefined"?window:typeof global!="undefined"?global:typeof self!="undefined"?self:{},Ai="Expected a function",fn=0/0,Pi="[object Symbol]",Li=/^\s+|\s+$/g,Ri=/^[-+]0x[0-9a-f]+$/i,Di=/^0b[01]+$/i,Mi=/^0o[0-7]+$/i,Bi=parseInt,Hi=typeof wt=="object"&&wt&&wt.Object===Object&&wt,Vi=typeof self=="object"&&self&&self.Object===Object&&self,Ni=Hi||Vi||Function("return this")(),Ii=Object.prototype,Fi=Ii.toString,Ui=Math.max,qi=Math.min,Qt=function(){return Ni.Date.now()};function Wi(t,e,o){var n,i,r,l,a,s,b=0,p=!1,u=!1,h=!0;if(typeof t!="function")throw new TypeError(Ai);e=xn(e)||0,Xt(o)&&(p=!!o.leading,u="maxWait"in o,r=u?Ui(xn(o.maxWait)||0,e):r,h="trailing"in o?!!o.trailing:h);function f(v){var E=n,C=i;return n=i=void 0,b=v,l=t.apply(C,E),l}function y(v){return b=v,a=setTimeout($,e),p?f(v):l}function z(v){var E=v-s,C=v-b,M=e-E;return u?qi(M,r-C):M}function k(v){var E=v-s,C=v-b;return s===void 0||E>=e||E<0||u&&C>=r}function $(){var v=Qt();if(k(v))return O(v);a=setTimeout($,z(v))}function O(v){return a=void 0,h&&n?f(v):(n=i=void 0,l)}function L(){a!==void 0&&clearTimeout(a),b=0,n=s=i=a=void 0}function x(){return a===void 0?l:O(Qt())}function _(){var v=Qt(),E=k(v);if(n=arguments,i=this,s=v,E){if(a===void 0)return y(s);if(u)return a=setTimeout($,e),f(s)}return a===void 0&&(a=setTimeout($,e)),l}return _.cancel=L,_.flush=x,_}function Xt(t){var e=typeof t;return!!t&&(e=="object"||e=="function")}function Ki(t){return!!t&&typeof t=="object"}function Qi(t){return typeof t=="symbol"||Ki(t)&&Fi.call(t)==Pi}function xn(t){if(typeof t=="number")return t;if(Qi(t))return fn;if(Xt(t)){var e=typeof t.valueOf=="function"?t.valueOf():t;t=Xt(e)?e+"":e}if(typeof t!="string")return t===0?t:+t;t=t.replace(Li,"");var o=Di.test(t);return o||Mi.test(t)?Bi(t.slice(2),o?2:8):Ri.test(t)?fn:+t}var Xi=Wi,vn=Xi;var mn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  display: inline;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}

:host([width=long]) {
  max-width: 600px;
}

:host([width=short]) {
  max-width: 350px;
}

.content-container {
  transition: all var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  align-items: stretch;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  border-radius: 100px;
  box-sizing: border-box;
  display: inline-flex;
  font-size: var(--font-size);
  padding: 0;
}
.content-container:hover:not(.disabled), .content-container.filled:not(.disabled) {
  border: var(--blox-border-input--hover);
}
.content-container:focus-within:not(.disabled) {
  border: var(--blox-border-input--focus);
}
.content-container.form {
  background-color: var(--blox-background-input);
  border-radius: var(--blox-border-radius);
}
.content-container.form input:not(:disabled) {
  background-color: var(--blox-background-input);
}
.content-container.disabled {
  background-color: var(--blox-background-input--disabled);
  cursor: not-allowed;
  opacity: 0.5;
}
.content-container.disabled i {
  color: var(--blox-slate1b);
}
.content-container.full {
  width: 100%;
}
.content-container.long {
  max-width: 600px;
  width: 100%;
}
.content-container.short {
  max-width: 350px;
  width: 100%;
}

.svg-container {
  transition: "fill" var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  align-self: center;
  fill: var(--blox-slate2);
}
.svg-container svg {
  padding: 11px 15px;
}

.clear-icon:hover {
  fill: var(--blox-slate2--hover);
}

input {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--blox-background-input);
  border: none;
  box-sizing: border-box;
  color: var(--blox-slate5);
  font-family: var(--font-family);
  font-size: var(--font-size);
  margin: 0;
  padding: 0;
  width: 100%;
}
input:disabled {
  background-color: var(--blox-background-input--disabled);
  color: var(--blox-slate1b);
  cursor: not-allowed;
}
input:focus-visible {
  outline: none;
}
input::-moz-placeholder {
  color: var(--blox-slate3);
}
input:-ms-input-placeholder {
  color: var(--blox-slate3);
}
input::placeholder {
  color: var(--blox-slate3);
}

button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-family: sofia-pro, sans-serif;
  margin: 0;
  padding: 0;
}
button:disabled, button.hide {
  visibility: hidden;
}

::-webkit-search-cancel-button {
  display: none;
}`;var Yi=Object.defineProperty,Gi=Object.getOwnPropertyDescriptor,oe=(t,e,o,n)=>{for(var i=n>1?void 0:n?Gi(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&Yi(e,o,i),i},I=class extends m{constructor(){super(...arguments);this.ariaLabel="Search content",this.disabled=!1,this.keystrokeDebounce=0,this.name="search",this.placeholder="Search",this.width="",this.value="",this.variant="default",this._startingValue=this.value,this.inputRef=A(),this.searchDebounced=this.getDebounce(),this.externalInput=document.createElement("input")}connectedCallback(){var t;super.connectedCallback(),this.searchDebounced=this.getDebounce(),this.externalInput.classList.add("blox","hidden-form-control"),this.externalInput.disabled=this.disabled,this.name&&(this.externalInput.name=this.name),this.externalInput.tabIndex=-1,this.externalInput.type="search",this.externalInput.value=this.value,(t=this.parentElement)==null||t.append(this.externalInput)}willUpdate(t){t.has("value")&&(this.externalInput.value=this.value)}emitClearEvent(){let t=new CustomEvent("clear",{bubbles:!0});this.dispatchEvent(t)}emitCustomEvent(t,e){let o=new CustomEvent(t,{detail:e,bubbles:!0});this.dispatchEvent(o)}emitSearchEvent(t){let e=new CustomEvent(`search-${t}`,{detail:this.value,bubbles:!0});this.dispatchEvent(e)}handleInput(t){t.stopPropagation();let e=t.target;this.value=e.value,this.externalInput.value=this.value,this.externalInput.dispatchEvent(new Event("input",{bubbles:!0})),this.emitCustomEvent("blox-input",t.data),this.keystrokeDebounce!==0?this.searchDebounced():this.emitSearchEvent("keystroke")}handleInputBlur(){this._startingValue!==this.value&&(this.externalInput.dispatchEvent(new Event("change",{bubbles:!0})),this.emitCustomEvent("blox-change",this.value))}handleInputFocus(){this._startingValue=this.value}handleKeyUp(t){t.key==="Enter"&&this.emitSearchEvent("enter")}getDebounce(){return vn(()=>{this.emitSearchEvent("keystroke")},this.keystrokeDebounce)}clear(){this.value="",this.focus(),this.externalInput.value=this.value,this.emitClearEvent()}focus(t){if(this.disabled)return;let e=this.inputRef.value;(e==null?void 0:e.nodeType)!==1?console.error("A <blox-search> ref element was not found to focus."):e.focus(t)}render(){let t=this.placeholder.length>0?this.placeholder:"Search";return c`
            <div class=${S({"content-container":!0,disabled:this.disabled,filled:this.value.length>0,[this.width]:this.width!=="",form:this.variant==="form"})}>
                ${D({ariaHidden:!0,icon:rn})}
                <input
                    ${P(this.inputRef)}
                    aria-label=${this.ariaLabel}
                    @blur=${this.handleInputBlur}
                    ?disabled=${this.disabled}
                    @focus=${this.handleInputFocus}
                    @input=${this.handleInput}
                    @keyup=${this.handleKeyUp}
                    placeholder=${t}
                    type='search'
                    .value=${this.value}
                />
                <button
                    aria-label='clear search input field'
                    class=${S({hide:this.value.length===0})}
                    @click=${this.clear}
                    ?disabled=${this.disabled}
                >
                    ${D({ariaHidden:!0,icon:an,class:"clear-icon"})}
                </button>
            </div>
        `}};I.styles=[mn];oe([d({attribute:"aria-label",type:String})],I.prototype,"ariaLabel",2);oe([d({type:Boolean})],I.prototype,"disabled",2);oe([d({attribute:"keystroke-debounce",type:Number})],I.prototype,"keystrokeDebounce",2);oe([d({type:String})],I.prototype,"name",2);oe([d({type:String})],I.prototype,"placeholder",2);oe([d({type:String})],I.prototype,"width",2);oe([d({reflect:!0,type:String})],I.prototype,"value",2);oe([d({type:String})],I.prototype,"variant",2);oe([Me()],I.prototype,"_startingValue",2);I=oe([w("blox-search")],I);var yn={prefix:"far",iconName:"circle-check",icon:[512,512,[61533,"check-circle"],"f058","M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"]},ot={prefix:"far",iconName:"circle-question",icon:[512,512,[62108,"question-circle"],"f059","M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 336c-18 0-32 14-32 32s13.1 32 32 32c17.1 0 32-14 32-32S273.1 336 256 336zM289.1 128h-51.1C199 128 168 159 168 198c0 13 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 159 329 128 289.1 128z"]};var gn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --label-top-font-family: sofia-pro, sans-serif;
  --label-top-font-weight: 400;
  --text-transform: none;
  --max-height: calc(40px * 7);
  display: inline;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  line-height: normal;
  margin: 0;
  padding: 0;
}

.component-container {
  --selection-width: 200px;
  align-items: center;
  display: inline-flex;
  width: auto;
}
.component-container.full-width {
  display: flex;
}
.component-container.full-width.label-top .selection-options-container {
  width: 100%;
}
.component-container.label-top {
  align-items: flex-start;
  flex-direction: column;
  justify-content: stretch;
}
.component-container.label-top label {
  font-family: var(--label-top-font-family);
  font-weight: var(--label-top-font-weight);
  padding: 0 0 5px;
}

.disabled {
  opacity: 0.6;
}
.disabled .selection-value {
  background-color: var(--blox-background-input--disabled);
  cursor: not-allowed;
}
.disabled .selection-value:hover, .disabled .selection-value:focus {
  border: var(--blox-border-input);
}

label {
  color: var(--blox-slate5);
  font-family: var(--font-family);
  font-size: var(--font-size);
  padding: 0 10px 0 0;
}

blox-tooltip {
  --tooltip-z-index: 1;
  height: var(--blox-icon-height);
  margin: 0 10px 0 -5px;
}

.required-star {
  color: var(--blox-red);
}

.selection-options-container {
  flex-grow: 1;
  position: relative;
  width: var(--selection-width);
}

.selection-value {
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  align-items: center;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  color: var(--blox-slate5);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--font-family);
  font-size: var(--font-size);
  justify-content: space-between;
  padding: 9px 15px 10px;
  position: relative;
  text-transform: var(--text-transform);
  width: 100%;
}
.selection-value:hover {
  border: var(--blox-border-input--hover);
}
.selection-value:focus {
  border: var(--blox-border-input--focus);
  outline: none;
}

.selection-value span {
  overflow: hidden;
  overflow-wrap: break-word;
  padding: 0 15px 0 0;
  white-space: break-spaces;
}
.selection-value span.placeholder {
  color: var(--blox-slate3);
}

.selection-value .svg-container {
  transition: transform var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  fill: var(--blox-slate2);
}
.selection-value .svg-container.rotate {
  transform: rotate(180deg);
}

ul {
  background-color: var(--blox-background-input);
  border-radius: var(--blox-border-radius);
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  color: var(--blox-slate5);
  font-family: var(--font-family);
  font-size: var(--font-size);
  left: 0;
  list-style: none;
  margin: -1px 0 0;
  max-height: var(--max-height);
  overflow-y: auto;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 10;
}
ul.list-top {
  bottom: 100%;
}

.multiple li:first-child {
  border-bottom: 1px solid var(--blox-slate1c);
}

ul li {
  align-items: center;
  border-bottom: 1px solid white;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
}
ul li:hover {
  background-color: var(--blox-background-input--hover);
}
ul li:focus {
  background-color: var(--blox-background-input--hover);
  outline: 1px solid var(--blox-blue);
  outline-offset: -1px;
}
ul li[aria-disabled] {
  opacity: 0.5;
  pointer-events: none;
}

ul li span {
  overflow: hidden;
  overflow-wrap: break-word;
  pointer-events: none;
  text-transform: var(--text-transform);
  white-space: break-spaces;
}

ul li .svg-container {
  fill: var(--blox-slate1c);
  padding: 0 0 0 15px;
  pointer-events: none;
}
ul li .svg-container.selected {
  fill: var(--blox-blue);
}

@media (prefers-reduced-motion) {
  .selection-value .svg-container {
    transition: none;
  }
}`;var Ji=Object.defineProperty,Zi=Object.getOwnPropertyDescriptor,R=(t,e,o,n)=>{for(var i=n>1?void 0:n?Zi(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&Ji(e,o,i),i},T=class extends m{constructor(){super();this.allSelectedLabel="All options",this.ariaLabel="",this.ariaLabelledby="",this.disabled=!1,this.fullWidth=!1,this.label="Select",this.labelPlacement="left",this.listPlacement="bottom",this.multiple=!1,this.multipleSelectedLabel="Multiple selected",this.name="",this.options=[],this.placeholder="Select an option",this.placeholderDisabled="",this.required=!1,this.selectedValue=null,this.selectedValues=[],this.showSelected=!1,this.showOptions=!1,this.selectionRef=A(),this.optionsRef=A(),this.externalSelect=document.createElement("select"),this.addEventListener("blur",this.handleComponentBlur)}connectedCallback(){var t;super.connectedCallback(),this.externalSelect.classList.add("blox","hidden-form-control"),this.multiple&&this.externalSelect.setAttribute("multiple",""),this.name&&(this.externalSelect.name=this.name),this.externalSelect.tabIndex=-1,this.selectedValue&&(this.externalSelect.value=this.selectedValue),this.multiple&&this.selectedValues.length>0&&(this.externalSelect.value=this.selectedValues[0]),this.options.forEach(e=>{this.externalSelect.innerHTML+=`
            <option
                value="${e.value}" ${e.disabled?"disabled":""}
            >${e.label}</option>`}),(t=this.parentElement)==null||t.append(this.externalSelect)}willUpdate(t){if(t.has("selectedValue"))if(this.selectedValue&&!this.options.find(e=>e.value===this.selectedValue))console.error(`<blox-select>: "${this.selectedValue}" does not match a value from the 'options' array.`);else{let e=t.get("selectedValue")===void 0;this.setExternalSelectValues(!e)}if(t.has("selectedValues"))if(this.selectedValues.some(o=>!this.options.find(n=>n.value===o)))console.error(`<blox-select>: "selection-values" array must only contain values from the 'options' array.`);else{let o=t.get("selectedValues")===void 0;this.setExternalSelectValues(!o)}t.has("options")&&(this.options=this.options.map(e=>(typeof e.value!="string"&&console.error('<blox-select>: "options" only accepts strings as values! Error on option: '+JSON.stringify(e)),ue(ue({},e),{label:String(e.label),value:String(e.value)})))),t.get("showOptions")!==void 0&&(this.showOptions?this.emitCustomEvent("blox-options-visible"):this.emitCustomEvent("blox-options-hidden"))}dispatchHiddenSelectEvent(){this.externalSelect.dispatchEvent(new Event("change",{bubbles:!0})),this.externalSelect.dispatchEvent(new Event("input",{bubbles:!0}))}emitCustomEvent(t){let e=this.multiple?this.options.filter(n=>this.selectedValues.indexOf(n.value)>=0):this.options.find(n=>n.value===this.selectedValue),o=new CustomEvent(t,{detail:e,bubbles:!0});this.dispatchEvent(o)}handleComponentBlur(){this.showOptions=!1}handleOptionClick(t){if(this.disabled)return;let e=t.target,o=e.dataset.value;this.multiple?(e.id==="all"&&this.allOptionsAreSelected()?this.selectedValues=[]:e.id==="all"?this.selectedValues=this.options.filter(n=>!n.disabled).map(n=>n.value):this.selectedValues.indexOf(o)===-1?this.selectedValues=[...this.selectedValues,o]:this.selectedValues=this.selectedValues.filter(i=>i!==o),this.emitCustomEvent("multiple-selection")):(this.selectedValue=o,this.showOptions=!this.showOptions,this.focus(),this.emitCustomEvent("selection")),this.emitCustomEvent("blox-change"),this.emitCustomEvent("blox-input")}handleOptionKeydown(t){if(["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"," "].includes(t.key)&&t.preventDefault(),this.disabled)return;let o=t.target;if(t.key==="Enter"||t.key===" ")this.handleOptionClick(t);else if(t.key==="ArrowDown"){let n=o.nextElementSibling;for(;n&&n.hasAttribute("aria-disabled");)n=n.nextElementSibling;n&&n.focus()}else if(t.key==="ArrowUp"){let n=o.previousElementSibling;for(;n&&n.hasAttribute("aria-disabled");)n=n.previousElementSibling;n?n.focus():this.selectionRef.value.focus()}else t.key==="Escape"&&this.showOptions&&(this.showOptions=!1,this.selectionRef.value.focus())}handleSelectionClick(){this.disabled||(this.showOptions=!this.showOptions)}handleSelectionKeydown(t){var o;if((["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].includes(t.key)||t.key===" ")&&t.preventDefault(),!this.disabled)if(t.key==="ArrowDown"&&this.showOptions){let n=(o=this.optionsRef.value)==null?void 0:o.firstElementChild;for(;n&&n.hasAttribute("aria-disabled");)n=n.nextElementSibling;n&&n.focus()}else t.key==="Enter"||t.key===" "||t.key==="ArrowDown"||t.key==="ArrowUp"?this.showOptions=!this.showOptions:t.key==="Escape"&&this.showOptions&&(this.showOptions=!1)}allOptionsAreSelected(){return this.selectedValues.length===this.options.filter(t=>!t.disabled).length}focus(t){if(this.disabled)return;let e=this.selectionRef.value;(e==null?void 0:e.nodeType)!==1?console.error("A <blox-select> ref element was not found to focus."):e.focus(t)}getDisplayString(){var t,e;if(this.disabled&&this.placeholderDisabled.length>0)return this.placeholderDisabled;if(this.multiple){if(this.selectedValues.length===1)return(t=this.options.find(o=>o.value===this.selectedValues[0]))==null?void 0:t.label;if(this.allOptionsAreSelected()&&!this.showSelected)return this.allSelectedLabel;if(this.selectedValues.length>1&&!this.showSelected)return this.multipleSelectedLabel;if(this.selectedValues.length>1&&this.showSelected){let o=[];return this.options.forEach(n=>{this.selectedValues.indexOf(n.value)>=0&&o.push(n.label)}),o.join(", ")}else return this.placeholder}else return this.selectedValue?(e=this.options.find(o=>o.value===this.selectedValue))==null?void 0:e.label:this.placeholder}setExternalSelectValues(t){this.multiple?this.externalSelect.querySelectorAll("option").forEach(e=>{e.selected=this.selectedValues.includes(e.value)}):this.externalSelect.value=this.selectedValue?this.selectedValue:"",t&&this.dispatchHiddenSelectEvent()}optionTemplate(t,e,o,n){let i=!0;return this.multiple?o==="all"?i=this.allOptionsAreSelected():i=this.selectedValues.indexOf(e)>=0:i=e===this.selectedValue,c`
            <li
                @click=${n?null:this.handleOptionClick}
                id=${K(o==="all"?o:void 0)}
                @keydown=${this.handleOptionKeydown}
                data-label=${t}
                data-value=${e}
                tabindex=${n?-1:0}
                ?aria-disabled=${n}
            >
                <span class='list-label'>${t}</span>
                ${i?c`${D({class:"selected",icon:Kt})}`:null}
                ${!i&&this.multiple?c`${D({icon:Kt})}`:null}
            </li>
        `}render(){var o;let t=this.helpTooltip?c`<blox-tooltip content=${this.helpTooltip}>${D({color:"var(--blox-slate2)",icon:ot})}</blox-tooltip>`:null,e=this.required?c`<span class='required-star'>*</span>`:null;return c`
            <div class=${S({"component-container":!0,disabled:this.disabled,"full-width":this.fullWidth,"label-top":this.labelPlacement==="top"})}>
                ${((o=this.label)==null?void 0:o.length)||this.helpTooltip?c`<label for='selection'>
                    ${e}${this.label}
                </label>`:null}
                ${t}
                <div class='selection-options-container'>
                    <div
                        ${P(this.selectionRef)}
                        aria-expanded=${this.showOptions}
                        aria-label=${K(this.ariaLabel?this.ariaLabel:void 0)}
                        aria-labelledby=${K(this.ariaLabelledby?this.ariaLabelledby:void 0)}
                        class='selection-value'
                        @click=${this.handleSelectionClick}
                        @keydown=${this.handleSelectionKeydown}
                        id='selection'
                        role='button'
                        tabindex=${this.disabled?-1:0}
                    >
                        <span class=${S({placeholder:!this.multiple&&!this.selectedValue||this.multiple&&this.selectedValues.length===0})}>${this.getDisplayString()}</span>
                        ${D({ariaHidden:!0,icon:pn,class:`${this.showOptions?"rotate":""}`})}
                    </div>
                    ${this.showOptions?c`
                    <ul
                        ${P(this.optionsRef)}
                        class=${S({multiple:this.multiple,"list-top":this.listPlacement==="top"})}
                    >
                        ${this.multiple?this.optionTemplate(this.allSelectedLabel,"all","all",this.options.filter(n=>!n.disabled).length===0):null}
                        ${this.options.map(n=>this.optionTemplate(n.label,n.value,"item",!!n.disabled))}
                    </ul>
                    `:null}
                    </div>
                </div>
            </div>
        `}};T.styles=[gn];R([d({attribute:"all-selected-label",type:String})],T.prototype,"allSelectedLabel",2);R([d({attribute:"aria-label",type:String})],T.prototype,"ariaLabel",2);R([d({attribute:"aria-labelledby",type:String})],T.prototype,"ariaLabelledby",2);R([d({type:Boolean})],T.prototype,"disabled",2);R([d({attribute:"full-width",type:Boolean})],T.prototype,"fullWidth",2);R([d({attribute:"help-tooltip",type:String})],T.prototype,"helpTooltip",2);R([d({type:String})],T.prototype,"label",2);R([d({attribute:"label-placement",type:String})],T.prototype,"labelPlacement",2);R([d({attribute:"list-placement",type:String})],T.prototype,"listPlacement",2);R([d({type:Boolean})],T.prototype,"multiple",2);R([d({attribute:"multiple-selected-label",type:String})],T.prototype,"multipleSelectedLabel",2);R([d({attribute:"name",type:String})],T.prototype,"name",2);R([d({type:Array})],T.prototype,"options",2);R([d({type:String})],T.prototype,"placeholder",2);R([d({attribute:"placeholder-disabled",type:String})],T.prototype,"placeholderDisabled",2);R([d({type:Boolean})],T.prototype,"required",2);R([d({attribute:"selected-value",reflect:!0})],T.prototype,"selectedValue",2);R([d({attribute:"selected-values",reflect:!0,type:Array})],T.prototype,"selectedValues",2);R([d({attribute:"show-selected",type:Boolean})],T.prototype,"showSelected",2);R([d({attribute:"show-options",reflect:!0,type:Boolean})],T.prototype,"showOptions",2);T=R([w("blox-select")],T);var wn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
/*
    @deprecated - \$blox-single-value-color-map

    This was taken from the original /styles/internal/colors.scss. Since we now
    have a different \$color-map to store colors in variables.scss this \$color-map
    has been moved here. We will remove this map and refine the list once we are
    ready for a major version upgrade. At this point, we will still offer the same
    list of available colors, so documenting this deprecation in the Stories or
    Docs is not necessary.
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --font-family: sofia-pro, sans-serif;
  --font-weight: 300;
  --label-font-family: sofia-pro, sans-serif;
  --label-font-weight: 700;
  display: inline-block;
  font-family: var(--blox-font-family);
  width: 100%;
}

.component-container {
  align-items: flex-start;
  color: var(--blox-slate5);
  display: flex;
  flex-direction: column;
  font-family: var(--font-family);
  font-weight: var(--font-weight);
  justify-content: center;
  width: 100%;
  word-break: break-word;
}
.component-container.center-items {
  align-items: center;
}
.component-container.center-items .label,
.component-container.center-items .subtitle {
  text-align: center;
}

.value {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-xl);
  font-weight: var(--blox-font-weight-300);
  align-items: center;
  display: flex;
  height: 34px;
}
.value .color-aqua {
  color: var(--blox-aqua);
}
.value .color-blue {
  color: var(--blox-blue);
}
.value .color-green {
  color: var(--blox-green);
}
.value .color-lime {
  color: var(--blox-lime);
}
.value .color-orange {
  color: var(--blox-orange);
}
.value .color-purple {
  color: var(--blox-purple);
}
.value .color-pink {
  color: var(--blox-pink);
}
.value .color-red {
  color: var(--blox-red);
}
.value .color-teal {
  color: var(--blox-teal);
}
.value .color-yellow {
  color: var(--blox-yellow);
}
.value .color-slate0a {
  color: var(--blox-slate0a);
}
.value .color-slate1 {
  color: var(--blox-slate1);
}
.value .color-slate1b {
  color: var(--blox-slate1b);
}
.value .color-slate1c {
  color: var(--blox-slate1c);
}
.value .color-slate2 {
  color: var(--blox-slate2);
}
.value .color-slate3 {
  color: var(--blox-slate3);
}
.value .color-slate4 {
  color: var(--blox-slate4);
}
.value .color-slate5 {
  color: var(--blox-slate5);
}
.value img {
  height: auto;
  width: 41px;
}

.label {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-lg);
  font-weight: var(--blox-font-weight-700);
  font-family: var(--label-font-family);
  font-weight: var(--label-font-weight);
}

.label,
.subtitle {
  align-items: center;
  display: flex;
  font-size: 16px;
  gap: 5px;
}
.label blox-tooltip,
.subtitle blox-tooltip {
  font-weight: var(--blox-font-weight);
  height: var(--blox-icon-height);
  padding: 0 0 2px;
}
.label blox-tooltip .svg-container,
.subtitle blox-tooltip .svg-container {
  fill: var(--blox-slate2);
}

.loading-text {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  display: none;
}

@media (prefers-reduced-motion) {
  .loading-text {
    display: block;
  }

  .loading-gif {
    display: none;
  }
}`;var er=Object.defineProperty,tr=Object.getOwnPropertyDescriptor,de=(t,e,o,n)=>{for(var i=n>1?void 0:n?tr(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&er(e,o,i),i},U=class extends m{constructor(){super(...arguments);this.centerItems=!1,this.color="slate5",this.isLoading=!1,this.label="",this.subtitle="",this.subtitleTooltip="",this.labelTooltip="",this.value=""}getValue(){return this.isLoading?c`<span class='loading-text'>Loading...</span>
            <img src=${Ie.loading} alt='loading' class='loading-gif'>`:c`<span class=${`${`color-${this.color}`}`}>${this.value}</span>`}render(){return c`
            <div class=${S({"component-container":!0,"center-items":this.centerItems})}>
                <div class='value'>
                    ${this.getValue()}
                </div>
                <div class='label'>
                    <span>${this.label}</span>
                    ${this.labelTooltip?c`<blox-tooltip content=${this.labelTooltip}>
                        ${D({icon:ot})}
                    </blox-tooltip>`:null}
                </div>
                <div class='subtitle'>
                    <span>${this.subtitle}</span>
                    ${this.subtitleTooltip?c`<blox-tooltip content=${this.subtitleTooltip}>
                        ${D({icon:ot})}
                    </blox-tooltip>`:null}
                </div>
            </div>
        `}};U.styles=[wn];de([d({attribute:"center-items",type:Boolean})],U.prototype,"centerItems",2);de([d({type:String})],U.prototype,"color",2);de([d({attribute:"is-loading",type:Boolean})],U.prototype,"isLoading",2);de([d({type:String})],U.prototype,"label",2);de([d({type:String})],U.prototype,"subtitle",2);de([d({attribute:"subtitle-tooltip",type:String})],U.prototype,"subtitleTooltip",2);de([d({attribute:"label-tooltip",type:String})],U.prototype,"labelTooltip",2);de([d({type:String})],U.prototype,"value",2);U=de([w("blox-single-value")],U);var kt=class extends ze{constructor(e){if(super(e),this.vt=j,e.type!==Be.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(e){if(e===j)return this.Vt=void 0,this.vt=e;if(e===B)return e;if(typeof e!="string")throw Error(this.constructor.directiveName+"() called with a non-string value");if(e===this.vt)return this.Vt;this.vt=e;let o=[e];return o.raw=o,this.Vt={_$litType$:this.constructor.resultType,strings:o,values:[]}}};kt.directiveName="unsafeHTML",kt.resultType=1;var kn=He(kt);var Sn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
@-webkit-keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --max-width: 800px;
  --z-index: 99;
  font-family: var(--blox-font-family);
}

.component-container {
  box-sizing: border-box;
  display: none;
  flex-direction: column-reverse;
  justify-content: flex-start;
  left: 50%;
  max-width: var(--max-width);
  opacity: 1;
  position: fixed;
  top: 20px;
  transform: translate(-50%, 0);
  width: 100%;
  z-index: var(--z-index);
}
.component-container.show {
  display: flex;
}

.status-container {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-lg);
  font-weight: var(--blox-font-weight-400);
  transition: opacity 1s var(--blox-transition-timing-function) var(--blox-transition-delay);
  align-items: center;
  -webkit-animation: appear 1s;
          animation: appear 1s;
  background-color: var(--blox-blue);
  border-radius: var(--blox-border-radius);
  box-shadow: 0 0 8 1px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  color: white;
  display: flex;
  gap: 15px;
  justify-content: flex-start;
  margin: 0 auto 20px;
  padding: 11px 15px;
  pointer-events: inherit;
  width: 100%;
}
.status-container:first-of-type {
  margin: 0 auto;
}
.status-container.hide {
  opacity: 0;
}
.status-container.error {
  background-color: var(--blox-red);
}
.status-container.success {
  background-color: var(--blox-green);
}
.status-container.warning {
  background-color: var(--blox-yellow);
  color: var(--blox-slate5);
}
.status-container.warning button {
  color: var(--blox-slate5);
}
.status-container.warning button .svg-container {
  fill: var(--blox-slate5);
}
.status-container.warning .icon {
  fill: var(--blox-slate5);
}

.icon {
  fill: white;
  line-height: normal;
}

span[role=status] {
  flex-grow: 1;
  padding: 0 0 1px;
  word-break: break-word;
}

.sr-only {
  height: 1px;
  left: -1000px;
  overflow: hidden;
  position: absolute;
  top: auto;
  width: 1px;
}

button {
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  margin: 0;
  padding: 0;
}
button .svg-container {
  fill: white;
  pointer-events: none;
}

@media (prefers-reduced-motion) {
  .status-container {
    -webkit-animation: none;
            animation: none;
    transition: none;
  }
}`;var or=Object.defineProperty,nr=Object.getOwnPropertyDescriptor,zn=(t,e,o,n)=>{for(var i=n>1?void 0:n?nr(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&or(e,o,i),i},ir=["error","info","success","warning"],nt=class extends m{constructor(){super(...arguments);this._show=!1,this.componentRef=A(),this.animationSpeed=1e3}emitCloseEvent(t){let e=new CustomEvent("close",{bubbles:!0,detail:t});this.dispatchEvent(e)}handleClick(t){let e=t.target;if(e&&e.nodeName.toLowerCase()==="button"){let o=e.parentElement;o&&this.closeStatus(o)}}closeStatus(t){let e=t.getAttribute("data"),o={};e&&(o=JSON.parse(e)),t.classList.add("hide"),window.setTimeout(()=>{t.remove(),this.updateComponentDisplay(),this.emitCloseEvent(o)},this.animationSpeed)}newStatus(t){var n;if(!t.content&&!t.slot)throw new Error("A <blox-status> has no body content! Fix: Either provide the `content` or `slot` property to the `BloxStatus.newStatus()` object parameter.");if((!t.variant||!ir.includes(t.variant))&&(t.variant="info"),t.hideClose&&(!t.displayTime||t.displayTime===0))throw new Error("A <blox-status> with a hidden close button has no `displayTime` value! Fix: Either show the close button, or provide a value to the `displayTime` `BloxStatus.newStatus()` object parameter.");t.displayTime&&t.displayTime<=1500&&console.warn("A <blox-status> `displayTime` is too short for smooth animations. Fix: Ensure the `displayTime` value is greater than 1500 (recommended value is at least 5000).");let e=document.createElement("div");e.classList.add("status-container",t.variant),e.setAttribute("data",JSON.stringify(t)),t.id&&e.setAttribute("id",t.id),Ge(c`
                    ${t.hideIcon?null:c`
                        ${this.iconTemplate(t.variant)}
                    `}
                    <span role='status'>
                        <span class='sr-only'>${t.variant} status:</span>
                        ${(n=t.content)!=null?n:""}
                        ${t.slot&&!t.content?c`${kn(t.slot.outerHTML)}`:null}
                    </span>
                    ${t.hideClose?null:c`
                        <button aria-label='Close'>
                            ${D({ariaHidden:!0,height:"29px",icon:yt})}
                        </button>`}
        `,e);let o=this.componentRef.value;o&&(o.appendChild(e),this.updateComponentDisplay()),t.displayTime&&t.displayTime>0&&window.setTimeout(()=>{this.closeStatus(e)},t.displayTime)}updateComponentDisplay(){let t=this.componentRef.value;t&&t.firstChild?this._show=!0:this._show=!1}iconTemplate(t){let e=nn;return t==="error"?e=on:t==="success"?e=yn:t==="warning"&&(e=ln),D({ariaHidden:!0,class:"icon",icon:e})}render(){return c`
            <div
                ${P(this.componentRef)}
                class=${S({"component-container":!0,show:this._show})}
                @click=${this.handleClick}
            ></div>
        `}};nt.styles=[Sn];zn([Me()],nt.prototype,"_show",2);nt=zn([w("blox-status")],nt);var En=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --width: 100%;
  font-family: var(--blox-font-family);
  margin: 0;
  padding: 0;
}

.component-container {
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  align-items: center;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  gap: 10px;
  justify-content: space-between;
  padding: 10px 15px;
  width: var(--width);
}
.component-container:hover:not([aria-disabled=true]) {
  border: var(--blox-border-input--hover);
}
.component-container:active:not([aria-disabled=true]) {
  border: var(--blox-border-input--active);
}
.component-container[aria-checked=true] {
  border: var(--blox-border-input--hover);
}
.component-container:focus:not([aria-disabled=true]) {
  border: var(--blox-border-input--focus);
  outline: none;
}
.component-container[aria-disabled=true] {
  cursor: not-allowed;
}
.component-container[aria-disabled=true] label {
  cursor: not-allowed;
}
.component-container[aria-checked=true][aria-disabled=true] {
  border: 1px solid rgba(139, 149, 162, 0.5);
}
.component-container label {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  align-items: center;
  color: var(--blox-slate5);
  cursor: pointer;
  display: flex;
  gap: 5px;
}
.component-container .switch {
  pointer-events: none;
}`;var Cn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
input.blox:not(.hidden-form-control):not([type]):disabled, input.blox:not(.hidden-form-control)[type=checkbox]:disabled, input.blox:not(.hidden-form-control)[type=color]:disabled, input.blox:not(.hidden-form-control)[type=date]:disabled, input.blox:not(.hidden-form-control)[type=datetime-local]:disabled, input.blox:not(.hidden-form-control)[type=email]:disabled, input.blox:not(.hidden-form-control)[type=file]:disabled, input.blox:not(.hidden-form-control)[type=image]:disabled, input.blox:not(.hidden-form-control)[type=month]:disabled, input.blox:not(.hidden-form-control)[type=number]:disabled, input.blox:not(.hidden-form-control)[type=password]:disabled, input.blox:not(.hidden-form-control)[type=radio]:disabled, input.blox:not(.hidden-form-control)[type=range]:disabled, input.blox:not(.hidden-form-control)[type=search]:disabled, input.blox:not(.hidden-form-control)[type=tel]:disabled, input.blox:not(.hidden-form-control)[type=text]:disabled, input.blox:not(.hidden-form-control)[type=time]:disabled, input.blox:not(.hidden-form-control)[type=url]:disabled, input.blox:not(.hidden-form-control)[type=week]:disabled {
  background-color: var(--blox-background-input--disabled);
  cursor: not-allowed;
  opacity: 0.5;
  outline: none;
}
input.blox:not(.hidden-form-control):not([type]), input.blox:not(.hidden-form-control)[type=date], input.blox:not(.hidden-form-control)[type=datetime-local], input.blox:not(.hidden-form-control)[type=email], input.blox:not(.hidden-form-control)[type=month], input.blox:not(.hidden-form-control)[type=number], input.blox:not(.hidden-form-control)[type=password], input.blox:not(.hidden-form-control)[type=search], input.blox:not(.hidden-form-control)[type=tel], input.blox:not(.hidden-form-control)[type=text], input.blox:not(.hidden-form-control)[type=time], input.blox:not(.hidden-form-control)[type=url], input.blox:not(.hidden-form-control)[type=week] {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  --font-size: 14px;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  color: var(--blox-slate5);
  cursor: text;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  outline: revert;
  padding: 10px 20px;
  -webkit-text-decoration: revert;
          text-decoration: revert;
  vertical-align: revert;
}
input.blox:not(.hidden-form-control):not([type]):hover:enabled, input.blox:not(.hidden-form-control)[type=date]:hover:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:hover:enabled, input.blox:not(.hidden-form-control)[type=email]:hover:enabled, input.blox:not(.hidden-form-control)[type=month]:hover:enabled, input.blox:not(.hidden-form-control)[type=number]:hover:enabled, input.blox:not(.hidden-form-control)[type=password]:hover:enabled, input.blox:not(.hidden-form-control)[type=search]:hover:enabled, input.blox:not(.hidden-form-control)[type=tel]:hover:enabled, input.blox:not(.hidden-form-control)[type=text]:hover:enabled, input.blox:not(.hidden-form-control)[type=time]:hover:enabled, input.blox:not(.hidden-form-control)[type=url]:hover:enabled, input.blox:not(.hidden-form-control)[type=week]:hover:enabled {
  border: var(--blox-border-input--hover);
}
input.blox:not(.hidden-form-control):not([type]):focus:enabled, input.blox:not(.hidden-form-control)[type=date]:focus:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:focus:enabled, input.blox:not(.hidden-form-control)[type=email]:focus:enabled, input.blox:not(.hidden-form-control)[type=month]:focus:enabled, input.blox:not(.hidden-form-control)[type=number]:focus:enabled, input.blox:not(.hidden-form-control)[type=password]:focus:enabled, input.blox:not(.hidden-form-control)[type=search]:focus:enabled, input.blox:not(.hidden-form-control)[type=tel]:focus:enabled, input.blox:not(.hidden-form-control)[type=text]:focus:enabled, input.blox:not(.hidden-form-control)[type=time]:focus:enabled, input.blox:not(.hidden-form-control)[type=url]:focus:enabled, input.blox:not(.hidden-form-control)[type=week]:focus:enabled {
  border: var(--blox-border-input--focus);
  outline: none;
}
input.blox:not(.hidden-form-control):not([type]):invalid:not(.hide-invalid), input.blox:not(.hidden-form-control):not([type])[aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=date]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=date][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=datetime-local]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=datetime-local][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=email]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=email][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=month]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=month][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=number]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=number][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=password]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=password][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=search]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=search][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=tel]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=tel][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=text]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=text][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=time]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=time][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=url]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=url][aria-invalid=true]:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=week]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=week][aria-invalid=true]:not(.hide-invalid) {
  border: var(--blox-border-input-invalid);
}
input.blox:not(.hidden-form-control):not([type]):invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control):not([type])[aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=date]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=date][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=datetime-local][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=email]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=email][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=month]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=month][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=number]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=number][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=password]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=password][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=search]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=search][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=tel]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=tel][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=text]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=text][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=time]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=time][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=url]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=url][aria-invalid=true]:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=week]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=week][aria-invalid=true]:not(.hide-invalid):hover:enabled {
  border: var(--blox-border-input-invalid--hover);
}
input.blox:not(.hidden-form-control):not([type]):invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control):not([type])[aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=date]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=date][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=datetime-local]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=datetime-local][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=email]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=email][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=month]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=month][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=number]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=number][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=password]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=password][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=search]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=search][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=tel]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=tel][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=text]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=text][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=time]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=time][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=url]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=url][aria-invalid=true]:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=week]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=week][aria-invalid=true]:not(.hide-invalid):focus:enabled {
  border: var(--blox-border-input-invalid--focus);
}
input.blox:not(.hidden-form-control):not([type])::-moz-placeholder, input.blox:not(.hidden-form-control)[type=date]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=datetime-local]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=email]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=month]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=number]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=password]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=search]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=tel]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=text]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=time]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=url]::-moz-placeholder, input.blox:not(.hidden-form-control)[type=week]::-moz-placeholder {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}
input.blox:not(.hidden-form-control):not([type]):-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=date]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=datetime-local]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=email]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=month]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=number]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=password]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=search]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=tel]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=text]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=time]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=url]:-ms-input-placeholder, input.blox:not(.hidden-form-control)[type=week]:-ms-input-placeholder {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}
input.blox:not(.hidden-form-control):not([type])::placeholder, input.blox:not(.hidden-form-control)[type=date]::placeholder, input.blox:not(.hidden-form-control)[type=datetime-local]::placeholder, input.blox:not(.hidden-form-control)[type=email]::placeholder, input.blox:not(.hidden-form-control)[type=month]::placeholder, input.blox:not(.hidden-form-control)[type=number]::placeholder, input.blox:not(.hidden-form-control)[type=password]::placeholder, input.blox:not(.hidden-form-control)[type=search]::placeholder, input.blox:not(.hidden-form-control)[type=tel]::placeholder, input.blox:not(.hidden-form-control)[type=text]::placeholder, input.blox:not(.hidden-form-control)[type=time]::placeholder, input.blox:not(.hidden-form-control)[type=url]::placeholder, input.blox:not(.hidden-form-control)[type=week]::placeholder {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  color: var(--blox-slate3);
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
}
input.blox:not(.hidden-form-control):not([type])::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=date]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=datetime-local]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=email]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=month]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=number]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=password]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=search]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=tel]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=text]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=time]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=url]::-webkit-search-cancel-button, input.blox:not(.hidden-form-control)[type=week]::-webkit-search-cancel-button {
  display: none;
}
input.blox:not(.hidden-form-control):not([type]).pill, input.blox:not(.hidden-form-control)[type=date].pill, input.blox:not(.hidden-form-control)[type=datetime-local].pill, input.blox:not(.hidden-form-control)[type=email].pill, input.blox:not(.hidden-form-control)[type=month].pill, input.blox:not(.hidden-form-control)[type=number].pill, input.blox:not(.hidden-form-control)[type=password].pill, input.blox:not(.hidden-form-control)[type=search].pill, input.blox:not(.hidden-form-control)[type=tel].pill, input.blox:not(.hidden-form-control)[type=text].pill, input.blox:not(.hidden-form-control)[type=time].pill, input.blox:not(.hidden-form-control)[type=url].pill, input.blox:not(.hidden-form-control)[type=week].pill {
  border-radius: 2em;
}
input.blox:not(.hidden-form-control)[type=checkbox], input.blox:not(.hidden-form-control)[type=radio] {
  --internal-size: var(--size, 16px);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--blox-background-input);
  border: var(--blox-border-input);
  display: inline-grid;
  font: inherit;
  height: var(--internal-size);
  place-content: center;
  transition: background-color 0.1s var(--blox-transition-timing-function), border 0.1s var(--blox-transition-timing-function);
  width: var(--internal-size);
}
input.blox:not(.hidden-form-control)[type=checkbox]::before, input.blox:not(.hidden-form-control)[type=radio]::before {
  background-color: white;
  content: "";
  transform: scale(0);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked, input.blox:not(.hidden-form-control)[type=radio]:checked {
  background-color: var(--blox-blue);
  border: 1px solid var(--blox-blue);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked::before, input.blox:not(.hidden-form-control)[type=radio]:checked::before {
  transform: scale(1);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked:hover:enabled, input.blox:not(.hidden-form-control)[type=radio]:checked:hover:enabled {
  background-color: var(--blox-blue--hover);
  border: 1px solid var(--blox-blue--hover);
}
input.blox:not(.hidden-form-control)[type=checkbox]:checked:active:enabled, input.blox:not(.hidden-form-control)[type=radio]:checked:active:enabled {
  background-color: var(--blox-blue--active);
  border: 1px solid var(--blox-blue--active);
}
input.blox:not(.hidden-form-control)[type=checkbox]:hover:enabled:not(:checked), input.blox:not(.hidden-form-control)[type=radio]:hover:enabled:not(:checked) {
  border: var(--blox-border-input--hover);
}
input.blox:not(.hidden-form-control)[type=checkbox]:active:enabled:not(:checked), input.blox:not(.hidden-form-control)[type=radio]:active:enabled:not(:checked) {
  border: var(--blox-border-input--active);
}
input.blox:not(.hidden-form-control)[type=checkbox]:focus-visible, input.blox:not(.hidden-form-control)[type=radio]:focus-visible {
  outline: 2px solid var(--blox-blue);
  outline-offset: 2px;
}
input.blox:not(.hidden-form-control)[type=checkbox] {
  border-radius: var(--blox-border-radius);
  transform: translateY(1px);
}
input.blox:not(.hidden-form-control)[type=checkbox]::before {
  background-color: transparent;
  background-image: url("http://assets.pxlecdn.com/blox/checkmark-checked.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  height: calc(var(--internal-size) - 2px);
  width: calc(var(--internal-size) - 2px);
}
input.blox:not(.hidden-form-control)[type=checkbox].table {
  --internal-size: var(--size, 45px);
  border: 0;
  border-radius: unset;
  height: 100%;
  transform: none;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=checkbox].table::before {
  box-shadow: none;
  transform: none;
}
input.blox:not(.hidden-form-control)[type=checkbox].table:not(:checked) {
  background-color: var(--background-color, transparent);
}
input.blox:not(.hidden-form-control)[type=checkbox].table:not(:checked)::before {
  background-image: url("http://assets.pxlecdn.com/blox/checkmark-unchecked.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50%;
}
input.blox:not(.hidden-form-control)[type=checkbox].table:not(:checked):hover, input.blox:not(.hidden-form-control)[type=checkbox].table:checked:hover, input.blox:not(.hidden-form-control)[type=checkbox].table:active:enabled:not(:checked) {
  border: none;
}
input.blox:not(.hidden-form-control)[type=checkbox].table:checked::before {
  background-color: transparent;
  background-image: url("http://assets.pxlecdn.com/blox/checkmark-checked.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50%;
}
input.blox:not(.hidden-form-control)[type=checkbox].switch {
  --internal-size: var(--size, 36px);
  --switch-off-background-color: var(--blox-slate1c);
  --switch-on-background-color: var(--blox-green);
  --dot-size: 20px;
  --dot-padding: 4px;
  transition: --switch-off-background-color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--switch-off-background-color);
  border: 0;
  border-radius: 22px;
  color: transparent;
  font-size: 0;
  height: calc(var(--dot-size) + var(--dot-padding));
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  width: var(--internal-size);
}
input.blox:not(.hidden-form-control)[type=checkbox].switch::before {
  content: unset;
}
input.blox:not(.hidden-form-control)[type=checkbox].switch::after {
  background-color: white;
  border-radius: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15), 0 4px 4px rgba(0, 0, 0, 0.1);
  content: " ";
  height: var(--dot-size);
  left: calc(var(--dot-padding) / 2);
  position: absolute;
  right: auto;
  top: calc(var(--dot-padding) / 2);
  transition: all 0.1s ease-out 0s;
  width: var(--dot-size);
}
input.blox:not(.hidden-form-control)[type=checkbox].switch:checked, input.blox:not(.hidden-form-control)[type=checkbox].switch:checked:hover, input.blox:not(.hidden-form-control)[type=checkbox].switch:checked:focus, input.blox:not(.hidden-form-control)[type=checkbox].switch:checked:active {
  background-color: var(--switch-on-background-color);
}
input.blox:not(.hidden-form-control)[type=checkbox].switch:checked::after {
  transform: translateX(calc(var(--internal-size) - var(--dot-size) - var(--dot-padding)));
}
input.blox:not(.hidden-form-control)[type=checkbox].switch:hover:enabled:checked, input.blox:not(.hidden-form-control)[type=checkbox].switch:hover:enabled:not(:checked), input.blox:not(.hidden-form-control)[type=checkbox].switch:active:enabled:checked, input.blox:not(.hidden-form-control)[type=checkbox].switch:active:enabled:not(:checked) {
  border: 0;
}
input.blox:not(.hidden-form-control)[type=radio] {
  border-radius: 50%;
  transform: translateY(-3px);
}
input.blox:not(.hidden-form-control)[type=radio]::before {
  border-radius: 50%;
  box-shadow: inset 1em 1em var(--form-control-color);
  height: calc(var(--internal-size) * 0.4);
  width: calc(var(--internal-size) * 0.4);
}
input.blox:not(.hidden-form-control)[type=color] {
  --width: 50px;
  background-color: var(--blox-slate0a);
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  height: calc(var(--width) / 2);
  min-height: 20px;
  min-width: 20px;
  padding: 0;
  transition: background-color var(--blox-transition-duration) var(--blox-transition-timing-function), border var(--blox-transition-duration) var(--blox-transition-timing-function);
  width: var(--width);
}
input.blox:not(.hidden-form-control)[type=color]:hover:enabled {
  background-color: var(--blox-slate1);
  border: var(--blox-border-input--hover);
}
input.blox:not(.hidden-form-control)[type=color]:active:enabled {
  border: var(--blox-border-input--active);
}
input.blox:not(.hidden-form-control)[type=color]:focus:enabled {
  border: var(--blox-border-input--focus);
  outline: none;
}
input.blox:not(.hidden-form-control)[type=color]::-webkit-color-swatch-wrapper {
  border: none;
  border-radius: var(--blox-border-radius);
  margin: 0;
  padding: 5px;
}
input.blox:not(.hidden-form-control)[type=color]::-webkit-color-swatch {
  border: none;
  border-radius: 2px;
  margin: 0;
  padding: 0;
}
input.blox:not(.hidden-form-control)[type=color].pill {
  border-radius: 2em;
}
input.blox:not(.hidden-form-control)[type=color].pill::-webkit-color-swatch-wrapper, input.blox:not(.hidden-form-control)[type=color].pill::-webkit-color-swatch {
  border-radius: 2em;
}
input.blox:not(.hidden-form-control)[type=file] {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  --font-size: 14px;
  border: 1px solid transparent;
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  color: var(--blox-slate3);
  cursor: pointer;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  padding: 0;
  transition: border var(--blox-transition-duration) var(--blox-transition-timing-function), color var(--blox-transition-duration) var(--blox-transition-timing-function);
}
input.blox:not(.hidden-form-control)[type=file]:hover:enabled {
  color: var(--blox-slate3--hover);
}
input.blox:not(.hidden-form-control)[type=file]:active:enabled {
  color: var(--blox-slate3--active);
}
input.blox:not(.hidden-form-control)[type=file]:focus-visible:enabled {
  outline: 2px solid var(--blox-blue);
}
input.blox:not(.hidden-form-control)[type=file]:disabled {
  background-color: transparent;
}
input.blox:not(.hidden-form-control)[type=file]:disabled::-webkit-file-upload-button {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=file]:invalid:not(.hide-invalid), input.blox:not(.hidden-form-control)[type=file][aria-invalid=true]:not(.hide-invalid) {
  border: var(--blox-border-input-invalid);
}
input.blox:not(.hidden-form-control)[type=file]:invalid:not(.hide-invalid):hover:enabled, input.blox:not(.hidden-form-control)[type=file][aria-invalid=true]:not(.hide-invalid):hover:enabled {
  border: var(--blox-border-input-invalid--hover);
}
input.blox:not(.hidden-form-control)[type=file]:invalid:not(.hide-invalid):focus:enabled, input.blox:not(.hidden-form-control)[type=file][aria-invalid=true]:not(.hide-invalid):focus:enabled {
  border: var(--blox-border-input-invalid--focus);
}
input.blox:not(.hidden-form-control)[type=file]::-webkit-file-upload-button {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-700);
  -webkit-transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  background-color: transparent;
  border: none;
  color: var(--blox-slate3);
  cursor: pointer;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  margin: 0 5px 0 0;
  padding: 0;
}
input.blox:not(.hidden-form-control)[type=file]::-webkit-file-upload-button:hover {
  color: var(--blox-slate3--hover);
}
input.blox:not(.hidden-form-control)[type=file]::-webkit-file-upload-button:active {
  color: var(--blox-slate3--active);
}
input.blox:not(.hidden-form-control)[type=image] {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-md);
  font-weight: var(--blox-font-weight-400);
  transition: color var(--blox-transition-duration) var(--blox-transition-timing-function) var(--blox-transition-delay);
  --font-size: 14px;
  box-sizing: border-box;
  color: var(--blox-slate3);
  cursor: pointer;
  font-family: var(--blox-font-family);
  font-size: var(--font-size);
  outline: revert;
  padding: 0;
  -webkit-text-decoration: revert;
          text-decoration: revert;
  vertical-align: revert;
}
input.blox:not(.hidden-form-control)[type=image]:hover:enabled {
  color: var(--blox-slate3--hover);
}
input.blox:not(.hidden-form-control)[type=image]:active:enabled {
  color: var(--blox-slate3--active);
}
input.blox:not(.hidden-form-control)[type=image]:focus-visible:enabled {
  outline: 2px solid var(--blox-blue);
  outline-offset: 2px;
}
input.blox:not(.hidden-form-control)[type=image]:disabled {
  background-color: transparent;
}
input.blox:not(.hidden-form-control)[type=range] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: var(--blox-border-radius);
  box-sizing: border-box;
  padding: 5px 10px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]:focus-visible {
  outline: 2px solid var(--blox-blue);
  outline-offset: 4px;
}
input.blox:not(.hidden-form-control)[type=range]:disabled {
  background-color: transparent;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-moz-range-track, input.blox:not(.hidden-form-control)[type=range]:disabled::-moz-range-thumb {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-moz-range-thumb {
  background-color: var(--blox-background-input--disabled);
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-ms-track, input.blox:not(.hidden-form-control)[type=range]:disabled::-ms-thumb {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-ms-thumb {
  background-color: var(--blox-background-input--disabled);
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-webkit-slider-runnable-track, input.blox:not(.hidden-form-control)[type=range]:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
}
input.blox:not(.hidden-form-control)[type=range]:disabled::-webkit-slider-thumb {
  background-color: var(--blox-background-input--disabled);
}
input.blox:not(.hidden-form-control)[type=range]::-moz-range-track {
  background: var(--blox-blue);
  border-radius: 8.4px;
  cursor: pointer;
  height: 8.4px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]::-ms-track {
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
  cursor: pointer;
  height: 8.4px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]::-ms-fill-lower, input.blox:not(.hidden-form-control)[type=range]::-ms-fill-upper {
  background: var(--blox-blue);
  border-radius: var(--blox-border-radius);
}
input.blox:not(.hidden-form-control)[type=range]::-webkit-slider-runnable-track {
  background: var(--blox-blue);
  border-radius: 8.4px;
  cursor: pointer;
  height: 8.4px;
  width: 100%;
}
input.blox:not(.hidden-form-control)[type=range]::-moz-range-thumb {
  background: white;
  border-radius: var(--blox-border-radius);
  cursor: pointer;
  height: 24px;
  width: 15px;
}
input.blox:not(.hidden-form-control)[type=range]::-ms-thumb {
  background: white;
  cursor: pointer;
  height: 24px;
  width: 15px;
}
input.blox:not(.hidden-form-control)[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
  background: white;
  border: var(--blox-border-input);
  border-radius: var(--blox-border-radius);
  cursor: pointer;
  height: 24px;
  margin-top: -8px;
  width: 15px;
}`;var rr=Object.defineProperty,lr=Object.getOwnPropertyDescriptor,Ue=(t,e,o,n)=>{for(var i=n>1?void 0:n?lr(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&rr(e,o,i),i},be=class extends m{constructor(){super(...arguments);this.checked=!1,this.disabled=!1,this.label="",this.name="",this.value="on",this.containerRef=A(),this.inputRef=A(),this.externalInput=document.createElement("input")}connectedCallback(){var t;super.connectedCallback(),this.externalInput.checked=this.checked,this.externalInput.classList.add("blox","hidden-form-control"),this.externalInput.disabled=this.disabled,this.name&&(this.externalInput.name=this.name),this.externalInput.tabIndex=-1,this.externalInput.type="checkbox",this.externalInput.value=this.value,(t=this.parentElement)==null||t.append(this.externalInput)}willUpdate(t){t.has("checked")&&(this.externalInput.checked=this.checked,t.get("checked")===void 0||this.dispatchHiddenInputEvent())}dispatchHiddenInputEvent(){this.externalInput.dispatchEvent(new Event("change",{bubbles:!0})),this.externalInput.dispatchEvent(new Event("input",{bubbles:!0}))}emitCustomEvent(t){let e=new CustomEvent(t,{detail:this.checked,bubbles:!0});this.dispatchEvent(e)}emitToggleEvent(){let t=new CustomEvent("toggle",{detail:this,bubbles:!0});this.dispatchEvent(t)}handleClick(t){var o;if(this.disabled)return;t.target!==this.containerRef.value&&t.preventDefault(),this.checked=!((o=this.inputRef.value)==null?void 0:o.checked),this.emitToggleEvent(),this.emitCustomEvent("blox-change"),this.emitCustomEvent("blox-input")}handleKeyup(t){t.key===" "&&!this.disabled&&this.handleClick(t)}focus(){var t;this.disabled||(t=this.containerRef.value)==null||t.focus()}render(){return c`
            <div
                ${P(this.containerRef)}
                aria-checked=${this.checked}
                aria-disabled=${this.disabled}
                aria-label=${this.label}
                class='component-container'
                @click=${this.handleClick}
                @keyup=${this.handleKeyup}
                role='checkbox'
                tabindex=${this.disabled?"-1":"0"}
            >
                <label for='switch-checkbox'>
                    <slot>${this.label}</slot>
                </label>
                <input
                    ${P(this.inputRef)}
                    ?checked=${this.checked}
                    ?disabled=${this.disabled}
                    id='switch-checkbox'
                    type='checkbox'
                    value=${this.value}
                    class='blox switch'
                    tabindex='-1'
                >
            </div>
        `}};be.styles=[En,Cn];Ue([d({reflect:!0,type:Boolean})],be.prototype,"checked",2);Ue([d({type:Boolean})],be.prototype,"disabled",2);Ue([d({type:String})],be.prototype,"label",2);Ue([d({type:String})],be.prototype,"name",2);Ue([d({type:String})],be.prototype,"value",2);be=Ue([w("blox-switch")],be);var On=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --font-family: sofia-pro, sans-serif;
  --font-size: 14px;
  --font-weight: 700;
  display: inline-flex;
  flex-shrink: 0;
  font-family: var(--blox-font-family);
  margin: 0;
}

.component-container {
  background-color: white;
  border: 1px solid var(--blox-slate1c);
  border-bottom: 1px solid white;
  border-radius: var(--blox-border-radius) var(--blox-border-radius) 0 0;
  color: var(--blox-slate3);
  flex: 1;
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  padding: 14px 20px;
  position: relative;
}
.component-container:hover[aria-disabled=false] {
  color: var(--blox-purple);
  cursor: pointer;
}
.component-container.selected {
  background-color: var(--blox-purple);
  border: 1px solid var(--blox-purple);
  color: white;
}
.component-container.selected:hover {
  color: white;
}
.component-container:focus[aria-disabled=false], .component-container:focus-visible[aria-disabled=false] {
  border: 2px solid var(--blox-blue);
  outline: none;
  padding: 13px 19px;
}
.component-container:focus[aria-disabled=false] .badge, .component-container:focus-visible[aria-disabled=false] .badge {
  right: -2px;
  top: -1px;
}
.component-container[aria-disabled=true] {
  opacity: 0.5;
}

.label {
  align-items: center;
  display: flex;
  gap: 5px;
  justify-content: center;
}

.badge {
  color: var(--blox-slate5);
  font-family: var(--blox-font-family);
  line-height: var(--blox-line-height);
  font-size: var(--blox-font-size-sm);
  font-weight: var(--blox-font-weight-400);
  background-color: var(--blox-purple);
  border: 1px solid white;
  border-radius: 12px;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.1);
  color: white;
  line-height: normal;
  padding: 2px 10px 4px;
  position: absolute;
  right: -1px;
  top: 0;
  transform: translate(0, -50%);
}
.badge.selected {
  background-color: white;
  border: 1px solid var(--blox-slate1c);
  color: var(--blox-slate3);
}`;var ar=Object.defineProperty,sr=Object.getOwnPropertyDescriptor,qe=(t,e,o,n)=>{for(var i=n>1?void 0:n?sr(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&ar(e,o,i),i},pe=class extends m{constructor(){super(...arguments);this.badge=null,this.disabled=!1,this.name="",this.selected=!1,this.slot="tab",this.tabRef=A()}willUpdate(t){t.has("badge")&&this.badge!==null&&this.badge!==void 0&&isNaN(this.badge)&&console.error("<blox-tab> 'badge' property type must be an integer."),t.has("name")&&this.name.length===0&&console.error("<blox-tab> 'name' property is required."),t.has("slot")&&this.slot!=="tab"&&console.error("<blox-tab> 'slot' property value must be 'tab'.")}handleSlotChange(){Array.from(this.children).forEach(t=>{t.nodeName.toLowerCase()!=="blox-tooltip"&&console.error("<blox-tab> can only accept plain text and/or a <blox-tooltip> element.")})}emitSelectEvent(){let t=new CustomEvent("select",{detail:this,bubbles:!0});this.dispatchEvent(t)}handleClick(){this.disabled||this.emitSelectEvent()}handleKeydown(t){!this.disabled&&(t.key===" "||t.key==="Enter")&&this.emitSelectEvent()}focus(){this.tabRef.value.focus()}setTabbable(t){var e,o;(o=(e=this.shadowRoot)==null?void 0:e.querySelector(".component-container"))==null||o.setAttribute("tabindex",`${t?"0":"-1"}`)}formatBadge(t){let e,o=Math.abs(t);return o>=1e3?e=o>99e3?"99K+":`${Math.floor(o/1e3)}K${o%1e3!=0?"+":""}`:e=o,`${t<0?"-":""}${e}`}render(){return c`
            <div
                ${P(this.tabRef)}
                aria-disabled=${this.disabled}
                aria-selected=${!!this.selected}
                class=${S({"component-container":!0,selected:this.selected})}
                @click=${this.handleClick}
                @keydown=${this.handleKeydown}
                role='tab'
                tabindex=${this.selected&&!this.disabled?"0":"-1"}
            >
                <span class='label'>
                    <slot @slotchange=${this.handleSlotChange}></slot>
                </span>
                ${this.badge||this.badge===0?c`
                    <span
                        aria-label=${`badge count: ${this.badge}`}
                        class=${S({badge:!0,selected:this.selected})}
                    >${this.formatBadge(this.badge)}</span>
                `:null}
            </div>
        `}};pe.styles=[On];qe([d({type:Number})],pe.prototype,"badge",2);qe([d({type:Boolean})],pe.prototype,"disabled",2);qe([d({type:String})],pe.prototype,"name",2);qe([d({reflect:!0,type:Boolean})],pe.prototype,"selected",2);qe([d({reflect:!0,type:String})],pe.prototype,"slot",2);pe=qe([w("blox-tab")],pe);var $n=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  display: block;
  font-family: var(--blox-font-family);
}

:host([panel-height=stretch]) {
  height: 100%;
}

.tabs {
  border-bottom: 3px solid var(--blox-purple);
  display: flex;
  gap: 5px;
  overflow: auto;
  padding: 22px 0 0;
}

.tab-group-container.stretch {
  display: grid;
  grid-template-rows: -webkit-min-content auto;
  grid-template-rows: min-content auto;
  height: 100%;
  overflow: hidden;
}
.tab-group-container.stretch .panels {
  overflow: auto;
}`;var dr=Object.defineProperty,br=Object.getOwnPropertyDescriptor,St=(t,e,o,n)=>{for(var i=n>1?void 0:n?br(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&dr(e,o,i),i},Ce=class extends m{constructor(){super();this.ariaLabel="Tabs",this.selected="",this.panelHeight="auto",this.handleTabSelect=t=>{this.selected=t.target.getAttribute("name")},this.handleKeyup=t=>{let e=t.target,o=t.key==="ArrowLeft"?e.previousElementSibling:e.nextElementSibling;if(!(e.nodeName.toLowerCase()!=="blox-tab"||(o==null?void 0:o.nodeName.toLowerCase())!=="blox-tab")){for(;o&&o.hasAttribute("disabled");)t.key==="ArrowLeft"?o=o.previousElementSibling:o=o.nextElementSibling;(t.key==="ArrowLeft"||t.key==="ArrowRight")&&o.focus()}},this.addEventListener("keyup",this.handleKeyup),this.addEventListener("select",this.handleTabSelect)}connectedCallback(){super.connectedCallback(),this.selectTab(!1)}willUpdate(t){var e;(t.get("selected")||t.get("selected")==="")&&this.selectTab(!0),this.selected&&((e=this.querySelector("blox-tab:first-child"))==null||e.setTabbable(!1))}handleSlotChange(){Array.from(this.children).forEach((t,e)=>{let o=t.nodeName.toLowerCase();o!=="blox-tab"&&o!=="blox-tab-panel"&&console.warn("<blox-tab-group> children can only be <blox-tab> and <blox-tab-panel> elements.");let n=t.getAttribute("name");o==="blox-tab"&&!this.querySelector(`blox-tab-panel[name='${n}']`)&&console.warn(`<blox-tab name='${n}'> is missing it's matching <blox-tab-panel name='${n}'>`),o==="blox-tab-panel"&&this.panelHeight!=="auto"&&t.setAttribute("panelHeight",this.panelHeight),e===0&&!this.selected&&t.setTabbable(!0)}),this.selectTab(!1)}emitSelectEvent(){let t=new CustomEvent("tab-select",{detail:this.querySelector(`blox-tab[name='${this.selected}']`),bubbles:!0});this.dispatchEvent(t)}selectTab(t){var e,o;this.querySelectorAll("blox-tab, blox-tab-panel").forEach(n=>{n.removeAttribute("selected")}),(e=this.querySelector(`blox-tab[name='${this.selected}']`))==null||e.setAttribute("selected",""),(o=this.querySelector(`blox-tab-panel[name='${this.selected}']`))==null||o.setAttribute("selected",""),t&&this.selected&&this.emitSelectEvent()}render(){return c`
            <div class=${S({"tab-group-container":!0,stretch:this.panelHeight==="stretch"})}>
                <div aria-label=${this.ariaLabel}
                    class=${S({tabs:!0,stretch:this.panelHeight==="stretch"})}
                    role='tablist'>
                    <slot name='tab' @slotchange=${this.handleSlotChange}></slot>
                </div>
                <div class='panels'>
                    <slot @slotchange=${this.handleSlotChange}></slot>
                </div>
            </div>
        `}};Ce.styles=[$n];St([d({attribute:"aria-label",type:String})],Ce.prototype,"ariaLabel",2);St([d({reflect:!0,type:String})],Ce.prototype,"selected",2);St([d({attribute:"panel-height",type:String})],Ce.prototype,"panelHeight",2);Ce=St([w("blox-tab-group")],Ce);var jn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  font-family: var(--blox-font-family);
  margin: 0;
  padding: 0;
  width: 100%;
}

.stretch {
  height: 100%;
}

:host(:not([selected])) {
  display: none;
}`;var pr=Object.defineProperty,cr=Object.getOwnPropertyDescriptor,zt=(t,e,o,n)=>{for(var i=n>1?void 0:n?cr(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&pr(e,o,i),i},Oe=class extends m{constructor(){super(...arguments);this.name="",this.selected=!1,this.panelHeight="auto"}willUpdate(t){t.has("name")&&(this.name||console.error("<blox-tab-panel> 'name' property is required."))}render(){return c`
            <div
                aria-hidden=${!this.selected}
                role='tabpanel'
                tabindex=${this.selected?"0":"-1"}
                class=${S({stretch:this.panelHeight==="stretch"})}
            >
                ${this.selected?c`<slot></slot>`:null}
            </div>
        `}};Oe.styles=[jn];zt([d({type:String})],Oe.prototype,"name",2);zt([d({reflect:!0,type:Boolean})],Oe.prototype,"selected",2);zt([d({type:String})],Oe.prototype,"panelHeight",2);Oe=zt([w("blox-tab-panel")],Oe);var q="top",X="bottom",Y="right",W="left",Yt="auto",it=[q,X,Y,W],We="start",Gt="end",ur="clippingParents",Tn="viewport",rt="popper",hr="reference",_n=it.reduce(function(t,e){return t.concat([e+"-"+We,e+"-"+Gt])},[]),An=[].concat(it,[Yt]).reduce(function(t,e){return t.concat([e,e+"-"+We,e+"-"+Gt])},[]),fr="beforeRead",xr="read",vr="afterRead",mr="beforeMain",yr="main",gr="afterMain",wr="beforeWrite",kr="write",Sr="afterWrite",zr=[fr,xr,vr,mr,yr,gr,wr,kr,Sr];function ne(t){return t?(t.nodeName||"").toLowerCase():null}function G(t){if(t==null)return window;if(t.toString()!=="[object Window]"){var e=t.ownerDocument;return e&&e.defaultView||window}return t}function lt(t){var e=G(t).Element;return t instanceof e||t instanceof Element}function J(t){var e=G(t).HTMLElement;return t instanceof e||t instanceof HTMLElement}function Pn(t){if(typeof ShadowRoot=="undefined")return!1;var e=G(t).ShadowRoot;return t instanceof e||t instanceof ShadowRoot}function Er(t){var e=t.state;Object.keys(e.elements).forEach(function(o){var n=e.styles[o]||{},i=e.attributes[o]||{},r=e.elements[o];!J(r)||!ne(r)||(Object.assign(r.style,n),Object.keys(i).forEach(function(l){var a=i[l];a===!1?r.removeAttribute(l):r.setAttribute(l,a===!0?"":a)}))})}function Cr(t){var e=t.state,o={popper:{position:e.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(e.elements.popper.style,o.popper),e.styles=o,e.elements.arrow&&Object.assign(e.elements.arrow.style,o.arrow),function(){Object.keys(e.elements).forEach(function(n){var i=e.elements[n],r=e.attributes[n]||{},l=Object.keys(e.styles.hasOwnProperty(n)?e.styles[n]:o[n]),a=l.reduce(function(s,b){return s[b]="",s},{});!J(i)||!ne(i)||(Object.assign(i.style,a),Object.keys(r).forEach(function(s){i.removeAttribute(s)}))})}}var Or={name:"applyStyles",enabled:!0,phase:"write",fn:Er,effect:Cr,requires:["computeStyles"]};function ie(t){return t.split("-")[0]}function Ke(t){var e=t.getBoundingClientRect();return{width:e.width,height:e.height,top:e.top,right:e.right,bottom:e.bottom,left:e.left,x:e.left,y:e.top}}function Jt(t){var e=Ke(t),o=t.offsetWidth,n=t.offsetHeight;return Math.abs(e.width-o)<=1&&(o=e.width),Math.abs(e.height-n)<=1&&(n=e.height),{x:t.offsetLeft,y:t.offsetTop,width:o,height:n}}function Ln(t,e){var o=e.getRootNode&&e.getRootNode();if(t.contains(e))return!0;if(o&&Pn(o)){var n=e;do{if(n&&t.isSameNode(n))return!0;n=n.parentNode||n.host}while(n)}return!1}function ce(t){return G(t).getComputedStyle(t)}function $r(t){return["table","td","th"].indexOf(ne(t))>=0}function ve(t){return((lt(t)?t.ownerDocument:t.document)||window.document).documentElement}function Et(t){return ne(t)==="html"?t:t.assignedSlot||t.parentNode||(Pn(t)?t.host:null)||ve(t)}function Rn(t){return!J(t)||ce(t).position==="fixed"?null:t.offsetParent}function jr(t){var e=navigator.userAgent.toLowerCase().indexOf("firefox")!==-1,o=navigator.userAgent.indexOf("Trident")!==-1;if(o&&J(t)){var n=ce(t);if(n.position==="fixed")return null}for(var i=Et(t);J(i)&&["html","body"].indexOf(ne(i))<0;){var r=ce(i);if(r.transform!=="none"||r.perspective!=="none"||r.contain==="paint"||["transform","perspective"].indexOf(r.willChange)!==-1||e&&r.willChange==="filter"||e&&r.filter&&r.filter!=="none")return i;i=i.parentNode}return null}function at(t){for(var e=G(t),o=Rn(t);o&&$r(o)&&ce(o).position==="static";)o=Rn(o);return o&&(ne(o)==="html"||ne(o)==="body"&&ce(o).position==="static")?e:o||jr(t)||e}function Zt(t){return["top","bottom"].indexOf(t)>=0?"x":"y"}var me=Math.max,st=Math.min,Ct=Math.round;function Ot(t,e,o){return me(t,st(e,o))}function Dn(){return{top:0,right:0,bottom:0,left:0}}function Mn(t){return Object.assign({},Dn(),t)}function Bn(t,e){return e.reduce(function(o,n){return o[n]=t,o},{})}var Tr=function(e,o){return e=typeof e=="function"?e(Object.assign({},o.rects,{placement:o.placement})):e,Mn(typeof e!="number"?e:Bn(e,it))};function _r(t){var e,o=t.state,n=t.name,i=t.options,r=o.elements.arrow,l=o.modifiersData.popperOffsets,a=ie(o.placement),s=Zt(a),b=[W,Y].indexOf(a)>=0,p=b?"height":"width";if(!(!r||!l)){var u=Tr(i.padding,o),h=Jt(r),f=s==="y"?q:W,y=s==="y"?X:Y,z=o.rects.reference[p]+o.rects.reference[s]-l[s]-o.rects.popper[p],k=l[s]-o.rects.reference[s],$=at(r),O=$?s==="y"?$.clientHeight||0:$.clientWidth||0:0,L=z/2-k/2,x=u[f],_=O-h[p]-u[y],v=O/2-h[p]/2+L,E=Ot(x,v,_),C=s;o.modifiersData[n]=(e={},e[C]=E,e.centerOffset=E-v,e)}}function Ar(t){var e=t.state,o=t.options,n=o.element,i=n===void 0?"[data-popper-arrow]":n;i!=null&&(typeof i=="string"&&(i=e.elements.popper.querySelector(i),!i)||!Ln(e.elements.popper,i)||(e.elements.arrow=i))}var Pr={name:"arrow",enabled:!0,phase:"main",fn:_r,effect:Ar,requires:["popperOffsets"],requiresIfExists:["preventOverflow"]},Lr={top:"auto",right:"auto",bottom:"auto",left:"auto"};function Rr(t){var e=t.x,o=t.y,n=window,i=n.devicePixelRatio||1;return{x:Ct(Ct(e*i)/i)||0,y:Ct(Ct(o*i)/i)||0}}function Hn(t){var e,o=t.popper,n=t.popperRect,i=t.placement,r=t.offsets,l=t.position,a=t.gpuAcceleration,s=t.adaptive,b=t.roundOffsets,p=b===!0?Rr(r):typeof b=="function"?b(r):r,u=p.x,h=u===void 0?0:u,f=p.y,y=f===void 0?0:f,z=r.hasOwnProperty("x"),k=r.hasOwnProperty("y"),$=W,O=q,L=window;if(s){var x=at(o),_="clientHeight",v="clientWidth";x===G(o)&&(x=ve(o),ce(x).position!=="static"&&(_="scrollHeight",v="scrollWidth")),x=x,i===q&&(O=X,y-=x[_]-n.height,y*=a?1:-1),i===W&&($=Y,h-=x[v]-n.width,h*=a?1:-1)}var E=Object.assign({position:l},s&&Lr);if(a){var C;return Object.assign({},E,(C={},C[O]=k?"0":"",C[$]=z?"0":"",C.transform=(L.devicePixelRatio||1)<2?"translate("+h+"px, "+y+"px)":"translate3d("+h+"px, "+y+"px, 0)",C))}return Object.assign({},E,(e={},e[O]=k?y+"px":"",e[$]=z?h+"px":"",e.transform="",e))}function Dr(t){var e=t.state,o=t.options,n=o.gpuAcceleration,i=n===void 0?!0:n,r=o.adaptive,l=r===void 0?!0:r,a=o.roundOffsets,s=a===void 0?!0:a,b={placement:ie(e.placement),popper:e.elements.popper,popperRect:e.rects.popper,gpuAcceleration:i};e.modifiersData.popperOffsets!=null&&(e.styles.popper=Object.assign({},e.styles.popper,Hn(Object.assign({},b,{offsets:e.modifiersData.popperOffsets,position:e.options.strategy,adaptive:l,roundOffsets:s})))),e.modifiersData.arrow!=null&&(e.styles.arrow=Object.assign({},e.styles.arrow,Hn(Object.assign({},b,{offsets:e.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:s})))),e.attributes.popper=Object.assign({},e.attributes.popper,{"data-popper-placement":e.placement})}var Mr={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:Dr,data:{}},$t={passive:!0};function Br(t){var e=t.state,o=t.instance,n=t.options,i=n.scroll,r=i===void 0?!0:i,l=n.resize,a=l===void 0?!0:l,s=G(e.elements.popper),b=[].concat(e.scrollParents.reference,e.scrollParents.popper);return r&&b.forEach(function(p){p.addEventListener("scroll",o.update,$t)}),a&&s.addEventListener("resize",o.update,$t),function(){r&&b.forEach(function(p){p.removeEventListener("scroll",o.update,$t)}),a&&s.removeEventListener("resize",o.update,$t)}}var Hr={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:Br,data:{}},Vr={left:"right",right:"left",bottom:"top",top:"bottom"};function jt(t){return t.replace(/left|right|bottom|top/g,function(e){return Vr[e]})}var Nr={start:"end",end:"start"};function Vn(t){return t.replace(/start|end/g,function(e){return Nr[e]})}function eo(t){var e=G(t),o=e.pageXOffset,n=e.pageYOffset;return{scrollLeft:o,scrollTop:n}}function to(t){return Ke(ve(t)).left+eo(t).scrollLeft}function Ir(t){var e=G(t),o=ve(t),n=e.visualViewport,i=o.clientWidth,r=o.clientHeight,l=0,a=0;return n&&(i=n.width,r=n.height,/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||(l=n.offsetLeft,a=n.offsetTop)),{width:i,height:r,x:l+to(t),y:a}}function Fr(t){var e,o=ve(t),n=eo(t),i=(e=t.ownerDocument)==null?void 0:e.body,r=me(o.scrollWidth,o.clientWidth,i?i.scrollWidth:0,i?i.clientWidth:0),l=me(o.scrollHeight,o.clientHeight,i?i.scrollHeight:0,i?i.clientHeight:0),a=-n.scrollLeft+to(t),s=-n.scrollTop;return ce(i||o).direction==="rtl"&&(a+=me(o.clientWidth,i?i.clientWidth:0)-r),{width:r,height:l,x:a,y:s}}function oo(t){var e=ce(t),o=e.overflow,n=e.overflowX,i=e.overflowY;return/auto|scroll|overlay|hidden/.test(o+i+n)}function Nn(t){return["html","body","#document"].indexOf(ne(t))>=0?t.ownerDocument.body:J(t)&&oo(t)?t:Nn(Et(t))}function dt(t,e){var o;e===void 0&&(e=[]);var n=Nn(t),i=n===((o=t.ownerDocument)==null?void 0:o.body),r=G(n),l=i?[r].concat(r.visualViewport||[],oo(n)?n:[]):n,a=e.concat(l);return i?a:a.concat(dt(Et(l)))}function no(t){return Object.assign({},t,{left:t.x,top:t.y,right:t.x+t.width,bottom:t.y+t.height})}function Ur(t){var e=Ke(t);return e.top=e.top+t.clientTop,e.left=e.left+t.clientLeft,e.bottom=e.top+t.clientHeight,e.right=e.left+t.clientWidth,e.width=t.clientWidth,e.height=t.clientHeight,e.x=e.left,e.y=e.top,e}function In(t,e){return e===Tn?no(Ir(t)):J(e)?Ur(e):no(Fr(ve(t)))}function qr(t){var e=dt(Et(t)),o=["absolute","fixed"].indexOf(ce(t).position)>=0,n=o&&J(t)?at(t):t;return lt(n)?e.filter(function(i){return lt(i)&&Ln(i,n)&&ne(i)!=="body"}):[]}function Wr(t,e,o){var n=e==="clippingParents"?qr(t):[].concat(e),i=[].concat(n,[o]),r=i[0],l=i.reduce(function(a,s){var b=In(t,s);return a.top=me(b.top,a.top),a.right=st(b.right,a.right),a.bottom=st(b.bottom,a.bottom),a.left=me(b.left,a.left),a},In(t,r));return l.width=l.right-l.left,l.height=l.bottom-l.top,l.x=l.left,l.y=l.top,l}function bt(t){return t.split("-")[1]}function Fn(t){var e=t.reference,o=t.element,n=t.placement,i=n?ie(n):null,r=n?bt(n):null,l=e.x+e.width/2-o.width/2,a=e.y+e.height/2-o.height/2,s;switch(i){case q:s={x:l,y:e.y-o.height};break;case X:s={x:l,y:e.y+e.height};break;case Y:s={x:e.x+e.width,y:a};break;case W:s={x:e.x-o.width,y:a};break;default:s={x:e.x,y:e.y}}var b=i?Zt(i):null;if(b!=null){var p=b==="y"?"height":"width";switch(r){case We:s[b]=s[b]-(e[p]/2-o[p]/2);break;case Gt:s[b]=s[b]+(e[p]/2-o[p]/2);break}}return s}function pt(t,e){e===void 0&&(e={});var o=e,n=o.placement,i=n===void 0?t.placement:n,r=o.boundary,l=r===void 0?ur:r,a=o.rootBoundary,s=a===void 0?Tn:a,b=o.elementContext,p=b===void 0?rt:b,u=o.altBoundary,h=u===void 0?!1:u,f=o.padding,y=f===void 0?0:f,z=Mn(typeof y!="number"?y:Bn(y,it)),k=p===rt?hr:rt,$=t.elements.reference,O=t.rects.popper,L=t.elements[h?k:p],x=Wr(lt(L)?L:L.contextElement||ve(t.elements.popper),l,s),_=Ke($),v=Fn({reference:_,element:O,strategy:"absolute",placement:i}),E=no(Object.assign({},O,v)),C=p===rt?E:_,M={top:x.top-C.top+z.top,bottom:C.bottom-x.bottom+z.bottom,left:x.left-C.left+z.left,right:C.right-x.right+z.right},V=t.modifiersData.offset;if(p===rt&&V){var Z=V[i];Object.keys(M).forEach(function(le){var H=[Y,X].indexOf(le)>=0?1:-1,ye=[q,X].indexOf(le)>=0?"y":"x";M[le]+=Z[ye]*H})}return M}function Kr(t,e){e===void 0&&(e={});var o=e,n=o.placement,i=o.boundary,r=o.rootBoundary,l=o.padding,a=o.flipVariations,s=o.allowedAutoPlacements,b=s===void 0?An:s,p=bt(n),u=p?a?_n:_n.filter(function(y){return bt(y)===p}):it,h=u.filter(function(y){return b.indexOf(y)>=0});h.length===0&&(h=u);var f=h.reduce(function(y,z){return y[z]=pt(t,{placement:z,boundary:i,rootBoundary:r,padding:l})[ie(z)],y},{});return Object.keys(f).sort(function(y,z){return f[y]-f[z]})}function Qr(t){if(ie(t)===Yt)return[];var e=jt(t);return[Vn(t),e,Vn(e)]}function Xr(t){var e=t.state,o=t.options,n=t.name;if(!e.modifiersData[n]._skip){for(var i=o.mainAxis,r=i===void 0?!0:i,l=o.altAxis,a=l===void 0?!0:l,s=o.fallbackPlacements,b=o.padding,p=o.boundary,u=o.rootBoundary,h=o.altBoundary,f=o.flipVariations,y=f===void 0?!0:f,z=o.allowedAutoPlacements,k=e.options.placement,$=ie(k),O=$===k,L=s||(O||!y?[jt(k)]:Qr(k)),x=[k].concat(L).reduce(function(we,ee){return we.concat(ie(ee)===Yt?Kr(e,{placement:ee,boundary:p,rootBoundary:u,padding:b,flipVariations:y,allowedAutoPlacements:z}):ee)},[]),_=e.rects.reference,v=e.rects.popper,E=new Map,C=!0,M=x[0],V=0;V<x.length;V++){var Z=x[V],le=ie(Z),H=bt(Z)===We,ye=[q,X].indexOf(le)>=0,Qe=ye?"width":"height",$e=pt(e,{placement:Z,boundary:p,rootBoundary:u,altBoundary:h,padding:b}),ge=ye?H?Y:W:H?X:q;_[Qe]>v[Qe]&&(ge=jt(ge));var Tt=jt(ge),je=[];if(r&&je.push($e[le]<=0),a&&je.push($e[ge]<=0,$e[Tt]<=0),je.every(function(we){return we})){M=Z,C=!1;break}E.set(Z,je)}if(C)for(var ct=y?3:1,_t=function(ee){var ht=x.find(function(At){var _e=E.get(At);if(_e)return _e.slice(0,ee).every(function(Pt){return Pt})});if(ht)return M=ht,"break"},Te=ct;Te>0;Te--){var ut=_t(Te);if(ut==="break")break}e.placement!==M&&(e.modifiersData[n]._skip=!0,e.placement=M,e.reset=!0)}}var Yr={name:"flip",enabled:!0,phase:"main",fn:Xr,requiresIfExists:["offset"],data:{_skip:!1}};function Un(t,e,o){return o===void 0&&(o={x:0,y:0}),{top:t.top-e.height-o.y,right:t.right-e.width+o.x,bottom:t.bottom-e.height+o.y,left:t.left-e.width-o.x}}function qn(t){return[q,Y,X,W].some(function(e){return t[e]>=0})}function Gr(t){var e=t.state,o=t.name,n=e.rects.reference,i=e.rects.popper,r=e.modifiersData.preventOverflow,l=pt(e,{elementContext:"reference"}),a=pt(e,{altBoundary:!0}),s=Un(l,n),b=Un(a,i,r),p=qn(s),u=qn(b);e.modifiersData[o]={referenceClippingOffsets:s,popperEscapeOffsets:b,isReferenceHidden:p,hasPopperEscaped:u},e.attributes.popper=Object.assign({},e.attributes.popper,{"data-popper-reference-hidden":p,"data-popper-escaped":u})}var Jr={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:Gr};function Zr(t,e,o){var n=ie(t),i=[W,q].indexOf(n)>=0?-1:1,r=typeof o=="function"?o(Object.assign({},e,{placement:t})):o,l=r[0],a=r[1];return l=l||0,a=(a||0)*i,[W,Y].indexOf(n)>=0?{x:a,y:l}:{x:l,y:a}}function el(t){var e=t.state,o=t.options,n=t.name,i=o.offset,r=i===void 0?[0,0]:i,l=An.reduce(function(p,u){return p[u]=Zr(u,e.rects,r),p},{}),a=l[e.placement],s=a.x,b=a.y;e.modifiersData.popperOffsets!=null&&(e.modifiersData.popperOffsets.x+=s,e.modifiersData.popperOffsets.y+=b),e.modifiersData[n]=l}var tl={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:el};function ol(t){var e=t.state,o=t.name;e.modifiersData[o]=Fn({reference:e.rects.reference,element:e.rects.popper,strategy:"absolute",placement:e.placement})}var nl={name:"popperOffsets",enabled:!0,phase:"read",fn:ol,data:{}};function il(t){return t==="x"?"y":"x"}function rl(t){var e=t.state,o=t.options,n=t.name,i=o.mainAxis,r=i===void 0?!0:i,l=o.altAxis,a=l===void 0?!1:l,s=o.boundary,b=o.rootBoundary,p=o.altBoundary,u=o.padding,h=o.tether,f=h===void 0?!0:h,y=o.tetherOffset,z=y===void 0?0:y,k=pt(e,{boundary:s,rootBoundary:b,padding:u,altBoundary:p}),$=ie(e.placement),O=bt(e.placement),L=!O,x=Zt($),_=il(x),v=e.modifiersData.popperOffsets,E=e.rects.reference,C=e.rects.popper,M=typeof z=="function"?z(Object.assign({},e.rects,{placement:e.placement})):z,V={x:0,y:0};if(!!v){if(r||a){var Z=x==="y"?q:W,le=x==="y"?X:Y,H=x==="y"?"height":"width",ye=v[x],Qe=v[x]+k[Z],$e=v[x]-k[le],ge=f?-C[H]/2:0,Tt=O===We?E[H]:C[H],je=O===We?-C[H]:-E[H],ct=e.elements.arrow,_t=f&&ct?Jt(ct):{width:0,height:0},Te=e.modifiersData["arrow#persistent"]?e.modifiersData["arrow#persistent"].padding:Dn(),ut=Te[Z],we=Te[le],ee=Ot(0,E[H],_t[H]),ht=L?E[H]/2-ge-ee-ut-M:Tt-ee-ut-M,At=L?-E[H]/2+ge+ee+we+M:je+ee+we+M,_e=e.elements.arrow&&at(e.elements.arrow),Pt=_e?x==="y"?_e.clientTop||0:_e.clientLeft||0:0,io=e.modifiersData.offset?e.modifiersData.offset[e.placement][x]:0,ro=v[x]+ht-io-Pt,lo=v[x]+At-io;if(r){var ao=Ot(f?st(Qe,ro):Qe,ye,f?me($e,lo):$e);v[x]=ao,V[x]=ao-ye}if(a){var Yn=x==="x"?q:W,Gn=x==="x"?X:Y,ft=v[_],so=ft+k[Yn],bo=ft-k[Gn],po=Ot(f?st(so,ro):so,ft,f?me(bo,lo):bo);v[_]=po,V[_]=po-ft}}e.modifiersData[n]=V}}var ll={name:"preventOverflow",enabled:!0,phase:"main",fn:rl,requiresIfExists:["offset"]};function al(t){return{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}}function sl(t){return t===G(t)||!J(t)?eo(t):al(t)}function dl(t,e,o){o===void 0&&(o=!1);var n=ve(e),i=Ke(t),r=J(e),l={scrollLeft:0,scrollTop:0},a={x:0,y:0};return(r||!r&&!o)&&((ne(e)!=="body"||oo(n))&&(l=sl(e)),J(e)?(a=Ke(e),a.x+=e.clientLeft,a.y+=e.clientTop):n&&(a.x=to(n))),{x:i.left+l.scrollLeft-a.x,y:i.top+l.scrollTop-a.y,width:i.width,height:i.height}}function bl(t){var e=new Map,o=new Set,n=[];t.forEach(function(r){e.set(r.name,r)});function i(r){o.add(r.name);var l=[].concat(r.requires||[],r.requiresIfExists||[]);l.forEach(function(a){if(!o.has(a)){var s=e.get(a);s&&i(s)}}),n.push(r)}return t.forEach(function(r){o.has(r.name)||i(r)}),n}function pl(t){var e=bl(t);return zr.reduce(function(o,n){return o.concat(e.filter(function(i){return i.phase===n}))},[])}function cl(t){var e;return function(){return e||(e=new Promise(function(o){Promise.resolve().then(function(){e=void 0,o(t())})})),e}}function ul(t){var e=t.reduce(function(o,n){var i=o[n.name];return o[n.name]=i?Object.assign({},i,n,{options:Object.assign({},i.options,n.options),data:Object.assign({},i.data,n.data)}):n,o},{});return Object.keys(e).map(function(o){return e[o]})}var Wn={placement:"bottom",modifiers:[],strategy:"absolute"};function Kn(){for(var t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return!e.some(function(n){return!(n&&typeof n.getBoundingClientRect=="function")})}function hl(t){t===void 0&&(t={});var e=t,o=e.defaultModifiers,n=o===void 0?[]:o,i=e.defaultOptions,r=i===void 0?Wn:i;return function(a,s,b){b===void 0&&(b=r);var p={placement:"bottom",orderedModifiers:[],options:Object.assign({},Wn,r),modifiersData:{},elements:{reference:a,popper:s},attributes:{},styles:{}},u=[],h=!1,f={state:p,setOptions:function($){z(),p.options=Object.assign({},r,p.options,$),p.scrollParents={reference:lt(a)?dt(a):a.contextElement?dt(a.contextElement):[],popper:dt(s)};var O=pl(ul([].concat(n,p.options.modifiers)));return p.orderedModifiers=O.filter(function(L){return L.enabled}),y(),f.update()},forceUpdate:function(){if(!h){var $=p.elements,O=$.reference,L=$.popper;if(!!Kn(O,L)){p.rects={reference:dl(O,at(L),p.options.strategy==="fixed"),popper:Jt(L)},p.reset=!1,p.placement=p.options.placement,p.orderedModifiers.forEach(function(V){return p.modifiersData[V.name]=Object.assign({},V.data)});for(var x=0;x<p.orderedModifiers.length;x++){if(p.reset===!0){p.reset=!1,x=-1;continue}var _=p.orderedModifiers[x],v=_.fn,E=_.options,C=E===void 0?{}:E,M=_.name;typeof v=="function"&&(p=v({state:p,options:C,name:M,instance:f})||p)}}}},update:cl(function(){return new Promise(function(k){f.forceUpdate(),k(p)})}),destroy:function(){z(),h=!0}};if(!Kn(a,s))return f;f.setOptions(b).then(function(k){!h&&b.onFirstUpdate&&b.onFirstUpdate(k)});function y(){p.orderedModifiers.forEach(function(k){var $=k.name,O=k.options,L=O===void 0?{}:O,x=k.effect;if(typeof x=="function"){var _=x({state:p,name:$,instance:f,options:L}),v=function(){};u.push(_||v)}})}function z(){u.forEach(function(k){return k()}),u=[]}return f}}var fl=[Hr,nl,Mr,Or,tl,Yr,ll,Pr,Jr],Qn=hl({defaultModifiers:fl});var Xn=g`
/*
Prioritize using the CSS variables whenever possible. However, CSS variables
are not compatible as Sass \`@function\` params, meaning we must keep this map
should we ever need to pass a variable into a Sass function.

Fortunately, CSS vars are compatible with Sass \`@mixins\`!
*/
:host {
  --font-family: var(--blox-font-family, sofia-pro, sans-serif);
  --font-size: 14px;
  --font-weight: 400;
  --arrow-width: 7.07px;
  --tooltip-background: var(--blox-slate5);
  --tooltip-padding: 10px;
  --tooltip-shadow: 0 0 8px 1px rgb(0 0 0 / 10%);
  --tooltip-max-width: 200px;
  --tooltip-width: 100%;
  --tooltip-z-index: auto;
  display: inline-flex;
  font-family: var(--font-family);
  margin: 0;
  padding: 0;
}

#component-container {
  flex: 1;
}

#tooltip {
  display: none;
  z-index: var(--tooltip-z-index);
}

#tooltip[data-show] {
  display: block;
}

#tooltip[data-popper-placement^=top] #tooltip-content {
  margin-bottom: 10px;
}
#tooltip[data-popper-placement^=top] #arrow {
  bottom: 6px;
}

#tooltip[data-popper-placement^=bottom] #tooltip-content {
  margin-top: 10px;
}
#tooltip[data-popper-placement^=bottom] #arrow {
  top: 6px;
}

#tooltip[data-popper-placement^=left] #tooltip-content {
  margin-right: 10px;
}
#tooltip[data-popper-placement^=left] #arrow {
  right: 6px;
}

#tooltip[data-popper-placement^=right] #tooltip-content {
  margin-left: 10px;
}
#tooltip[data-popper-placement^=right] #arrow {
  left: 6px;
}

#tooltip-content {
  background: var(--tooltip-background);
  border-radius: var(--blox-border-radius);
  box-shadow: var(--tooltip-shadow);
  box-sizing: border-box;
  color: white;
  font-family: var(--font-family);
  font-size: var(--font-size);
  padding: var(--tooltip-padding);
  text-align: left;
  text-transform: none;
}
#tooltip-content.text-content {
  max-width: var(--tooltip-max-width);
  width: var(--tooltip-width);
}

#arrow,
#arrow::before {
  background: inherit;
  height: var(--arrow-width);
  position: absolute;
  width: var(--arrow-width);
}

#arrow {
  visibility: hidden;
}

#arrow::before {
  content: "";
  transform: rotate(45deg);
  visibility: visible;
}

#slot-container {
  display: inline-block;
  width: 100%;
}`;var xl=Object.defineProperty,vl=Object.getOwnPropertyDescriptor,re=(t,e,o,n)=>{for(var i=n>1?void 0:n?vl(e,o):e,r=t.length-1,l;r>=0;r--)(l=t[r])&&(i=(n?l(e,o,i):l(i))||i);return n&&i&&xl(e,o,i),i},F=class extends m{constructor(){super(...arguments);this.ariaLabel="",this.content="",this.ignoreMouse=!1,this.offsetX=0,this.offsetY=0,this.placement="top",this.position="absolute",this.isOpen=!1,this.tooltipRef=A(),this.wrappedElement=null,this.handleElementBlur=t=>{var e;t.relatedTarget!==this&&!((e=this.getSlottedTooltipContent())==null?void 0:e.contains(t.relatedTarget))&&this.hideTooltip()},this.handleElementFocus=()=>{this.ignoreMouse||this.showTooltip()},this.handleElementKeydown=t=>{var o,n,i;let e=["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"];if(!!e.includes(t.key)){if(t.preventDefault(),((o=this.content)==null?void 0:o.length)>0)if(this.isOpen){this.hideTooltip();return}else{this.showTooltip();return}if(this.isOpen)if(t.key===e[0]&&this.placement.includes("top")||t.key===e[1]&&this.placement.includes("bottom")||t.key===e[2]&&this.placement.includes("left")||t.key===e[3]&&this.placement.includes("right")){let r=(i=(n=this.getSlottedTooltipContent())==null?void 0:n.children)!=null?i:[];for(let a=0;a<r.length;a++)r[a].removeAttribute("aria-hidden"),r[a].removeAttribute("tabindex");let l=this.tooltipRef.value;l.setAttribute("tabindex","0"),l.focus()}else this.hideTooltip();else this.showTooltip()}},this.handleElementMouseleave=t=>{var e,o;t.relatedTarget!==this&&!((e=this.tooltipRef.value)==null?void 0:e.contains(t.relatedTarget))&&!((o=this.getSlottedTooltipContent())==null?void 0:o.contains(t.relatedTarget))&&!this.ignoreMouse&&this.hideTooltip()},this.handleElementMouseover=()=>{this.ignoreMouse||this.showTooltip()},this.handleTooltipFocusout=t=>{this.contains(t.relatedTarget)||this.hideTooltip()},this.handleTooltipMouseleave=t=>{let e=this.getWrappedElement();t.relatedTarget!==e&&!this.ignoreMouse&&this.hideTooltip()}}handleSlotChange(){if(this.wrappedElement&&(this.wrappedElement.removeEventListener("blur",this.handleElementBlur),this.wrappedElement.removeEventListener("focus",this.handleElementFocus),this.wrappedElement.removeEventListener("keydown",this.handleElementKeydown),this.wrappedElement.removeEventListener("mouseleave",this.handleElementMouseleave),this.wrappedElement.removeEventListener("mouseover",this.handleElementMouseover)),this.wrappedElement=this.getWrappedElement(),!this.wrappedElement)return;this.wrappedElement.removeAttribute("aria-hidden"),this.wrappedElement.removeAttribute("focusable"),this.wrappedElement.setAttribute("tabindex","0"),this.updateAriaAttributes(),this.wrappedElement.addEventListener("blur",this.handleElementBlur),this.wrappedElement.addEventListener("focus",this.handleElementFocus),this.wrappedElement.addEventListener("keydown",this.handleElementKeydown),this.wrappedElement.addEventListener("mouseleave",this.handleElementMouseleave),this.wrappedElement.addEventListener("mouseover",this.handleElementMouseover);let t=this.tooltipRef.value;t.addEventListener("focusout",this.handleTooltipFocusout),t.addEventListener("mouseleave",this.handleTooltipMouseleave),this.popperInstance=Qn(this.wrappedElement,t,{modifiers:this.getModifiers(!1),placement:this.placement,strategy:this.position})}willUpdate(t){var n;!this.querySelector('[slot="content"]')&&!this.content&&console.error('A <blox-tooltip> is missing the content="string" attribute.'),(n=this.popperInstance)==null||n.setOptions({modifiers:this.getModifiers(),placement:this.placement,strategy:this.position});let e=t.get("ariaLabel")===void 0,o=t.get("content")===void 0;(!e||!o)&&this.updateAriaAttributes()}getAriaLabel(){var t,e;return((t=this.ariaLabel)==null?void 0:t.trim())||((e=this.content)==null?void 0:e.trim())||"Tooltip"}getAriaDescription(){let t="Use any arrow key toggle the tooltip display.",e="";if(this.getSlottedTooltipContent()){let o="up";this.placement.includes("bottom")?o="down":this.placement.includes("left")?o="left":this.placement.includes("right")&&(o="right"),e=`Once the tooltip is expanded, use the ${o} key to focus the tooltip content.`}return`${t} ${e}`}getModifiers(t){var o;let e=[{name:"arrow",options:{padding:8}},{name:"offset",options:{offset:[this.offsetX,this.offsetY]}}];return t!==void 0&&e.push({enabled:t,name:"eventListeners"}),this.fallbackPlacements&&e.push({enabled:((o=this.fallbackPlacements)==null?void 0:o.length)>0,name:"flip",options:{fallbackPlacements:this.fallbackPlacements}}),e}getSlottedTooltipContent(){var e;let t=(e=this.shadowRoot)==null?void 0:e.querySelector('slot[name="content"]');return t?t==null?void 0:t.assignedElements()[0]:null}getWrappedElement(){var e;let t=(e=this.shadowRoot)==null?void 0:e.querySelector('slot:not([name="content"])');return t?t==null?void 0:t.assignedElements()[0]:null}hideTooltip(){var t,e,o,n;(t=this.tooltipRef.value)==null||t.setAttribute("aria-hidden","true"),(e=this.tooltipRef.value)==null||e.removeAttribute("data-show"),(o=this.tooltipRef.value)==null||o.removeAttribute("tabindex"),(n=this.popperInstance)==null||n.setOptions({modifiers:this.getModifiers(!1)}),this.isOpen=!1,this.updateAriaAttributes()}showTooltip(){var t,e,o,n,i,r;if((t=this.tooltipRef.value)==null||t.removeAttribute("aria-hidden"),(e=this.tooltipRef.value)==null||e.setAttribute("data-show",""),!this.content){let l=(n=(o=this.getSlottedTooltipContent())==null?void 0:o.children)!=null?n:[];for(let a=0;a<l.length;a++)l[a].setAttribute("aria-hidden","true"),l[a].setAttribute("tabindex","-1")}(i=this.popperInstance)==null||i.setOptions({modifiers:this.getModifiers(!0)}),(r=this.popperInstance)==null||r.update(),this.isOpen=!0,this.updateAriaAttributes()}updateAriaAttributes(){let t=this.getWrappedElement();t==null||t.setAttribute("aria-expanded",`${this.isOpen}`),t==null||t.setAttribute("aria-label",`${this.getAriaLabel()}`),t==null||t.setAttribute("aria-description",`${this.getAriaDescription()}`)}render(){return c`
            <div id='component-container'>
                <div
                    ${P(this.tooltipRef)}
                    id='tooltip'
                    role='tooltip'
                >
                    <div id='tooltip-content' class=${S({"text-content":this.content})}>
                        ${this.content?this.content:c`<slot name='content'></slot>`}
                        <div id='arrow' data-popper-arrow></div>
                    </div>
                </div>
                <div id='slot-container' @mouseleave=${this.handleElementMouseleave}>
                    <slot @slotchange=${this.handleSlotChange}></slot>
                </div>
            </div>
        `}};F.styles=[Xn];re([d({attribute:"aria-label",type:String})],F.prototype,"ariaLabel",2);re([d({type:String})],F.prototype,"content",2);re([d({attribute:"fallback-placements",type:Array})],F.prototype,"fallbackPlacements",2);re([d({attribute:"ignore-mouse",type:Boolean})],F.prototype,"ignoreMouse",2);re([d({attribute:"offset-x",type:Number})],F.prototype,"offsetX",2);re([d({attribute:"offset-y",type:Number})],F.prototype,"offsetY",2);re([d({type:String})],F.prototype,"placement",2);re([d({type:String})],F.prototype,"position",2);re([Me()],F.prototype,"isOpen",2);F=re([w("blox-tooltip")],F);export{N as BloxAlert,ae as BloxBreadcrumb,et as BloxBreadcrumbItem,Ne as BloxConnectSocialButton,Q as BloxDialog,se as BloxDialogAction,Ee as BloxInputGroup,xe as BloxSample,I as BloxSearch,T as BloxSelect,U as BloxSingleValue,nt as BloxStatus,be as BloxSwitch,pe as BloxTab,Ce as BloxTabGroup,Oe as BloxTabPanel,F as BloxTooltip};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
//# sourceMappingURL=blox-all.js.map
